var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoralCover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 248.80314 172.10011",
    height: 172.10011,
    width: 248.80315,
    id: "svg2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,-340.63248,272.57628)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.1)",
    id: "g12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3786",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3098.56,1819.79 -0.04,-0.01 0.04,0.01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3788",
    style: {
      fill: "#f03747",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2763.68,1322.57 c 71.7,0 143.4,-81.94 194.61,-10.24 22.32,29.75 6.79,54.08 -15.15,73.04 l 2.4,1.35 c -4.08,3.03 -8.18,7.03 -11.05,9.29 -2.05,1.61 -3.42,3.51 -4.5,5.51 22.93,-3.32 44.2,5.9 55.06,32.02 26.04,-12.77 44.39,-46.51 30.21,-74.25 -7.13,-13.91 -20.16,-22.64 -33.45,-29.93 -1.04,-0.57 -2.04,-1.18 -3.04,-1.79 22.6,-9.68 33.35,-29.57 47.4,-48.46 6.07,-0.59 11.72,-1.38 17.28,-2.71 6.09,4.8 12.13,7.45 20.25,6.5 7.91,-0.92 14.83,-5.04 19.02,-11.99 3.52,-5.83 4.79,-12.59 4.44,-19.53 9.62,-7.7 19.15,-15.69 28.52,-23.9 0.89,0.99 1.61,2.03 2.57,3.01 2.01,2.08 6.29,5.04 11.51,8.41 1.32,12.01 9.83,23.95 20.24,29.44 -5.08,2.53 -9.93,5.56 -14.36,8.96 -24.72,-3.84 -43.4,16.5 -50.62,43.3 -2.05,7.62 4.88,15.6 12.87,13.31 4.03,-1.15 23.75,-11.15 25.47,-9.66 1.87,1.63 3.95,2.94 6.11,4.08 -4.73,10.81 -4.46,22.09 1.92,32.94 -13.33,5.44 -25.44,13.99 -34.43,24.87 -6.56,7.93 -11.21,17.35 -14.03,27.32 6.07,-2.77 12.25,-5.69 18.77,-8.94 20.48,-10.25 20.48,-61.46 61.45,-51.21 30.74,0 -20.49,71.69 30.74,81.94 10.23,0 30.72,-20.49 30.72,-30.73 0,-38.4 -9,-94.79 40.47,-101.72 -2.48,-5.74 -4.94,-11.51 -7.51,-17.23 0.59,-1.36 1.31,-2.6 1.81,-4.06 2.23,-6.42 4.47,-13.06 6.66,-19.76 6.79,2.35 13.64,4.43 20.53,6.3 5.61,10.64 18.27,17.9 31.25,15.09 5.71,-1.24 12.39,-3.89 19.32,-6.73 5.46,0.27 10.94,0.34 16.48,0.17 8.53,12.56 18.23,16.82 32.76,19.84 13.66,2.84 26.89,3.2 38.53,-0.92 l -0.88,0.65 c 6.69,-2.13 13.61,-4.17 20.58,-5.78 1.48,0.11 5.09,0.11 9.03,0.35 0.08,0.85 0.21,2.07 0.4,4.1 1.63,16.9 2.79,32.72 10.43,48.16 1.05,2.11 2.17,4.05 3.34,5.89 10.35,-5.76 21.03,-9.92 33.36,-5.81 -20.49,-20.49 -20.49,-51.22 0,-61.46 24.45,-8.15 29.47,35.49 40.82,43.36 l 2.21,0.61 0.73,0.54 c 2.19,0.24 4.61,-0.7 7.45,-3.54 25.75,-25.75 31.26,-59.6 26.72,-93.91 -7.82,6.34 -13.77,14.3 -17.65,23.28 -14.95,-8.75 -32.07,-17.18 -49.91,-23.84 -9.55,-6.52 -18.94,-12.95 -28.37,-17.41 -26.58,-12.58 -53.34,-15.05 -82.01,-13.33 -8.75,-7.22 -19.33,-10.72 -31.97,-10.56 -8.21,0.11 -16.03,1.8 -23.46,4.6 0.47,-2.83 0.77,-5.68 0.78,-8.53 0.03,-5.86 -0.9,-11.54 -2.62,-16.84 6.99,-1.19 13.7,-2.82 19.65,-5.54 16.29,-7.43 26.94,-21.55 37.88,-35.14 2.32,-2.86 11.31,-14.07 16.26,-22.33 2.58,2.65 5.12,5.33 7.8,7.88 l 1.45,1.35 c -0.32,14.8 4.53,30.34 12.32,41.73 5.27,7.71 10.62,12.92 18.91,15.6 6.51,2.1 14.52,2.31 18.54,-4.54 2.38,-4.08 3.9,-8.54 5.03,-13.14 20.86,9.87 43.56,13.95 67.25,6.16 3.99,-1.31 7.54,-2.83 10.77,-4.56 -1,1.43 -2.1,2.89 -3.42,4.42 -6.29,7.3 -9.58,18.28 -3.96,27.14 1.23,1.94 2.45,3.87 3.68,5.8 4.38,6.9 11.04,12.02 18.49,14.48 -3.13,-12.43 -7.23,-24.69 -11.91,-36.41 102.43,30.73 40.96,-51.21 81.94,-112.68 30.72,40.98 71.7,61.47 122.91,30.74 -10.25,-10.25 -10.25,-10.25 -20.48,-20.49 20.48,0 40.97,20.49 61.46,10.24 -10.25,-20.49 -20.49,-51.21 -10.25,-51.21 61.46,-30.729 102.43,-20.49 133.16,-92.19 0,-2.801 3.9,-4.02 9.89,-3.969 0.19,-3.012 0.83,-5.562 2.52,-7.082 -0.62,0.563 15.21,-1.48 20,-4.168 7.86,-4.422 14.68,-14.879 12.26,-24.16 l -0.75,-2.871 c -1.91,-7.36 -8.53,-15.789 -16.54,-17.102 -21.25,-3.488 -41.23,-2.988 -56.69,13.922 -12.53,13.731 -15.74,34.211 -21.7,51.149 l -0.28,1.043 c -3.02,3.257 -7.35,6.378 -10.75,9.089 -6.42,5.11 -13.6,9.481 -19.58,15.11 -5.61,5.301 -11.45,11.34 -16.79,17.898 -3.39,1.93 -6.78,3.961 -10.17,6.121 -2.79,1.782 -6.21,4.25 -10.04,7.039 -2.87,-21.359 -21.95,-31.218 -43.22,-32.519 -10.76,-0.66 -15.99,15.781 -6.01,20.781 11.49,5.75 16.21,11.469 11.68,23.849 -1.46,3.97 -3.47,7.69 -5.64,11.32 0.17,-0.49 -0.79,0.61 -1.98,2.05 -3.69,0.7 -7.15,0.76 -10.22,-0.21 -16.8,-5.31 -20.52,-23.849 -46.58,-21.939 -11,0.809 -19.73,4.849 -25.96,11.459 -4.04,-4.45 -9.21,-8.02 -15.22,-10.08 -30.3,-10.398 -72.33,1.59 -89.76,29.1 -1.99,0.81 -3.92,1.73 -5.88,2.64 -2.2,-1.82 -4.62,-3.47 -7.46,-4.72 -1.03,-0.45 -2.16,-0.74 -3.26,-1.08 -12.1,-20.11 -37.22,-40.401 -19.24,-56.471 16.75,-14.98 47.98,-12.367 66.94,-27.078 9.8,-7.609 4.46,-24.992 -6.84,-27.742 -34.8,-8.449 -88.88,-2.969 -113.8,25.82 l -0.38,0.5 c -7.27,-2.129 -16.07,-0.269 -21.61,6.973 -10.78,14.09 -22.09,26.558 -35.85,37.75 -13.89,11.277 -7.22,30.708 4.45,39.718 1.18,0.91 2.31,1.95 3.46,2.91 l -1.02,-0.23 c -25.2,-4.42 -50.27,-5.16 -74.72,3.19 -17.43,5.95 -31.02,16.96 -45.19,27.13 -8.2,-17.38 -24.29,-33.85 -35.06,-46.12 -12.59,-14.36 -23.25,-26.938 -42.8,-31.649 -22.61,-5.449 -45.78,-0.309 -68.26,-6.52 -15.98,-4.402 -29.94,12.899 -21.91,27.529 6.79,12.34 16.01,19.86 26.53,25.02 -3.36,2.38 -7.39,5.36 -11.28,8.55 -2.62,-2.59 -5.69,-4.99 -9.71,-6.93 -10.93,-5.26 -21.28,-7.81 -31.39,-8.55 -12.57,-5.03 -26.67,-3.98 -39.64,4.66 -1.99,1.32 -3.72,2.76 -5.34,4.26 -5.92,2.59 -11.88,5.51 -17.98,8.97 -2.5,1.42 -4.89,2.83 -7.2,4.23 -2.59,0.82 -5.22,1.65 -7.91,2.5 -23.91,7.6 -46.84,6.28 -69.67,1.79 -13.65,-6.15 -27.23,-13.13 -41.6,-15.85 l -1.91,-0.3 c -2.62,-19.62 -19.15,-37.238 -42.42,-29.43 -15.96,5.36 -19.57,7.27 -23.42,3.85 24.63,86.29 124.65,47.65 167.27,124.72 14.02,-3.79 41.53,-21.41 61.6,-31.82 4.75,7.94 9.21,15.17 18.19,20.45 -0.54,1.38 -1.1,2.76 -1.6,4.17 -4.23,0.88 -8.67,2.38 -13.31,4.74 -19.7,10.04 -35.7,24.25 -52.19,37.47 -9.42,-4.91 -23.1,1.42 -22.77,13.25 0.03,1.04 0.32,1.99 0.53,2.96 -5.04,3.23 -10.35,6.09 -15.88,8.66 l -1.09,-1.43 c -11.68,-12.47 -24.33,-7.38 -37.11,-13.44 -7.17,-3.39 -15.03,-3.43 -21.6,-0.84 -11.66,-6.15 -23.77,-10.95 -34.6,-9.9 -5.01,15.35 -9.52,29 -14.03,41.17 4.27,1.2 8.9,1.15 12.72,-0.6 8.51,-3.9 25.63,15.04 32.48,20 4.63,3.35 9.34,4.27 13.78,3.66 -4.17,9.52 -7.8,20.16 -14.85,25.85 2.59,-3.47 -20.23,0.71 -25.74,1.28 -14.56,1.48 -29.51,3.77 -43.62,7.72 -2.61,0.73 -5.07,1.62 -7.58,2.46 -20.46,23.15 -50.78,39.35 -105.39,57.55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3790",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3327.04,1404.52 c 12.19,-8.13 26,-9.77 40.14,-8.83 -10.82,-9.77 -21.65,-19.52 -32.47,-29.28 5.28,-9.96 -0.27,-25.64 -12.49,-29.51 9.82,20.1 10.39,45.35 4.82,67.62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3792",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2890.63,1184.99 c -4.26,9.73 2.74,17.26 11.25,19.66 4.51,-12.17 9.02,-25.82 14.03,-41.17 -9.97,0.97 -18.86,6.9 -25.28,21.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3794",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2565.93,1255.9 0.24,-0.73 c 0.64,0.72 1.47,1.64 2.64,2.91 2.09,2.26 4.94,4.24 7.53,5.84 4.88,3.01 10.77,4.86 16.26,6.84 -3.73,5.56 -7.22,11.94 -11.08,19.3 -2.31,4.41 2.36,10.43 7.16,7.41 9.89,-6.25 37.2,-0.95 47.96,0.36 10.72,1.3 20.85,5.52 30.53,10.64 -1.96,6.99 -3.13,14.27 -3.88,21.45 -1.51,14.48 5.1,42.43 -11.85,45.82 -18.9,3.78 -19.1,33.21 -0.62,37.8 19.75,4.91 39.39,3.46 53.43,-12.91 15.59,-18.18 11.24,-38.91 16.57,-60.27 3.13,-12.59 -0.19,-11.01 13.75,-12.48 13.07,-1.38 30.71,5.33 43.79,7.45 10.2,1.65 20.49,3.01 30.47,3.36 1.54,3.66 3.62,7.21 6.3,10.53 3.19,3.97 5.34,9.27 6.62,15.36 -16.92,14.95 -28.18,31.26 -33.04,49.84 -8.98,0.46 -18.09,3.73 -26.85,10.74 -7.04,5.63 -12.32,12.75 -18.48,19.22 -2.02,2.13 -5.75,4.7 -8.33,7.36 -3.34,-0.55 -6.66,-1.18 -10.05,-1.62 -37.07,-4.78 -41.13,49.08 -11.01,61.98 -0.07,6.52 0.05,13.06 0.21,19.8 0.15,6.57 -0.5,13.17 -0.1,19.72 0.1,1.62 1.34,6.12 1.51,9.06 -0.37,0.66 -1.3,3.68 -2.48,5.27 -8.89,12.11 7.45,26.11 19.22,19.87 1.06,-0.57 5.81,-3.81 7.68,-5.13 1.15,-0.54 7.04,-3.85 7.8,-4.31 8.97,-5.39 14.44,-12.02 18.68,-21.32 5.14,-11.29 8.74,-22.98 12.35,-34.71 10.54,-5.88 18.32,-16.38 22.12,-30.56 18.34,-0.66 36.94,-10.07 53.25,-27.25 32.43,-34.14 43.12,-85.7 26.65,-128.72 6.34,-2.34 13.89,-3.25 21.91,-3.47 2.01,19.56 13.1,38.1 31.54,50.04 2.84,1.83 5.83,3.39 8.81,4.98 21.94,-18.96 37.47,-43.29 15.15,-73.04 -51.21,-71.7 -122.91,10.24 -194.61,10.24 54.61,-18.2 84.93,-34.4 105.39,-57.55 -1.85,0.62 -3.78,1.16 -5.59,1.82 -6.14,-5.34 -14,-9.01 -22.57,-9.9 -15.07,-1.55 -27.23,4.71 -41.91,6.04 -14.96,1.35 -29.61,-2.65 -44.47,-3 h -0.48 c -1.51,-0.97 -3.09,-1.88 -4.82,-2.62 -15.19,-6.54 -30.61,-6.96 -46.74,-9.27 -4.91,-0.7 -9.34,0.07 -13.27,1.84 -11.93,-2.88 -24.22,-3.73 -36.73,-3.52 l -1.08,-0.57 c -1.31,-5.09 -4.6,-9.72 -10.38,-12.77 l -2.65,-1.4 c -10.21,-5.39 -19.78,-3.6 -28.55,3.21 3.33,-2.59 1.39,-0.76 -2.33,-2.81 -4.53,-2.5 -10.85,-4.8 -15.83,-5.81 -6.11,-1.23 -12.91,-0.76 -18.53,2.06 -1.4,0.7 -2.62,1.78 -3.89,2.73 -1.09,0.07 -6.02,1.68 -6.07,1.7 -12.13,4.34 -11.15,22.54 2.75,23.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3796",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2929.99,1401.52 c -5.26,9.67 -0.17,22.77 8.36,28.91 15.11,10.9 32.1,10.26 46.7,3.11 -10.86,-26.12 -32.13,-35.34 -55.06,-32.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3798",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3552.38,1322.57 c -2.84,2.84 -5.26,3.78 -7.45,3.54 10.8,8.54 25.14,12.31 37.69,7.61 -0.07,1.05 -0.14,2.1 -0.15,3.15 l -0.01,0.09 c -0.22,1.4 -0.46,3.05 -0.76,5.12 -0.07,1.32 0,2.65 -0.05,3.97 -0.01,0.3 -0.11,1.34 -0.18,2.25 l -0.12,0.72 c -0.35,1.86 -0.7,3.7 -0.99,5.55 -5.89,13.35 3.25,32.6 19.52,31.32 1.63,-0.13 3.25,-0.38 4.88,-0.56 7.47,0.38 14.37,-0.76 21.41,-4.96 6.34,-3.79 11.66,-8.81 16.22,-14.53 3.07,-3.83 5.31,-8.06 7.03,-12.52 5.56,1.26 11.16,2.39 16.92,3.19 7.19,1 34.15,-2.25 38.87,1.21 8.34,-1.05 5.37,0.37 -8.89,4.23 -1.67,7.16 -1.75,14.3 -0.24,21.44 2.02,12.21 5.7,19.62 14.36,28.11 9,8.82 18.54,8.87 28.5,14.84 1.48,0.31 2.77,0.56 3.89,0.77 3.77,4.08 5.67,8.86 5.47,14.43 -0.24,4.8 2.56,9.7 6.59,12.78 2.31,10.33 4.36,20.7 6.25,31.03 2.6,14.23 20.04,16.04 29.54,8.32 2.31,3.67 4.6,7.34 6.9,11.01 -5.72,23.82 27.17,32.79 36.02,10.58 13.84,-34.8 -4.45,-53.85 -29.92,-56.05 6.82,-30.68 4.14,-61.56 -6.95,-92.67 -2.46,-6.93 -5.48,-13.45 -8.7,-19.84 5.46,1.42 10.73,2.95 15.81,4.76 5.07,16.24 20.25,23.85 35.44,22.6 5.53,5.89 10.87,13.03 16.05,22.01 1.79,3.08 4.54,5.35 7.67,7 0.52,1.29 1.01,2.57 1.62,3.87 7.66,16.43 30.23,13.58 39.17,0.64 1.33,-1.91 2.32,-4.1 3.41,-6.22 3.16,1.24 6.42,2.32 9.85,3.06 11.62,2.51 23.51,1.02 34.88,-2.06 1.39,1.81 2.74,3.47 3.77,4.69 7.91,9.3 21.21,7.08 29.7,0.49 15.15,-11.75 18.89,-37.89 9.04,-54.34 -10.92,-18.22 -32.1,-20.26 -51.02,-16.77 -2.97,0.56 -5.94,1.21 -8.84,2.06 -0.89,0.26 -2.49,0.28 -3.67,0.3 l -1.68,-0.89 c -4.14,-3.22 -7.54,-7.65 -11.09,-11.46 -3.54,-3.82 -7.1,-7.4 -10.72,-10.74 3.81,-2.28 7.33,-5.13 10.36,-8.61 l 1.68,0.39 c 10.22,2.49 22.07,-8.99 15.19,-19.1 -4.44,-6.51 -9.17,-10.4 -15.59,-14.92 -5.74,-4.04 -15.77,-2.94 -20.52,2.31 -2.68,2.96 -4.75,5.62 -7.62,7.77 -1.46,0.13 -2.78,0.09 -4.55,-0.92 -11.59,-6.51 -22.66,-0.26 -27.39,8.89 -7.44,-14.86 -18.98,-26.41 -38.65,-30.37 -11.33,-2.28 -22.87,-0.68 -34.26,-2.32 -19.89,-2.86 -29.7,-14.44 -41.95,-28.6 3.57,-6.81 6.67,-13.79 8.46,-21.17 3.61,-14.99 -1.44,-29.67 -14.81,-37.81 -14.62,-8.93 -31.93,-4.23 -39.81,10.69 -2.07,3.91 -2.94,9.34 -0.22,13.28 -0.93,-1.35 -0.19,-0.01 0.66,1.49 -0.76,1.36 -1.53,2.75 -1.82,3.23 -6.39,10.21 -13.47,19.32 -19.04,29.79 -24.61,-12.11 -50.66,-20.72 -77.21,-12.41 -8.22,2.57 -15.26,6.5 -21.23,11.35 4.54,34.31 -0.97,68.16 -26.72,93.91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3800",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3501.17,1281.6 c -20.49,10.24 -20.49,40.97 0,61.46 -12.33,-4.11 -23.01,0.05 -33.36,5.81 2.97,4.65 6.44,8.63 10.91,12.52 -3.51,-3.05 9.02,6.32 5.62,4.41 1.01,0.56 6.03,2.17 8.71,2.94 3.1,1.25 8.23,3.2 10.01,3.57 7.25,1.51 14.15,0.73 21.18,-1.44 15.72,-4.84 14.23,-30.04 -3.53,-29.77 -0.69,0.01 -2.31,-0.21 -3.84,-0.33 l 0.03,-0.45 c 0.62,-9.7 1.16,-14.63 1.43,-23.35 7.81,3.43 15.69,6.05 23.66,7.99 -11.35,-7.87 -16.37,-51.51 -40.82,-43.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3802",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3032.45,1130.03 c 0.94,-0.11 2.17,-0.51 3.29,-0.82 -42.62,-77.07 -142.64,-38.43 -167.27,-124.72 -2.58,-2.29 -5.28,-6.931 -11.84,-14.592 -12.17,-14.187 -32.75,-29.628 -50.56,-35.328 -17.49,-5.59 -36.95,-4.41 -53.05,4.571 -7.74,4.289 -11.79,8.82 -14.84,13.75 -14.1,-9.532 -27.33,-27.379 -48.97,-24.512 -34.3,4.562 -46.53,36.32 -59.52,63.681 -7.58,15.94 10.54,32.4 24.74,19.75 13.19,-11.75 26.13,-23.1 38.28,-17.24 8.65,4.17 15.26,18.33 24.75,23.68 27.85,15.72 45.07,6.97 68.21,-7.46 3,-1.88 4.43,-3.3 4.99,-4.36 1.22,3.14 11.98,16.53 12.75,17.6 4.52,6.29 8.02,11.81 12.83,16.87 -6.14,6.25 -10.43,14.44 -11.3,22.85 -16.7,-3.1 -31.3,10.01 -33.73,26.07 -13.29,-2.65 -26.68,-7.24 -38.88,-11.18 -18.49,-6 -25.72,21.48 -8.36,28.48 13.22,5.35 26.2,12.1 39.32,18.02 -8.51,6.7 -9.98,8.95 -21.42,8.76 -19.23,-0.31 -28.12,22.84 -15.86,36.56 40.4,45.17 98.91,-6.18 132.38,-33 7.7,-6.19 11.1,-13.52 11.63,-20.87 3.48,-3.02 6.79,-6.19 9.75,-9.52 l 0.09,-0.1 c 5.44,-0.95 10.72,-2.54 15.68,-5.06 14.37,1.27 26.17,-9.84 30.74,-23.02 16.5,5.45 34.77,17.34 45.98,21.54 1.33,0.5 2.67,0.96 4,1.44 14.49,1.12 30.33,3.93 45.15,8.76 3.66,-0.01 7.33,-0.16 11.04,-0.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3804",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3931.37,933.34 c -30.73,71.7 -71.7,61.461 -133.16,92.19 -10.24,0 0,30.72 10.25,51.21 -20.49,10.25 -40.98,-10.24 -61.46,-10.24 10.23,10.24 10.23,10.24 20.48,20.49 -51.21,30.73 -92.19,10.24 -122.91,-30.74 -40.98,61.47 20.49,143.41 -81.94,112.68 4.68,11.72 8.78,23.98 11.91,36.41 7.88,2.6 16.63,2.22 24.53,-2.43 2.99,-1.76 5.99,-3.52 8.98,-5.28 2.4,-1.41 4.38,-3.28 6.14,-5.32 7.94,-3.04 14.24,-11.39 17.91,-19.79 0.77,-1.75 1.13,-3.71 1.18,-5.73 5.49,-5.73 9.74,-12.73 11.81,-22.49 1.97,-9.28 0.3,-18.82 -1.67,-27.98 -0.24,-1.08 -0.41,-2.16 -0.6,-3.24 12.89,10.32 23.9,25.35 38.89,32.73 21.44,10.54 46.14,11.68 69.14,5.55 7.92,-2.11 15.94,-5.53 23.36,-9.34 1.67,14.42 4.81,28.9 12.12,40.42 7.24,11.41 22.87,11.8 30.47,0.49 1.96,-2.92 3.51,-6.04 4.91,-9.24 14.55,7.56 31.74,10.24 47.83,7.13 4.35,-0.83 14.73,-2.19 18.23,-5.42 0.76,11.35 -2.11,33.12 -2.11,36.92 0,29.32 39.5,50.73 61.13,26.5 5.05,-5.66 42.85,-46.95 26.81,-13.83 -12.85,26.52 19.72,58.71 42.99,34.31 5.04,-5.28 9.58,-11.22 13.52,-17.5 l 1.66,1.17 c 6.38,3.87 13.01,5.3 20.26,6.51 3.09,0.51 4.67,0.46 5.44,0.25 0.17,0.74 0.82,2.06 2.64,4.39 6.06,7.74 18.63,3.12 21.15,-5.21 1.84,-6.09 3.49,-11.77 3.47,-17.32 1.92,-0.45 4.72,-1.11 5.29,-2.12 9.23,-3.23 17.19,-12.25 16.81,-22.47 -0.76,-20.97 -15.2,-34.9 -33.66,-42.46 -12.52,-5.15 -28.72,-8.16 -42.7,-5.51 -2.46,-2.71 -5.42,-5.22 -8.62,-7.63 2.38,-1.5 4.66,-3.16 6.8,-5.1 5.33,0.75 11.09,-0.02 14.98,-2.69 l 4.93,0.95 c 13.52,10.54 32.01,-3.32 32.6,-18 0.21,-4.97 22.55,-4.54 27.23,-5.26 6,-0.9 6.93,-8.7 3.55,-12.57 -16.09,-18.46 -36.71,-20.67 -53.57,-10.37 -7.08,-3.17 -14.49,-3.89 -22.39,-2.04 l -1.97,-1.48 c -10.47,-7.48 -26.84,-2.48 -33.04,8.08 -8.2,13.97 -22.55,9.79 -36.96,9.88 -6.68,0.04 -13.46,2.72 -18.14,7.58 -10.42,-20.44 -29.37,-33.33 -63.57,-28.2 -4.81,0.72 -15.51,2.58 -20.39,6.32 -2.85,-9.31 -5.81,-20.67 -7.84,-23.94 -3.42,-5.48 -7.52,-10.7 -12.12,-15.44 1.69,-1.35 3.42,-2.73 5.2,-4.13 13.63,-1.75 23.41,-10.76 32.34,-21.61 5.51,-2.34 10.09,-2.97 12.79,-0.55 12.21,10.84 31.82,13.69 44.16,0.72 20.53,-21.56 36.94,-20.48 60.67,-5.14 8.97,5.81 22.1,0.67 24.84,-9.63 7.66,-28.698 -10.64,-53.6 -39.32,-60.671 -15.15,-3.718 -30.31,-2.16 -44.57,2.711 1.38,-4.558 2.37,-9.238 3.05,-13.73 0.84,-5.508 -0.21,-12.371 0.15,-17.719 -5.99,-0.051 -9.89,1.168 -9.89,3.969"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3806",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3429.47,1404.52 c -8.56,0 -17.93,-1.61 -27.64,-3.45 -8.2,1 -16.16,2.41 -23.48,4.7 -3.72,-3.36 -7.45,-6.72 -11.17,-10.08 -14.14,-0.94 -27.95,0.7 -40.14,8.83 5.57,-22.27 5,-47.52 -4.82,-67.62 -1.4,-0.45 -2.84,-0.84 -4.41,-0.94 -12.14,-0.8 -24.65,0.69 -37,0.98 -1.47,-2.87 -3,-5.75 -4.34,-8.59 -3.91,-8.26 -7.65,-16.88 -11.39,-25.55 -49.47,6.93 -40.47,63.32 -40.47,101.72 0,10.24 -20.49,30.73 -30.72,30.73 -51.23,-10.25 0,-81.94 -30.74,-81.94 -40.97,-10.25 -40.97,40.96 -61.45,51.21 -6.52,3.25 -12.7,6.17 -18.77,8.94 -2.26,7.95 -3.37,16.23 -3.18,24.45 0.2,8.59 4.4,17.33 6.3,25.69 -14.96,-8.55 -35.52,0.52 -45.73,15.79 -13.06,4.48 -24.8,10.83 -35.68,19.13 l -0.59,-0.07 c -2.66,-5.18 -7.25,-9.47 -14.06,-11.5 -0.29,-0.09 -2.2,-0.61 -3.35,-0.86 l -0.9,-0.61 c -0.69,-1.23 -6.49,-7.76 -3.21,-3.36 -4.89,-6.57 -9.13,-13.68 -15.3,-19.14 -9.82,-8.67 -25.14,-11.25 -37.05,-5.21 -12.07,6.1 -20.21,21.01 -9.63,32.68 2.82,3.12 8.43,5.58 11.63,6.25 1.1,1.32 2.3,2.59 3.53,3.82 0.39,0.65 2.88,3.8 3.59,4.8 1.76,2.53 3.63,4.96 5.54,7.33 -2.62,1.87 -5.17,3.89 -7.62,6.07 -5.6,4.98 -10.14,10.34 -13.96,15.94 -4.23,-0.18 -8.54,0.02 -13.23,0.89 -2.18,0.41 -3.5,0.77 -3.71,0.93 -4.05,0.43 -8.16,0.59 -12.15,1.42 -3.12,0.64 -6.15,1.39 -9.14,2.24 -8.51,-3.23 -17.85,-4.91 -26.46,-6.03 -6.08,-0.79 -11.95,-0.71 -18.05,-0.61 -8.4,0.13 -14.46,2.08 -22.43,3.63 -14.75,2.86 -12.79,23.09 -0.45,27.54 9.71,3.51 18.79,10.58 28.12,17.13 1.46,7.66 5.74,14.74 13.14,18.92 l 2.08,1.08 c -3.95,2.69 -7.81,5.49 -11.44,8.28 -7.06,-4.07 -16.04,-5.53 -26.37,-2.9 -12.77,3.26 -21.6,12.65 -27.15,24.21 -2.39,4.98 -12.08,40 -4.56,41.83 -14.88,-3.62 -27.84,14.74 -15.97,26.42 12.86,12.65 31,12.58 45.12,1.3 7.14,-5.7 11.48,-13.82 13.97,-22.49 0.72,-2.49 1.88,-6.21 2.57,-9.78 3.46,0.89 7.16,0.83 10.89,-0.64 3.85,-1.52 9.22,-3.45 15.26,-5.71 5.93,22.87 17.43,43.94 33.79,61.25 l -12.38,14.41 c -7.82,4.54 -7.8,19.19 2.4,21.03 7.62,1.38 14.58,1.95 21.14,1.77 -0.16,1.57 0,3.17 0.58,4.74 1.07,2.96 1.9,5.56 2.7,8.48 0.55,1.97 3.91,11.43 2.83,8.69 -1.42,-3.6 1.49,3.82 1.7,4.25 0.52,0.99 1.08,1.91 1.66,2.87 l 0.43,0.62 c -0.5,3.06 -0.95,6.11 -1.51,9.2 -1.33,7.42 0.24,11.31 -2.92,17.45 -1.8,3.5 1.01,6.7 4.65,6.25 9.28,-1.15 13.47,-0.44 21.17,-5.47 8.69,-5.7 15.51,-13.55 20.24,-22.67 4.36,-8.38 4.15,-19.11 -2.93,-26.1 -2.66,-2.64 -5.34,-4.9 -8.6,-6.67 -1.13,-2.88 -2.96,-6.89 -3.57,-8.19 -0.75,-1.55 -1.87,-2.9 -3.14,-4.13 4.33,-2.91 8.6,-6.34 12.92,-10.62 13.71,-13.62 9.75,-33.84 -4.99,-44.46 -14.85,-10.71 -23.79,-22.7 -27.15,-36.74 13.34,10.17 32.52,8.79 44.95,-0.84 1.25,5.79 2.16,11.6 2.66,16.56 1.49,14.65 21.05,29.02 33.24,14.41 16.51,-19.78 21.14,-39.87 13.96,-65.37 -4.37,-15.51 -14.1,-34.24 -27.86,-45.72 1.01,-0.33 2.1,-0.38 3.34,0.22 14.97,7.43 35.27,8.11 47.6,-5.34 1.58,-1.72 3.14,-3.3 4.68,-4.78 3.41,9.97 7.81,19.41 11.69,29.6 5.31,13.98 28.37,14.07 28.12,-3.33 -0.24,-15.2 0.31,-30.64 1.01,-46.09 2.49,-0.89 4.78,-1.97 6.85,-3.32 20.64,-2.63 39.6,-10.63 53.04,-30 10.77,-15.52 12.75,-33.06 10.97,-51.5 -1.62,-16.8 -3.01,-28.82 17.53,-22.68 11.2,3.35 23.9,1.24 33.5,-5.42 1.33,1.04 2.69,1.76 4.05,2.57 -12.39,19.18 -13.44,44.21 1.14,65 -2.28,1.69 -4.71,4.31 -7.31,8.08 -17.71,13.01 -26.36,31.17 -26.98,48.83 -11.05,4.85 -20.42,14.54 -23.96,25.28 -1.25,3.8 -2.49,7.6 -3.74,11.4 -16.84,15.01 -31.6,34.87 -36.63,56.77 -1.44,0.47 -2.87,0.94 -4.34,1.68 -35.74,17.98 -62.81,49.24 -51.13,86.7 l -1.47,2.45 c -2.25,0.15 -4.5,0.31 -6.81,0.37 -28.3,0.73 -34.13,33.37 -14.22,49.28 2.7,2.16 6.32,14.13 8.63,17.94 4.64,7.63 15.49,11.83 23.59,6.6 5.95,-3.85 9.83,-8.63 12.33,-13.86 1.74,3.96 3.98,7.3 7.7,9.91 1.89,2.67 6.69,5.18 8.75,5.82 l 1.32,0.28 -0.34,-0.71 0.18,0.36 -0.07,-0.04 0.27,0.4 0.05,0.01 c 1.92,3.18 4.96,5.72 8.9,7.12 l 0.18,0.07 c 6.32,2.25 14.58,-1.15 17.85,-6.92 4.33,-7.68 1.73,-15.69 -3.57,-21.84 0.13,-1.55 0.15,-3.11 -0.04,-4.73 -0.87,-7.4 -3.92,-13.33 -9.22,-18.64 -3.44,-3.47 -7.89,-5.2 -12.39,-5.58 2.85,-4.79 6.4,-9.6 8.75,-13.72 5.8,-10.15 4.43,-22.73 -3.51,-31.29 -5.12,-5.52 5.34,-11.59 15.59,-16.27 4.22,9.68 9.84,18.52 17.03,24.26 -1.11,5.63 4.24,10.18 10.09,7.65 1.6,-0.37 3.2,-0.75 4.79,-1.12 4.18,-0.02 9.58,-2.17 11.41,-6.3 4.23,-9.52 2.91,-17.26 4.58,-27.2 2.02,-12.01 8.56,-23.67 14.56,-34.36 5.95,-10.57 13.94,-15.16 23.01,-22.54 3.36,-2.71 6.07,-5.82 8.37,-9.18 5.92,-0.89 11.6,-2.96 16.83,-6.28 1,7.54 2,15.09 3.02,22.63 -6.88,0.32 -13.56,3.11 -19.05,7.97 -12.3,10.9 -14.89,27.56 -11.56,43.05 2.59,12.04 10.86,20.82 20.2,28.16 6.44,5.07 14.38,4.35 20.78,0.57 0.41,2.6 0.95,5.25 1.79,7.98 1.71,5.53 4.34,10.05 7.46,13.8 -14.47,5.09 -21.33,19.72 -17.51,33.8 0.15,1.04 0.18,2.09 0.4,3.12 0.48,1.83 1.17,3.44 1.98,4.95 0.04,1.87 0.37,3.74 0.78,5.59 l -1.9,1.13 c -12.45,9.49 -20.41,24.85 -16.09,40.67 1.31,4.81 2.92,9.68 3.77,14.48 l -2.19,0.96 c -10.01,5.64 -13.47,18.03 -9.29,28 -0.63,4.64 1.97,10.09 6.67,10.86 1.54,0.25 2.99,0.25 4.49,0.4 7.1,3.05 15.6,2.42 21.9,-1.98 14.44,-4.78 24.66,-16.73 26.06,-36.85 0.89,-12.73 -6.46,-19.28 -7.97,-30.43 1.63,12.03 5.78,0.62 6.96,-5.37 0.21,-1.1 0.2,-2.16 0.29,-3.23 3.67,-1.12 7.14,-3.03 10.12,-5.83 4.17,-3.92 8,-7.37 11.3,-12.21 2.46,-3.59 3.93,-7.4 4.91,-11.3 9.42,11.34 19.27,22.48 25.63,35.31 -24.42,13.1 -20.23,58.57 14.21,59.14 31.01,0.51 38.74,-36.31 22.39,-53.74 8.27,-12.88 10.34,-27.57 3.07,-46.76 -5.75,-15.2 -15.89,-25.7 -25.32,-38.45 -8.64,-11.67 -13.61,-17.18 -15.22,-25.44 0.42,-3.5 0.3,-7.08 -0.37,-10.61 0.1,-1.26 0.16,-2.44 0.34,-3.84 1.14,-8.95 3.27,-17.41 5.11,-25.73 l 0.18,-0.2 c 9,-9.69 10.26,-25.03 2.13,-35.07 -0.78,-4.12 -2.14,-8.32 -4.07,-12.61 1.57,-18.96 2.94,-37.94 4.05,-56.92 6.02,6.15 12.29,11.13 20.91,14.28 11.63,4.26 24.38,-6.2 24.4,-17.96 0.02,-10.97 -4.09,-19.92 -9.15,-29.44 -3.69,-6.93 -7.72,-14.46 -13.7,-19.51 6.87,-16.92 12.51,-31.49 33.95,-29.44 11.85,1.12 29.36,13.83 40.22,18.26 l 2.27,0.89 c 1.8,6.92 5.91,12.39 11.36,16.05 -21.79,23.34 -43.68,56.01 -49.93,81.64 -4.67,19.11 3.37,36.14 16.53,49.73 6.43,6.63 14.37,12.22 22.05,17.31 1.82,1.21 4.98,2.58 6.25,4.44 l 1.08,1.14 c -0.91,0.61 -2.32,2 -4.5,5.23 -9.32,13.8 8.76,33.3 22.98,23.76 16.57,-11.11 32.98,-22.98 29.26,-45.55 -2.27,-13.81 -16.51,-31.93 -29.42,-38.1 l -2.13,-1.95 c 6.49,-8.04 11.44,-17.92 17.81,-26.15 3.12,-4.02 7.12,-8.84 11.32,-13.76 4.62,3.59 10.24,6.02 16.44,6.76 6.71,19.98 28.83,27.49 48.37,22.16 4.75,9.45 11.11,18.17 20.79,25.85 12.11,9.63 24.4,15.67 39.63,18.26 1.37,0.23 8.19,1.66 13.32,2.31 9.76,18.02 40.5,18.69 51.08,0.16 20.21,-35.44 -7.96,-61.09 -41.83,-65.73 -29.1,-3.98 -25.36,-19.81 -33.31,-45.63 -0.67,-2.2 -1.65,-4.34 -2.75,-6.43 1.37,-13.62 -0.32,-26.91 -4.49,-39.58 3.94,-0.98 7.84,-2.09 11.66,-3.44 10.72,10.5 29.43,12.56 41.53,-0.21 3.79,8.27 13.67,10.24 21.81,6.84 28.48,-11.91 24.25,-51.59 0.81,-66.82 -8.27,-5.37 -17.02,-7.35 -25.51,-6.86 l -1.14,-1.46 c -10.37,-11.61 -27.84,-12.51 -40.99,-5.98 -28.1,13.96 -53.62,1.23 -77.46,-13.92 -11.6,-7.38 -22.86,-7.74 -32.23,-3.85 -11.74,-4.51 -23.74,-7.88 -35.61,-9.86 -10.39,-1.73 -20.37,-2.36 -30.08,-2.44 1.73,1.68 3.88,3.23 6.6,4.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3808",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3401.83,1401.07 c 9.71,1.84 19.08,3.45 27.64,3.45 -2.72,-1.36 -4.87,-2.91 -6.6,-4.59 -7.26,-0.06 -14.28,0.31 -21.04,1.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3810",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2976.26,1121.87 c 14.73,5.23 29.67,8.81 45.15,8.76 -14.82,-4.83 -30.66,-7.64 -45.15,-8.76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3812",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2771.71,1475.71 0.32,1.68 c 2.01,10.21 13.73,18.72 23.98,18.26 10.38,-0.47 21.83,-7.31 23.98,-18.26 l 0.33,-1.68 c 1.71,-8.7 0.42,-18.19 -6.48,-24.52 -4.94,-4.53 -11,-7.39 -17.83,-7.39 -6.46,0 -13.25,2.82 -17.83,7.39 -6.71,6.71 -8.25,15.5 -6.47,24.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3814",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2746.51,1550.12 c 27.03,0 27.08,-42.01 0,-42.01 -27.03,0 -27.08,42.01 0,42.01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3816",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2924.6,1421.11 c 2.65,6.29 9.27,11.33 16.38,11.01 6.25,-0.28 12.24,-3.37 15.46,-8.87 4.4,-7.51 2.24,-15.39 -2.8,-21.71 l -0.78,-0.98 c -5.25,-6.57 -18.55,-6.54 -23.77,0 l -0.78,0.98 c -4.61,5.77 -6.71,12.45 -3.71,19.57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3818",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2972.79,1373.69 c 7.73,0 14.29,-6.57 14.29,-14.28 0,-7.76 -6.53,-14.29 -14.29,-14.29 -7.71,0 -14.28,6.56 -14.28,14.29 0,7.74 6.54,14.28 14.28,14.28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3820",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2919.76,1333.78 c 21.63,0 21.66,-33.61 0,-33.61 -21.63,0 -21.67,33.61 0,33.61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3822",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2870.26,1368.75 c 16.58,0 16.6,-25.77 0,-25.77 -16.58,0 -16.61,25.77 0,25.77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3824",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2834.9,1443.11 c 21.27,0 21.3,-33.05 0,-33.05 -21.26,0 -21.3,33.05 0,33.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3826",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2803.08,1322.34 c 20.55,0 20.58,-31.94 0,-31.94 -20.54,0 -20.57,31.94 0,31.94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3828",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2753.58,1313.97 c 9.52,0 18.65,-8.38 18.21,-18.2 -0.44,-9.87 -8,-18.22 -18.21,-18.22 -9.52,0 -18.64,8.38 -18.2,18.22 0.44,9.86 8,18.2 18.2,18.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3830",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2677.17,1274.55 c 0.72,6.37 6.31,11.19 12.8,8.44 5.78,-2.43 7.76,-10.47 2.97,-14.98 -2.66,-2.49 -4.91,-5.14 -8.51,-6.21 -3.23,-0.95 -6.15,1.17 -7.23,4.11 -1.05,2.84 -0.38,5.71 -0.03,8.64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3832",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2619.99,1258.08 -0.02,-0.03 0.5,0.9 0.13,0.25 0.68,1.2 c 3.62,7.65 14.5,8.62 20.57,3.93 6.06,-4.67 8.01,-15.49 1.42,-20.9 -2.59,-2.13 -5.41,-4.66 -8.89,-5.16 -6.53,-0.96 -12.96,1.04 -15.61,7.66 -1.73,4.29 -1.07,8.61 1.22,12.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3834",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2679.33,1417.34 c 24.52,0 24.56,-38.09 0,-38.09 -24.51,0 -24.55,38.09 0,38.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3836",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2820.76,1164.28 c 31,0 31.05,-48.17 0,-48.17 -31,0 -31.04,48.17 0,48.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3838",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2898.54,1109.46 c 24.15,0 24.19,-37.53 0,-37.53 -24.15,0 -24.19,37.53 0,37.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3840",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2902.08,1061.54 c 21.63,0 21.66,-33.62 0,-33.62 -21.62,0 -21.66,33.62 0,33.62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3842",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2972.43,1109.78 0.63,1.41 c 4.66,10.52 23.09,10.52 27.77,0 l 0.61,-1.41 c 2.52,-5.66 3.3,-11.33 0,-16.96 -2.98,-5.11 -8.58,-8.32 -14.5,-8.32 -5.93,0 -11.52,3.21 -14.51,8.32 -3.3,5.63 -2.52,11.3 0,16.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3844",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2856.12,1067.84 c 11.53,0 11.55,-17.93 0,-17.93 -11.53,0 -11.55,17.93 0,17.93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3846",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2813.69,1003.25 c 5.77,0 5.77,-8.969 0,-8.969 -5.77,0 -5.78,8.969 0,8.969"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3848",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2735.91,1017.11 c 5.4,0 5.41,-8.4 0,-8.4 -5.41,0 -5.42,8.4 0,8.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3850",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2692.77,1006.79 c 10.76,-4.53 13.36,-18.38 5.32,-26.79 -1.92,-2 -3.8,-4.039 -5.82,-5.949 -6.2,-5.891 -19.21,-4.199 -20.83,5.508 -0.67,4.023 -1.08,8.082 -1.56,12.132 -1.41,12.019 13.19,19.199 22.89,15.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3852",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2771.26,1217.49 c 26.67,0 26.72,-41.45 0,-41.45 -26.67,0 -26.71,41.45 0,41.45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3854",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3146.04,1438.28 c 24.15,0 24.19,-37.53 0,-37.53 -24.15,0 -24.19,37.53 0,37.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3856",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3094.75,1406.23 0.66,1.59 c 2.62,6.3 7.75,11.96 15.28,11.62 7.61,-0.33 12.46,-4.86 15.28,-11.62 l 0.65,-1.59 c 4.22,-10.16 -6.2,-20.92 -15.93,-20.92 -9.78,0 -20.14,10.79 -15.94,20.92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3858",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3109.81,1522 c 1.3,0.95 2.55,1.55 3.99,2.25 9.89,4.84 22.34,-0.93 22.34,-12.81 0,-11.88 -12.45,-17.65 -22.34,-12.82 -1.44,0.71 -2.69,1.31 -3.99,2.26 -7.79,5.77 -7.79,15.35 0,21.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3860",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3039.7,1506.33 c 2.59,1.31 4.19,2.92 7.24,3.76 1.08,0.28 2.16,0.24 3.23,0.32 13.2,7.45 27.88,-7.66 20.54,-20.75 -2.9,-5.17 -7.18,-9.28 -12.65,-11.6 -7.85,-3.31 -15.55,-0.16 -21.31,5.4 -6.43,6.2 -5.42,18.67 2.95,22.87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3862",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2997.55,1569.38 c 9.96,0 19.5,-8.76 19.04,-19.04 -0.46,-10.33 -8.37,-19.06 -19.04,-19.06 -9.96,0 -19.51,8.76 -19.06,19.06 0.47,10.31 8.37,19.04 19.06,19.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3864",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2954.61,1599.51 c 1.67,10.97 12.94,19.25 21.01,25.78 8.53,6.9 21.48,8.96 29.71,0 8.36,-9.11 7.4,-20.55 0,-29.71 -2.75,-3.4 -5.37,-7.47 -8.55,-10.49 -4.64,-4.4 -10.99,-9.57 -17.23,-10.52 -7.39,-1.13 -14.16,-0.36 -19.73,5.21 -5.57,5.58 -6.34,12.33 -5.21,19.73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3866",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2923.3,1593.85 c 13.53,0 24.3,-16.2 16.2,-28.24 l -0.86,-1.27 c -7.68,-11.43 -23.01,-11.43 -30.69,0 l -0.86,1.27 c -8.1,12.04 2.66,28.24 16.21,28.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3868",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2918.36,1673.5 1.06,0.52 c 7.02,3.39 15.19,1.87 19.46,-5.11 2.48,-4.05 3.22,-7.87 3.81,-12.51 1.33,-10.48 -14.47,-16.42 -21.04,-8.71 l -1.16,1.24 -1.07,0.53 c -4.48,2.13 -6.93,7.59 -7.04,12.28 l -0.03,1.29 c -0.09,3.99 2.31,8.68 6.01,10.47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3870",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2841.21,1618.78 c 3.18,11.55 19.03,17.16 28.02,8.51 4.53,-2.2 7.92,-6.09 8.54,-11.34 0.76,-6.43 -2.14,-10.98 -7.09,-14.79 -2.28,-1.76 -5.24,-3.32 -8.1,-3.73 -6.36,-0.91 -12.1,-0.35 -16.9,4.46 -4.38,4.37 -6.11,10.92 -4.47,16.89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3872",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2838.44,1685.67 c 19.46,0 19.5,-30.25 0,-30.25 -19.47,0 -19.5,30.25 0,30.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3874",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2891.94,1787.82 c 2.88,10.46 10.49,16.4 20.15,20.15 0.91,0.35 1.81,0.7 2.71,1.05 18.74,7.26 41.09,-15.08 33.83,-33.82 -0.35,-0.91 -0.7,-1.81 -1.05,-2.71 -3.74,-9.67 -9.69,-17.28 -20.15,-20.15 -9.93,-2.74 -20.79,0.14 -28.07,7.41 -7.27,7.28 -10.15,18.15 -7.42,28.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3876",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3124.91,1719.97 c 6.93,7.79 21.14,7.59 28.13,0 6.93,-7.56 8.3,-20.75 0,-28.13 -6.87,-6.1 -13.38,-13.18 -23.34,-12.85 -9.78,0.33 -17.31,7.82 -17.64,17.64 -0.33,10.01 6.73,16.45 12.85,23.34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3878",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3078.87,1811.76 c 27.03,0 27.08,-42.01 0,-42.01 -27.04,0 -27.08,42.01 0,42.01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3880",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3031.97,1743.83 c 1.81,11.92 17.41,19.54 28.25,16.04 12.99,-4.2 17.98,-15.48 16.04,-28.25 0.34,3.57 0.57,4.13 0.71,1.67 1.32,-11.99 -11.5,-23.48 -22.97,-22.97 -13.56,0.61 -21.55,10.13 -22.97,22.97 -0.39,3.55 0.4,7.02 0.94,10.54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3882",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3184.94,1665.68 c 25.59,0 25.62,-39.77 0,-39.77 -25.6,0 -25.63,39.77 0,39.77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3884",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3189.19,1599.09 c 9.56,5.05 21.09,2.3 26.81,-7.04 2.82,-4.58 5.7,-10.39 5.45,-15.91 -0.24,-5.34 -2.05,-10.1 -4.39,-14.85 -5.42,-10.98 -23.14,-10.66 -28.65,0 l -1.23,2.16 c -0.53,0.68 -1.21,1.57 -2.16,2.82 -0.82,1.89 -1.32,3.03 -1.64,3.82 l -1.23,2.17 c -5.36,8.75 -2.19,21.94 7.04,26.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3886",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3206.15,1538.57 c 10.67,0 18.77,-10.55 15.94,-20.92 -0.45,-1.64 -0.91,-3.28 -1.36,-4.93 -3.93,-14.39 -25.22,-14.4 -29.16,0 -0.46,1.65 -0.91,3.29 -1.36,4.93 -2.84,10.37 5.24,20.92 15.94,20.92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3888",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3245.38,1491.24 8.49,1.25 c 8.42,1.26 16.9,-3.49 16.9,-12.88 0,-9.29 -8.47,-14.13 -16.9,-12.87 l -8.49,1.26 c -11.5,1.72 -11.5,21.52 0,23.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3890",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3315.76,1448.11 c 14.05,0 14.07,-21.85 0,-21.85 -14.06,0 -14.08,21.85 0,21.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3892",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3279.22,1550.17 c 1.55,3.54 5.62,7.15 9.85,6.62 1.54,-0.18 3.07,-0.48 4.61,-0.71 4.25,0.32 8.06,-1.12 11.89,-3.54 7.5,-4.72 9.69,-14.64 4.16,-21.81 -5.02,-6.52 -16.29,-8.36 -22.14,-1.5 -2.41,2.81 -4.29,5.27 -5.45,8.21 l -0.7,0.95 c -2.8,3.4 -4.1,7.51 -2.22,11.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3894",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3227.36,1616.35 c 21.27,0 21.3,-33.04 0,-33.04 -21.26,0 -21.3,33.04 0,33.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3896",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3276.86,1654.69 c 8.35,0 16.35,-7.34 15.97,-15.96 -0.39,-8.66 -7.02,-15.97 -15.97,-15.97 -8.35,0 -16.34,7.34 -15.96,15.97 0.39,8.65 7.02,15.96 15.96,15.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3898",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3206.01,1727.82 c 4.84,3.11 10.96,3.39 16.41,2.15 7.78,-1.78 12.06,-8.01 14.86,-14.88 3.24,-7.91 -1.45,-17.6 -7.62,-22.37 -9.99,-7.72 -24.84,-5.03 -31.28,5.98 -5.98,10.21 -2.05,22.88 7.63,29.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3900",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3257.69,1721.68 c 1.07,7.89 8.05,11.39 15.37,10.25 8.92,-1.4 17,-3.7 20.6,-12.74 1.56,-3.93 -1.02,-9.49 -4.64,-11.38 -6.87,-3.61 -12.2,-0.85 -19.23,-0.09 -7.32,0.8 -13.18,6.01 -12.1,13.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3902",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3306.86,1764.24 c 0.91,0.29 1.21,0.35 1.3,0.35 l 1.15,0.49 c 1.55,0.9 3.23,1.36 5.01,1.36 l 0.51,0.07 c 7.55,1.18 14.44,-0.26 19.37,-6.62 4.63,-6.01 4.98,-13.85 1.43,-20.52 -2.99,-5.66 -7.46,-9.46 -13.23,-11.99 -11.01,-4.81 -23.5,-2.46 -28.61,9.65 -4.79,11.33 1.51,23.55 13.07,27.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3904",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3314.83,1766.51 h -0.06 c 2.88,0.38 2.83,0.37 0.06,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3906",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3287.31,1790.09 c 3.37,6.91 9.34,10.66 17.05,12.8 5.59,1.55 11.72,-0.09 15.81,-4.18 4.45,-4.44 5.12,-9.9 4.18,-15.81 -1.37,-8.59 -8.46,-14.22 -16.48,-16.4 -9.66,-2.64 -18.56,3.28 -21.71,12.32 l -0.08,-0.08 c -2.36,3.45 -1.42,8.26 1.23,11.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3908",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3240.95,1828.57 0.75,0.48 c 3.93,2.52 9.82,2.52 13.76,0 l 0.75,-0.48 c 12.38,-7.93 7.75,-28.18 -7.63,-28.18 -15.38,0 -20.07,20.22 -7.63,28.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3910",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3241.5,1862.88 c 1.81,0 1.81,-2.81 0,-2.81 -1.79,0 -1.79,2.81 0,2.81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3912",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3354.65,1847.85 v -1.03 1.03"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3914",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3326.98,1428.59 c 5.2,8.06 13.83,11.22 23.12,9.4 6.19,-1.2 12.28,-5.53 16.46,-10.1 8.82,-9.62 8.41,-24.4 -2.21,-32.6 -9.85,-7.62 -25.96,-5.58 -32.1,6.12 l -0.31,0.67 -1.76,1.7 c -6.14,6.23 -8.11,17.19 -3.2,24.81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3916",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3244.76,1392.24 c 10.11,7.81 29.15,6.61 34.98,-6.68 2.91,-6.65 4.45,-10.97 4.81,-18.28 1.11,-22.02 -30.57,-29.94 -41.18,-11.5 l -1.02,0.93 c -10.96,9.32 -7.97,27.51 2.41,35.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3918",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3219.05,1366.3 c 3.45,4.1 6.9,8.2 10.34,12.29 7.49,8.89 23.68,8.29 31.3,0 7.54,-8.21 9.45,-23.33 0,-31.29 -4.1,-3.46 -8.19,-6.9 -12.28,-10.35 -8.29,-6.99 -21.33,-8.74 -29.36,0 -8.14,8.87 -7.5,20.47 0,29.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3920",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3204.36,1376.65 c 0.89,1.85 1.78,3.69 2.67,5.52 0.97,2.01 4.35,2.01 5.31,0 0.89,-1.83 1.78,-3.67 2.67,-5.52 1.98,-4.11 -0.37,-9.26 -5.32,-9.26 -4.96,0 -7.31,5.15 -5.33,9.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3922",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3418.29,1504.72 c 11.28,0 22.09,-9.92 21.57,-21.56 -0.53,-11.69 -9.48,-21.57 -21.57,-21.57 -11.28,0 -22.09,9.92 -21.56,21.57 0.51,11.68 9.47,21.56 21.56,21.56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3924",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3468.44,1454.22 c 8.62,7.91 24.12,10.01 33,0.97 9.01,-2.34 16.36,-12.6 15.95,-21.77 -0.44,-9.95 -6.75,-19.47 -16.77,-22.03 -12.33,-3.15 -22.85,0.68 -32.18,8.77 -9.55,8.28 -9.13,25.69 0,34.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3926",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3544.54,1497.95 1.68,-0.31 c 9.19,-1.74 16.82,-12.39 16.41,-21.56 -0.41,-9.28 -6.57,-19.69 -16.41,-21.55 l -1.68,-0.33 c -14.32,-2.7 -28.72,6.35 -28.72,21.88 0,15.43 14.39,24.59 28.72,21.87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3928",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3612.75,1487.67 c 3.03,0 6.34,0.08 9.28,-0.73 3.44,-0.95 5.85,-3.27 8.57,-5.38 4.99,-3.88 4.96,-14.17 0,-18.02 -2.72,-2.12 -5.13,-4.44 -8.57,-5.39 -2.94,-0.8 -6.25,-0.72 -9.28,-0.72 -8.17,0 -15.12,6.94 -15.12,15.11 0,8.21 6.92,15.13 15.12,15.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3930",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3599.48,1459.28 c 6.9,-8.32 14.98,-19.78 26.62,-20.3 5.6,-0.25 11.68,4.33 12.88,9.8 1.53,6.96 -1,12.22 -3.84,18.37 -0.59,1.27 -1.17,2.55 -1.72,3.83 l -0.26,0.58 c -0.79,1.98 -1.57,3.97 -2.31,5.97 -4.17,11.21 -16.58,17.65 -27.57,11.22 -11.07,-6.48 -11.41,-20.28 -3.8,-29.47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3932",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3506.69,1597.1 c 11.04,0 22.35,-12.03 17.82,-23.39 l -0.63,-1.6 c -2.85,-7.12 -8.81,-13.46 -17.19,-13.08 -8.5,0.38 -14.14,5.44 -17.2,13.08 l -0.63,1.6 c -4.55,11.39 6.82,23.39 17.83,23.39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3934",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3460.72,1559.12 c 15.86,0 15.88,-24.64 0,-24.64 -15.86,0 -15.89,24.64 0,24.64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3936",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3414.74,1600.09 2.85,-0.6 c 7.97,-1.69 10.09,-12.39 4.69,-17.79 -5.4,-5.41 -16.1,-3.28 -17.79,4.69 l -0.6,2.84 c -1.43,6.78 4.08,12.29 10.85,10.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3938",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3400.68,1679.4 c 5.44,2.29 11,2.11 16.18,-0.84 3.13,-1.77 4.97,-4.54 5.89,-7.65 0.29,-0.67 0.61,-1.49 1.01,-2.59 0.21,-1.12 0.18,-1.31 -0.07,-0.75 4.09,-10 -0.12,-21.85 -11.24,-24.92 -11.4,-3.13 -22.31,5.7 -22.69,17.29 -0.26,8.18 3,16.11 10.92,19.46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3940",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3573.97,1597.43 0.81,1.29 c 6.16,9.89 20.3,9.89 26.45,0 l 0.8,-1.29 c 6.56,-10.56 -1.97,-24.45 -14.02,-24.45 -12.06,0 -20.6,13.89 -14.04,24.45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3942",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3633.96,1656.51 c 4.69,0 4.7,-7.29 0,-7.29 -4.67,0 -4.68,7.29 0,7.29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3944",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3559.72,1640.93 c 15.14,0 24.69,-16.87 17.17,-29.92 -1.95,-3.39 -3.76,-6.61 -6.46,-9.51 -5.43,-5.84 -15.99,-5.84 -21.42,0 -2.67,2.86 -4.52,6.14 -6.46,9.51 -7.53,13.05 2.03,29.92 17.17,29.92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3946",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3763.27,1484.17 c 3.11,7.37 10.86,13.3 19.2,12.91 7.32,-0.32 14.35,-3.94 18.13,-10.4 5.01,-8.56 2.86,-18.31 -3.28,-25.45 l -0.82,-0.95 c -6.62,-7.72 -21.46,-7.7 -28.07,0 l -0.81,0.95 c -5.61,6.53 -7.79,14.8 -4.35,22.94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3948",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3779.11,1392.8 c 1.07,0.41 2.18,0.67 3.32,0.78 8.49,1.41 17.01,-3.62 17.01,-12.96 0,-9.27 -8.52,-14.38 -17.01,-12.97 -1.14,0.12 -2.25,0.38 -3.32,0.79 -11.98,3.74 -12,20.61 0,24.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3950",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3724.42,1392.34 c 1.01,-1.04 2.26,-1.92 3.91,-2.49 2.86,-1 5.76,-0.43 8.38,0.97 2.91,1.56 5.06,5.19 4.88,8.51 -0.16,2.98 -1.05,5.56 -2.72,8.02 -4.27,6.29 -13.14,7.42 -18.01,1.1 -4.43,-5.72 -2.07,-12.81 3.56,-16.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3952",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3712.15,1328.81 0.42,1.65 c 4.21,16.66 29.52,16.67 33.73,0 l 0.42,-1.65 c 2.85,-11.27 -5.52,-22.68 -17.29,-22.68 -11.73,0 -20.13,11.41 -17.28,22.68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3954",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3738.14,1262.05 c 9.05,-9.04 -0.25,-23.1 -11.99,-20.6 l -2.41,0.52 c -2.6,0.55 -5.12,3.07 -5.68,5.67 l -0.51,2.42 c -2.49,11.69 11.56,21.02 20.59,11.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3956",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3662.25,1361.33 c 25.24,0 25.28,-39.21 0,-39.21 -25.23,0 -25.27,39.21 0,39.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3958",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3637.51,1285.26 c 4.68,0 4.69,-7.28 0,-7.28 -4.69,0 -4.7,7.28 0,7.28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3960",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3610.64,1270.8 c 4.25,6.35 7.96,13.06 11.15,20.01 3.97,8.69 17.2,11.49 24.9,6.53 8.84,-5.69 10.96,-15.7 6.53,-24.9 -6.82,-14.16 -20.45,-42.07 -40.04,-31.01 -5.35,3.02 -8.14,9.21 -8.14,15.16 0,5.9 2.53,9.62 5.6,14.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3962",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3570.32,1335.17 v -1.02 1.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3964",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3504.74,1307.5 c 1.11,2.41 2.2,4.81 3.31,7.21 1.32,2.91 5.92,0.35 4.34,-2.54 l -3.77,-6.93 c -1.4,-2.58 -5.05,-0.31 -3.88,2.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3966",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3796.11,1331.71 c 2.95,6.98 10.28,12.58 18.18,12.22 15.26,-0.68 23.89,-16.59 17.38,-29.18 -2.55,-8.51 -13.54,-12.8 -21.46,-10.77 -3.64,0.93 -7.48,3.14 -9.99,6.01 -5.36,6.11 -7.34,14.06 -4.11,21.72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3968",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3877.93,1402.25 c 18.74,0 18.78,-29.12 0,-29.12 -18.74,0 -18.77,29.12 0,29.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3970",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3910.36,1348.74 1.38,0.67 c 11.38,5.56 25.7,-1.08 25.7,-14.76 0,-13.68 -14.32,-20.31 -25.7,-14.74 l -1.38,0.66 c -10.65,5.21 -10.65,22.96 0,28.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3972",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3899.74,1295.77 c -0.31,-5.28 -0.65,-9.75 -4.66,-13.62 -3.65,-3.5 -9.43,-3.51 -13.08,0 -4.01,3.87 -4.36,8.34 -4.67,13.62 -0.85,14.41 23.26,14.43 22.41,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3974",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3970.42,1417.41 c 2.14,-1.08 4.1,-2.83 5.92,-4.39 12.14,-10.45 5.31,-31.56 -9.32,-35.29 1.13,0.49 2.27,0.98 3.4,1.46 -14.62,-7.91 -33.29,1.92 -33.29,19.11 0,17.59 18.57,26.47 33.29,19.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3976",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4039.35,1238.6 c 2.49,5.89 8.7,10.62 15.37,10.33 14.73,-0.66 21.87,-17.72 11.88,-28.69 l -0.85,-0.93 c -5.49,-6.02 -16.58,-6.02 -22.08,0 l -0.84,0.93 c -4.61,5.06 -6.17,11.97 -3.48,18.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3978",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4061.19,1181.24 c 4.18,1.73 6.99,-0.63 8.46,-4.5 2.77,-7.34 -11.56,-7.03 -8.65,0 l 0.1,0.25 c -2.04,0.87 -1.94,3.41 0.09,4.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3980",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4010.94,1232.49 c 0.21,1.34 2.49,1.34 2.7,0 l 2.16,-13.54 c 0.94,-5.88 -7.97,-5.91 -7.02,0 0.72,4.51 1.43,9.02 2.16,13.54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3982",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3978.58,1250.24 c 11.74,15.2 30.38,1.71 39.31,-8.98 6.84,-8.2 7.24,-19.76 -1.82,-26.75 -8.83,-6.82 -20.31,-3.86 -26.34,5.03 l -1.85,2.57 -1.24,1.37 -1.39,1.24 -1.16,0.7 c -8.51,5.63 -12.19,16.18 -5.51,24.82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3984",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3966.33,1175.48 c 9,0 9.02,-14 0,-14 -9.02,0 -9.04,14 0,14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3986",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4047.64,1118.74 c 13.34,0 13.36,-20.73 0,-20.73 -13.33,0 -13.35,20.73 0,20.73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3988",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4042.43,1089.47 c 2.9,-0.96 5.77,-2.12 8.75,-2.82 10.1,-2.32 20.57,4.28 20.77,15.14 l 0.01,-0.01 -0.01,0.02 0.01,0.03 c 0.04,2.33 -0.72,4.55 -1.79,6.62 -1.4,3.4 -3.39,6.44 -5.6,9.82 -7.48,11.47 -23.68,13.16 -32.33,1.98 -8.66,-11.21 -2.83,-26.5 10.19,-30.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3990",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3913.46,1156.11 c 1.18,9.04 7.2,17.97 17.51,17.51 10.5,-0.47 16.24,-7.75 17.51,-17.51 0.23,-1.77 0.46,-3.55 0.69,-5.31 1.24,-9.49 -9.26,-18.61 -18.2,-18.21 -8.81,0.4 -19.53,8.1 -18.21,18.21 0.23,1.76 0.46,3.54 0.7,5.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3992",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3890.62,1229.66 c 1.6,0.61 3.2,1.21 4.8,1.82 8.67,3.28 17.73,-5.05 17.73,-13.51 0,-8.46 -9.08,-16.77 -17.73,-13.49 -1.6,0.6 -3.2,1.21 -4.8,1.81 -11.45,4.34 -11.47,19.03 0,23.37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3994",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3853.18,1158.64 c 10.09,0 10.11,-15.69 0,-15.69 -10.1,0 -10.11,15.69 0,15.69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3996",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3877.93,1113.13 c 6.13,0 6.14,-9.52 0,-9.52 -6.12,0 -6.13,9.52 0,9.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3998",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3839.35,1043.05 c 0.66,2.58 1.37,4.98 2.46,7.42 5,11.29 22.95,-2.34 13.18,-10.17 -1.48,-1.18 -2.68,-2.66 -3.93,-4.06 -4.83,-5.41 -13.34,0.35 -11.71,6.81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4000",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3909.75,1018.33 c 11.54,0 11.56,-17.92 0,-17.92 -11.53,0 -11.55,17.92 0,17.92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4002",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3969.49,1017.86 c 4.95,9.75 19.09,10.69 26.4,3.39 7.3,-7.3 6.34,-21.441 -3.41,-26.391 -7.2,-3.64 -15.99,-6.097 -22.54,0.461 -6.54,6.55 -4.1,15.34 -0.45,22.54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4004",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3925.37,988.34 c 2.29,-1.199 4.58,-2.391 6.86,-3.59 9.52,-4.988 10.6,-18.699 3.34,-25.961 -7.24,-7.238 -20.96,-6.148 -25.94,3.352 -1.2,2.289 -2.4,4.57 -3.61,6.859 -6.64,12.66 6.67,25.992 19.35,19.34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4006",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3748.22,1133.27 c 0.2,1.44 0.39,2.9 0.59,4.34 0.56,4.54 3.19,9.37 7.32,11.32 11.91,5.64 22.38,1.29 29.61,-9.17 7.51,-10.87 -0.22,-26.36 -12.05,-29.62 -12.01,-3.31 -26.4,6.23 -25.53,19.44 0.08,1.24 -0.01,2.45 0.06,3.69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4008",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3707.41,1126.05 c 0.97,7.52 4.01,13.79 11.37,16.89 6.55,2.77 15.17,1.63 20.18,-3.81 4.42,-4.81 6.53,-11.58 4.76,-17.99 -2.38,-8.67 -9.59,-12.51 -17.82,-13.58 -1.18,-0.14 -2.36,-0.3 -3.54,-0.45 -7.58,-0.97 -16.38,7.88 -15.41,15.4 0.16,1.19 0.3,2.36 0.46,3.54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4010",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3648.11,1124.44 c 10.26,0 20.08,-9.02 19.6,-19.6 -0.47,-10.63 -8.61,-19.61 -19.6,-19.61 -10.25,0 -20.07,9.02 -19.61,19.61 0.48,10.61 8.62,19.6 19.61,19.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4012",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3457.29,1252.12 c 0.51,3.73 1.52,7.23 2.49,10.85 2.55,9.38 12.17,17.32 22.15,16.87 10.11,-0.46 19.42,-6.81 22.15,-16.87 0.99,-3.61 1.99,-7.13 2.49,-10.85 0.98,-7.24 -0.34,-13.05 -3.58,-19.68 -7.78,-15.92 -34.33,-15.92 -42.11,0 -3.23,6.61 -4.56,12.38 -3.59,19.68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4014",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3393.99,1252.2 1.69,2.55 c 4.2,6.3 12.74,6.3 16.94,0 l 1.69,-2.55 c 5.02,-7.57 -1.64,-17.7 -10.16,-17.7 -8.53,0 -15.19,10.13 -10.16,17.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4016",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3339.08,1293.84 c 3.74,6.07 8.58,10.31 15.79,11.52 6.2,1.03 12.17,0.7 18.24,-1 7.82,-2.19 12.7,-9.9 11.63,-17.83 -0.98,-7.33 -7.9,-14.88 -15.95,-14.08 -1.34,0.13 -2.63,0.15 -3.96,0.13 l -1.61,-0.38 c -3.6,-1.18 -7.09,-1.35 -10.82,-1.56 -11.68,-0.67 -19.23,13.6 -13.32,23.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4018",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3297.31,1212.66 c 3.82,-7.67 10.37,-10.39 18.45,-11.21 7.34,-0.73 13.85,5.68 15.93,12.14 2.27,7.01 -1.57,14.96 -7.59,18.66 -3.44,2.11 -6.87,2.98 -10.7,3.47 l -0.38,0.12 -0.48,0.14 -1.17,0.98 c -7.6,5.49 -16.38,-2.1 -17.04,-9.77 -0.43,-5.05 0.74,-10.02 2.98,-14.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4020",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3230.8,1312.43 c 6.94,7.05 17.53,8.9 26.12,2.26 8.88,-6.85 10.72,-21.21 1.98,-29.26 -5.86,-5.41 -11.62,-7.59 -19.52,-8.42 -9.28,-0.99 -17.38,7.93 -18.51,16.33 -1.11,8.23 3.03,15.32 9.93,19.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4022",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3188.06,1264.69 c 3.56,-4.23 10.45,-5.55 15.55,-4.11 l 0.71,0.23 1.9,0.25 c 3.31,1.07 6.01,2.81 8.65,5.04 1.88,1.59 3.41,3.47 5.34,5 7.79,6.14 7.02,19.02 1.56,26.1 -5.86,7.59 -17.22,10.37 -25.66,5.13 -6.38,-3.98 -11.66,-9.08 -13.77,-16.51 -2.34,-8.27 0.56,-14.98 5.72,-21.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4024",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3148.69,1249.51 c 1.12,0.17 2.26,0.36 3.38,0.53 6.33,1.01 6.37,-8.57 0,-7.55 -1.12,0.17 -2.26,0.36 -3.38,0.53 -3.21,0.51 -3.21,5.97 0,6.49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4026",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3142.51,1351.39 c 12.45,0 24.38,-10.95 23.81,-23.81 -0.58,-12.9 -10.46,-23.81 -23.81,-23.81 -12.45,0 -24.39,10.96 -23.81,23.81 0.58,12.9 10.46,23.81 23.81,23.81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4028",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3081.31,1213.56 c 5.57,2.26 10.67,3.04 16.69,1.3 17.83,-5.16 17.86,-31.03 0,-36.19 -5.88,-1.7 -11.17,-0.93 -16.69,1.3 -6.96,2.81 -13.16,8.58 -12.79,16.79 0.37,8.32 5.33,13.78 12.79,16.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4030",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3019.4,1246.45 c 1.27,9.17 13.53,12.49 20.57,8.37 7.7,-4.51 9.27,-15.64 2.83,-21.99 -1.41,-1.4 -2.81,-2.8 -4.25,-4.17 -3.44,-3.34 -8.65,-4.43 -13.06,-2.48 -3.92,1.72 -7.96,6.26 -7.36,10.93 0.39,3.12 0.83,6.23 1.27,9.34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4032",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2987.11,1198.45 c 3.09,5.29 8.65,9.57 14.57,11.2 8.93,2.46 16.9,-0.52 23.7,-6.27 1.81,-1.51 3.44,-3.12 5.03,-4.86 6.52,-7.2 9.11,-18.74 3.52,-27.39 -5.15,-8 -15.89,-13.83 -25.51,-10.39 -2.23,0.8 -4.44,1.42 -6.74,1.92 -15.55,3.33 -22.15,22.83 -14.57,35.79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4034",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3212.58,1153.69 c 5.74,-6.26 8.49,-15.07 6.19,-23.43 -2.78,-10.09 -12.68,-17.84 -23.22,-17.69 -1.89,0.02 -3.77,0.05 -5.66,0.08 -10.03,0.15 -18.21,8.29 -18.35,18.35 -0.03,1.89 -0.06,3.77 -0.09,5.65 -0.29,20.38 26.91,32.52 41.13,17.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4036",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3160.18,1060.97 c 13.71,-0.61 21.93,-17.46 11.49,-27.72 l -1.78,-1.76 c -5.31,-5.23 -14.08,-5.25 -19.4,0 l -1.79,1.76 c -9.75,9.58 -2.75,28.37 11.48,27.72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4038",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3195.09,991.68 0.76,1.332 c 7.54,13.058 27.21,13.058 34.74,0 l 0.77,-1.332 c 7.96,-13.77 -2.15,-31.598 -18.14,-31.598 -15.98,0 -26.1,17.828 -18.13,31.598"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4040",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3067.78,1071.66 c -0.29,10.38 6.85,19.84 18.16,19.84 11.52,0 21.64,-11.89 17.82,-23.4 -2.59,-7.82 -7.53,-14.81 -15.93,-16.95 -9.41,-2.39 -21.72,4.83 -20.66,15.74 0.14,1.6 0.37,3.19 0.61,4.77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4042",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3078.87,1088.14 c 19.46,0 19.49,-30.24 0,-30.24 -19.47,0 -19.5,30.24 0,30.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4044",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3258,1101.72 c 4.75,8.13 15.48,12.87 24.67,10.04 1.49,-0.46 2.97,-0.92 4.46,-1.37 8.51,-2.63 15.53,-12.41 12.23,-21.55 -0.47,-1.32 -0.95,-2.63 -1.43,-3.95 -3,-8.32 -9.17,-14.45 -18.17,-15.66 -8.28,-1.1 -17.68,2.73 -21.76,10.43 -3.61,6.84 -3.98,15.26 0,22.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4046",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3300.35,1221.36 c 1.68,-0.32 3.35,-0.65 5.03,-0.98 8.55,-1.68 15.67,-11.5 15.28,-20.08 -0.38,-8.69 -6.11,-18.27 -15.28,-20.08 -1.68,-0.32 -3.35,-0.65 -5.03,-0.99 -13.78,-2.7 -27.66,6.18 -27.66,21.07 0,14.79 13.87,23.78 27.66,21.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4048",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3379.4,1094.74 v -1.02 1.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4050",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3391.08,1068.74 c 12.2,9.42 27.29,3.25 33.1,-9.66 l 0.36,-0.44 c -0.94,2.58 -0.26,1.04 0.22,-0.28 1.14,-1.13 2.21,-2.3 3.05,-3.69 0.93,-1.57 1.58,-3.22 1.96,-4.98 1.33,-5.45 0.2,-12.09 -4.21,-15.97 -9.74,-8.56 -21.72,-5.67 -32.3,-0.54 -13.94,6.76 -13.32,26.94 -2.18,35.56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4052",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3494.86,1126.08 c 1.74,1.53 3.75,2.61 6.07,3.15 1.24,0.29 2.58,0.41 3.93,0.51 l 0.69,0.09 0.54,0.02 c 5.04,0.45 9.98,-1.23 13.23,-5.78 4.18,-4.59 5.33,-11.53 4.24,-17.47 -0.53,-2.92 -1.85,-5.65 -3.24,-8.27 -6.66,-12.51 -24.61,-12.6 -32.79,-2.01 -8.24,10.68 -3.51,23.97 7.33,29.76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4054",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3496.58,1065.38 c 6.48,12.66 24.72,12.46 32.79,2.01 8,-10.36 3.77,-23.67 -6.73,-29.52 -3.83,-3.88 -8.8,-6 -14.63,-5.22 -6.21,0.83 -13.3,5.74 -14.42,12.41 -1.28,7.62 -0.52,13.44 2.99,20.32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4056",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3488.73,1004.27 c 9.15,5.35 22.5,-1.37 21.91,-12.579 -0.09,-1.871 -0.19,-3.742 -0.3,-5.609 -0.42,-8.113 -9.6,-15.023 -17.25,-9.891 -1.45,0.969 -2.91,1.95 -4.36,2.93 -8.93,5.981 -9.88,19.371 0,25.149"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4058",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3510.22,981.602 v -1.032 1.032"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4060",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3580.94,1110.85 c 9,0 15.86,-5.81 18.6,-13.44 2.75,-4.66 3.75,-10.67 2.23,-15.37 -2.56,-7.9 -9.83,-14.31 -18.5,-14.08 -10.21,0.27 -19.79,6.95 -21.79,17.38 -2.42,12.71 5.66,25.51 19.46,25.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4062",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3612.75,1041.7 v -1.02 1.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4064",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3704.69,1038.17 v -1.03 1.03"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4066",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3704.69,1053.9 c 3.53,0.34 7.07,0.67 10.6,1.02 5.91,0.56 11.75,-4.67 13.23,-10.08 1.63,-5.93 -1.11,-12.32 -6.3,-15.5 -3.12,-1.9 -6.23,-3.81 -9.34,-5.71 -8.99,-5.5 -21.13,-0.22 -23.86,9.7 -2.97,10.76 5.3,19.58 15.67,20.57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4068",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3876.95,1952.65 0.04,-0.01 -0.04,0.01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4070",
    style: {
      fill: "#f03747",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4211.83,1404.5 c -71.69,0 -143.4,-90.35 -194.61,-11.3 -22.32,32.81 -6.78,59.63 15.15,80.52 l -2.4,1.49 c 4.07,3.34 8.18,7.75 11.05,10.24 2.04,1.77 3.41,3.87 4.5,6.07 -22.92,-3.65 -44.2,6.51 -55.05,35.3 -26.06,-14.07 -44.4,-51.27 -30.22,-81.84 7.12,-15.36 20.16,-24.97 33.45,-33 1.03,-0.63 2.04,-1.31 3.05,-1.98 -22.6,-10.68 -33.35,-32.59 -47.42,-53.42 -6.07,-0.65 -11.7,-1.53 -17.27,-2.99 -6.08,5.29 -12.14,8.22 -20.25,7.17 -7.91,-1.03 -14.83,-5.56 -19.02,-13.22 -3.51,-6.42 -4.78,-13.89 -4.43,-21.54 -9.63,-8.5 -19.15,-17.29 -28.53,-26.36 -0.89,1.11 -1.62,2.25 -2.57,3.33 -2.02,2.3 -6.29,5.57 -11.52,9.28 -1.31,13.24 -9.81,26.4 -20.23,32.46 5.07,2.79 9.94,6.12 14.36,9.87 24.73,-4.23 43.39,18.2 50.62,47.74 2.06,8.4 -4.88,17.2 -12.87,14.67 -4.04,-1.27 -23.74,-12.3 -25.46,-10.65 -1.88,1.8 -3.97,3.24 -6.13,4.5 4.74,11.92 4.48,24.36 -1.9,36.31 13.32,6.01 25.43,15.42 34.42,27.42 6.56,8.75 11.21,19.13 14.04,30.12 -6.08,-3.05 -12.27,-6.27 -18.77,-9.86 -20.49,-11.29 -20.49,-67.76 -61.46,-56.46 -30.73,0 20.48,79.05 -30.73,90.34 -10.24,0 -30.73,-22.58 -30.73,-33.88 0,-42.34 8.99,-104.49 -40.46,-112.14 2.47,-6.33 4.94,-12.69 7.51,-18.99 -0.61,-1.5 -1.32,-2.87 -1.83,-4.48 -2.23,-7.08 -4.46,-14.39 -6.65,-21.78 -6.8,2.58 -13.64,4.88 -20.53,6.95 -5.6,11.72 -18.28,19.74 -31.25,16.63 -5.71,-1.37 -12.4,-4.29 -19.32,-7.41 -5.45,0.3 -10.95,0.37 -16.48,0.17 -8.52,13.85 -18.23,18.56 -32.76,21.88 -13.66,3.13 -26.89,3.53 -38.54,-1.02 l 0.88,0.72 c -6.68,-2.35 -13.6,-4.59 -20.56,-6.37 -1.5,0.13 -5.09,0.13 -9.04,0.38 -0.08,0.94 -0.2,2.29 -0.4,4.52 -1.63,18.64 -2.79,36.09 -10.43,53.11 -1.04,2.32 -2.16,4.45 -3.35,6.48 -10.35,-6.35 -21.02,-10.94 -33.35,-6.41 20.49,-22.57 20.49,-56.45 0,-67.75 -24.46,-8.98 -29.47,39.13 -40.82,47.79 l -2.21,0.69 -0.74,0.59 c -2.18,0.27 -4.6,-0.77 -7.44,-3.89 -25.76,-28.4 -31.26,-65.72 -26.72,-103.54 7.83,6.99 13.77,15.76 17.65,25.66 14.94,-9.64 32.06,-18.93 49.9,-26.28 9.56,-7.19 18.95,-14.27 28.37,-19.19 26.58,-13.87 53.34,-16.59 82.02,-14.7 8.75,-7.96 19.33,-11.83 31.98,-11.64 8.19,0.12 16.02,1.98 23.45,5.07 -0.47,-3.12 -0.77,-6.26 -0.78,-9.41 -0.04,-6.46 0.9,-12.71 2.62,-18.56 -6.98,-1.31 -13.69,-3.12 -19.65,-6.1 -16.29,-8.2 -26.94,-23.76 -37.89,-38.74 -2.3,-3.17 -11.3,-15.51 -16.26,-24.62 -2.57,2.92 -5.12,5.87 -7.79,8.69 l -1.45,1.48 c 0.32,16.31 -4.54,33.46 -12.32,46.01 -5.27,8.49 -10.62,14.24 -18.92,17.19 -6.49,2.33 -14.51,2.55 -18.52,-5 -2.4,-4.5 -3.92,-9.41 -5.04,-14.49 -20.85,10.89 -43.56,15.38 -67.25,6.8 -3.99,-1.46 -7.55,-3.13 -10.77,-5.04 1,1.58 2.1,3.2 3.43,4.89 6.28,8.03 9.58,20.14 3.95,29.92 -1.23,2.13 -2.46,4.26 -3.68,6.39 -4.37,7.6 -11.04,13.24 -18.48,15.96 3.12,-13.7 7.22,-27.22 11.91,-40.14 -102.43,33.88 -40.98,-56.46 -81.94,-124.22 -30.74,45.17 -71.7,67.76 -122.92,33.88 10.24,-11.29 10.24,-11.29 20.48,-22.59 -20.48,0 -40.96,22.59 -61.45,11.3 10.24,-22.59 20.49,-56.46 10.24,-56.46 -61.45,-33.88 -102.43,-22.59 -133.16,-101.629 0,-3.09 -3.91,-4.442 -9.88,-4.379 -0.2,-3.321 -0.83,-6.121 -2.53,-7.813 0.62,0.61 -15.21,-1.629 -19.99,-4.597 -7.86,-4.872 -14.69,-16.411 -12.27,-26.633 l 0.74,-3.168 c 1.93,-8.11 8.55,-17.399 16.56,-18.852 21.25,-3.84 41.23,-3.297 56.68,15.36 12.53,15.113 15.74,37.703 21.7,56.371 l 0.28,1.16 c 3.03,3.59 7.34,7.019 10.75,10.019 6.42,5.633 13.6,10.451 19.57,16.661 5.63,5.84 11.47,12.5 16.81,19.72 3.39,2.13 6.77,4.37 10.15,6.75 2.81,1.96 6.22,4.69 10.04,7.76 2.88,-23.55 21.96,-34.42 43.23,-35.85 10.77,-0.72 15.99,17.41 6,22.92 -11.48,6.33 -16.2,12.64 -11.67,26.28 1.46,4.38 3.48,8.48 5.65,12.48 -0.17,-0.54 0.78,0.68 1.97,2.27 3.68,0.77 7.16,0.83 10.21,-0.23 16.81,-5.85 20.53,-26.3 46.59,-24.19 11,0.89 19.73,5.34 25.95,12.63 4.05,-4.91 9.22,-8.83 15.24,-11.11 30.29,-11.46 72.31,1.76 89.75,32.09 1.99,0.88 3.93,1.9 5.87,2.9 2.21,-2 4.63,-3.82 7.46,-5.2 1.05,-0.5 2.17,-0.82 3.26,-1.2 12.1,-22.16 37.23,-44.53 19.24,-62.26 -16.75,-16.518 -47.97,-13.63 -66.92,-29.85 -9.81,-8.379 -4.46,-27.539 6.83,-30.571 34.81,-9.32 88.88,-3.277 113.79,28.461 l 0.39,0.539 c 7.27,-2.339 16.08,-0.289 21.62,7.7 10.78,15.521 22.08,29.271 35.84,41.601 13.88,12.44 7.22,33.87 -4.46,43.81 -1.17,1 -2.29,2.14 -3.45,3.2 l 1.01,-0.25 c 25.22,-4.89 50.27,-5.69 74.73,3.51 17.44,6.56 31.02,18.69 45.18,29.91 8.22,-19.16 24.29,-37.31 35.06,-50.85 12.6,-15.83 23.26,-29.68 42.8,-34.89 22.62,-6.01 45.8,-0.34 68.28,-7.19 15.97,-4.85 29.94,14.23 21.89,30.36 -6.78,13.6 -16.01,21.89 -26.52,27.58 3.36,2.62 7.4,5.92 11.29,9.43 2.61,-2.85 5.68,-5.51 9.7,-7.64 10.93,-5.8 21.28,-8.61 31.39,-9.42 12.57,-5.56 26.67,-4.39 39.64,5.12 1.99,1.46 3.72,3.05 5.34,4.69 5.92,2.87 11.88,6.09 17.98,9.89 2.51,1.57 4.89,3.14 7.21,4.68 2.58,0.89 5.21,1.81 7.91,2.76 23.9,8.37 46.82,6.91 69.66,1.96 13.66,-6.77 27.23,-14.47 41.61,-17.47 l 1.9,-0.32 c 2.63,-21.63 19.14,-41.06 42.41,-32.46 15.98,5.91 19.57,8.02 23.44,4.24 -24.65,95.14 -124.66,52.54 -167.28,137.51 -14.02,-4.18 -41.53,-23.61 -61.6,-35.08 -4.74,8.75 -9.21,16.72 -18.18,22.54 0.53,1.54 1.09,3.05 1.59,4.59 4.24,0.97 8.67,2.63 13.3,5.24 19.71,11.07 35.7,26.73 52.2,41.31 9.41,-5.41 23.1,1.56 22.77,14.61 -0.03,1.14 -0.31,2.18 -0.53,3.26 5.04,3.55 10.36,6.71 15.87,9.54 l 1.1,-1.57 c 11.69,-13.75 24.32,-8.15 37.12,-14.82 7.15,-3.74 15.03,-3.79 21.59,-0.93 11.67,-6.77 23.78,-12.07 34.6,-10.91 5.01,16.92 9.53,31.97 14.02,45.39 -4.26,1.33 -8.89,1.27 -12.7,-0.66 -8.53,-4.3 -25.65,16.57 -32.49,22.04 -4.62,3.7 -9.34,4.71 -13.77,4.04 4.17,10.49 7.8,22.21 14.83,28.5 -2.58,-3.82 20.24,0.78 25.74,1.41 14.56,1.64 29.51,4.15 43.63,8.51 2.6,0.81 5.06,1.79 7.57,2.72 20.46,25.52 50.79,43.37 105.4,63.45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4072",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3648.48,1494.83 c -12.2,-8.96 -26,-10.76 -40.14,-9.74 10.82,-10.75 21.64,-21.51 32.46,-32.26 -5.27,-10.99 0.26,-28.28 12.49,-32.54 -9.82,22.15 -10.38,49.99 -4.81,74.54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4074",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4084.88,1252.82 c 4.27,10.73 -2.73,19.02 -11.26,21.67 -4.49,-13.42 -9.01,-28.47 -14.02,-45.39 9.98,1.06 18.87,7.6 25.28,23.72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4076",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4409.59,1330.99 -0.26,-0.81 c -0.62,0.8 -1.45,1.82 -2.62,3.21 -2.1,2.49 -4.95,4.68 -7.54,6.44 -4.87,3.31 -10.76,5.37 -16.26,7.54 3.74,6.14 7.22,13.17 11.08,21.29 2.32,4.85 -2.36,11.49 -7.16,8.15 -9.89,-6.88 -37.19,-1.03 -47.95,0.4 -10.74,1.43 -20.86,6.1 -30.54,11.74 1.96,7.7 3.13,15.72 3.88,23.64 1.51,15.96 -5.09,46.78 11.85,50.51 18.91,4.17 19.09,36.62 0.63,41.68 -19.76,5.42 -39.4,3.81 -53.43,-14.23 -15.61,-20.05 -11.25,-42.9 -16.57,-66.45 -3.15,-13.88 0.18,-12.13 -13.76,-13.75 -13.07,-1.53 -30.71,5.87 -43.79,8.2 -10.21,1.82 -20.48,3.33 -30.46,3.7 -1.55,4.04 -3.63,7.96 -6.31,11.63 -3.18,4.37 -5.33,10.22 -6.61,16.94 16.91,16.47 28.17,34.46 33.03,54.93 8.98,0.5 18.08,4.11 26.84,11.83 7.04,6.21 12.33,14.07 18.49,21.2 2.03,2.35 5.75,5.18 8.34,8.12 3.34,-0.62 6.66,-1.31 10.05,-1.8 37.06,-5.27 41.13,54.12 11,68.34 0.06,7.18 -0.05,14.4 -0.2,21.82 -0.16,7.25 0.49,14.53 0.08,21.75 -0.09,1.77 -1.32,6.74 -1.51,9.99 0.37,0.73 1.32,4.05 2.48,5.8 8.9,13.36 -7.44,28.79 -19.22,21.9 -1.05,-0.61 -5.81,-4.19 -7.66,-5.64 -1.16,-0.6 -7.05,-4.25 -7.81,-4.75 -8.96,-5.95 -14.44,-13.25 -18.68,-23.5 -5.13,-12.45 -8.75,-25.34 -12.34,-38.29 -10.56,-6.48 -18.32,-18.04 -22.13,-33.68 -18.35,-0.73 -36.93,-11.09 -53.24,-30.03 -32.43,-37.64 -43.13,-94.49 -26.65,-141.91 -6.35,-2.59 -13.9,-3.59 -21.93,-3.83 -2,21.55 -13.08,42 -31.53,55.17 -2.84,2.02 -5.83,3.73 -8.81,5.48 -21.93,-20.89 -37.47,-47.71 -15.15,-80.52 51.21,-79.05 122.92,11.3 194.61,11.3 -54.61,-20.08 -84.94,-37.93 -105.4,-63.45 1.86,0.68 3.78,1.27 5.61,2 6.12,-5.9 13.99,-9.94 22.56,-10.92 15.08,-1.71 27.23,5.21 41.91,6.66 14.96,1.5 29.61,-2.92 44.47,-3.31 h 0.47 c 1.52,-1.07 3.1,-2.07 4.84,-2.89 15.17,-7.2 30.59,-7.66 46.73,-10.21 4.92,-0.77 9.34,0.08 13.28,2.03 11.91,-3.17 24.22,-4.12 36.72,-3.89 l 1.08,-0.61 c 1.32,-5.63 4.6,-10.73 10.38,-14.09 l 2.65,-1.55 c 10.2,-5.94 19.78,-3.95 28.55,3.54 -3.34,-2.85 -1.39,-0.84 2.34,-3.1 4.52,-2.74 10.85,-5.28 15.83,-6.39 6.11,-1.36 12.91,-0.84 18.51,2.26 1.42,0.78 2.63,1.97 3.9,3.01 1.08,0.08 6.01,1.85 6.07,1.87 12.13,4.8 11.15,24.85 -2.74,25.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4078",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4045.52,1491.52 c 5.25,10.66 0.16,25.12 -8.35,31.89 -15.11,12.01 -32.1,11.3 -46.7,3.41 10.85,-28.79 32.13,-38.95 55.05,-35.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4080",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3423.13,1404.5 c 2.84,3.12 5.26,4.16 7.44,3.89 -10.79,9.43 -25.12,13.58 -37.68,8.38 0.07,1.16 0.15,2.33 0.16,3.48 l 0.01,0.1 c 0.2,1.55 0.44,3.38 0.76,5.65 0.07,1.47 0,2.92 0.05,4.38 0.01,0.33 0.09,1.47 0.17,2.48 l 0.12,0.79 c 0.34,2.05 0.7,4.08 0.98,6.12 5.9,14.72 -3.25,35.94 -19.51,34.52 -1.63,-0.14 -3.26,-0.41 -4.89,-0.61 -7.46,0.42 -14.36,-0.84 -21.4,-5.48 -6.33,-4.17 -11.66,-9.71 -16.22,-16 -3.06,-4.23 -5.31,-8.89 -7.04,-13.81 -5.54,1.4 -11.15,2.63 -16.9,3.52 -7.21,1.1 -34.16,-2.48 -38.88,1.33 -8.34,-1.15 -5.38,0.41 8.9,4.66 1.67,7.9 1.75,15.78 0.23,23.65 -2.02,13.45 -5.69,21.63 -14.36,30.98 -9.01,9.72 -18.55,9.78 -28.5,16.36 -1.48,0.33 -2.76,0.62 -3.9,0.86 -3.76,4.48 -5.66,9.76 -5.45,15.9 0.23,5.29 -2.57,10.69 -6.61,14.09 -2.3,11.39 -4.35,22.82 -6.24,34.2 -2.6,15.7 -20.04,17.7 -29.55,9.18 -2.29,4.04 -4.59,8.1 -6.89,12.14 5.72,26.26 -27.18,36.15 -36.02,11.66 -13.85,-38.36 4.45,-59.36 29.92,-61.78 -6.82,-33.84 -4.15,-67.88 6.95,-102.18 2.47,-7.62 5.48,-14.82 8.71,-21.87 -5.48,1.56 -10.74,3.26 -15.82,5.24 -5.07,17.91 -20.25,26.3 -35.43,24.92 -5.54,6.5 -10.88,14.37 -16.07,24.26 -1.77,3.4 -4.53,5.91 -7.66,7.73 -0.52,1.42 -1.01,2.83 -1.61,4.26 -7.67,18.12 -30.24,14.99 -39.17,0.72 -1.33,-2.12 -2.33,-4.53 -3.41,-6.87 -3.17,1.38 -6.43,2.56 -9.85,3.37 -11.63,2.77 -23.51,1.13 -34.9,-2.26 -1.38,2 -2.73,3.83 -3.76,5.16 -7.91,10.26 -21.21,7.8 -29.7,0.54 -15.15,-12.95 -18.88,-41.77 -9.04,-59.9 10.91,-20.09 32.09,-22.34 51.02,-18.49 2.98,0.61 5.94,1.33 8.84,2.28 0.89,0.29 2.5,0.31 3.67,0.33 l 1.68,-1 c 4.14,-3.54 7.55,-8.43 11.08,-12.63 3.56,-4.2 7.11,-8.16 10.73,-11.84 -3.8,-2.5 -7.33,-5.66 -10.36,-9.48 l -1.69,0.42 c -10.21,2.74 -22.07,-9.92 -15.17,-21.05 4.43,-7.19 9.17,-11.47 15.57,-16.44 5.76,-4.47 15.78,-3.25 20.53,2.54 2.68,3.26 4.75,6.2 7.63,8.56 1.44,0.15 2.77,0.09 4.54,-1.01 11.59,-7.18 22.67,-0.3 27.39,9.8 7.44,-16.38 18.98,-29.11 38.65,-33.48 11.33,-2.52 22.87,-0.75 34.26,-2.56 19.89,-3.16 29.7,-15.91 41.95,-31.54 -3.58,-7.5 -6.67,-15.19 -8.45,-23.33 -3.63,-16.52 1.43,-32.7 14.8,-41.7 14.62,-9.83 31.93,-4.65 39.81,11.8 2.07,4.32 2.95,10.3 0.22,14.65 0.93,-1.49 0.2,-0.01 -0.66,1.64 0.76,1.5 1.52,3.02 1.82,3.55 6.39,11.26 13.47,21.31 19.05,32.84 24.6,-13.35 50.65,-22.84 77.19,-13.68 8.23,2.84 15.27,7.17 21.24,12.52 -4.54,37.82 0.96,75.14 26.72,103.54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4082",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3474.34,1359.32 c 20.49,11.3 20.49,45.18 0,67.75 12.33,-4.53 23,0.06 33.35,6.41 -2.96,5.14 -6.42,9.52 -10.9,13.81 3.51,-3.36 -9.02,6.96 -5.63,4.85 -1,0.63 -6.02,2.41 -8.69,3.25 -3.12,1.38 -8.23,3.53 -10.02,3.94 -7.25,1.67 -14.15,0.8 -21.18,-1.59 -15.71,-5.34 -14.22,-33.12 3.53,-32.82 0.7,0.02 2.32,-0.23 3.84,-0.37 l -0.03,-0.49 c -0.62,-10.7 -1.16,-16.14 -1.42,-25.74 -7.82,3.77 -15.71,6.67 -23.67,8.79 11.35,-8.66 16.36,-56.77 40.82,-47.79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4084",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3943.06,1192.23 c -0.94,-0.13 -2.16,-0.57 -3.29,-0.91 42.62,-84.97 142.63,-42.37 167.28,-137.51 2.58,-2.52 5.26,-7.62 11.84,-16.08 12.15,-15.64 32.74,-32.67 50.55,-38.941 17.49,-6.16 36.95,-4.867 53.06,5.021 7.72,4.75 11.78,9.74 14.82,15.17 14.11,-10.5 27.34,-30.191 48.98,-27.011 34.29,5.031 46.53,40.041 59.53,70.181 7.58,17.59 -10.55,35.74 -24.76,21.79 -13.18,-12.95 -26.11,-25.47 -38.27,-19 -8.64,4.6 -15.25,20.19 -24.74,26.1 -27.87,17.33 -45.07,7.69 -68.22,-8.23 -3,-2.06 -4.42,-3.64 -5,-4.81 -1.21,3.47 -11.97,18.24 -12.73,19.41 -4.53,6.93 -8.03,13.03 -12.83,18.61 6.13,6.88 10.43,15.91 11.29,25.2 16.69,-3.44 31.3,11.02 33.74,28.72 13.28,-2.92 26.67,-7.98 38.86,-12.33 18.51,-6.61 25.73,23.68 8.37,31.42 -13.21,5.88 -26.2,13.33 -39.31,19.85 8.5,7.39 9.98,9.86 21.41,9.66 19.22,-0.34 28.13,25.19 15.86,40.3 -40.41,49.8 -98.91,-6.81 -132.37,-36.38 -7.71,-6.81 -11.11,-14.91 -11.64,-23.01 -3.48,-3.32 -6.78,-6.81 -9.76,-10.48 l -0.09,-0.12 c -5.43,-1.05 -10.71,-2.8 -15.66,-5.58 -14.38,1.4 -26.17,-10.85 -30.75,-25.37 -16.5,6 -34.77,19.11 -45.98,23.75 -1.33,0.54 -2.67,1.05 -4,1.57 -14.5,1.25 -30.34,4.34 -45.16,9.67 -3.64,-0.01 -7.31,-0.17 -11.03,-0.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4086",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3044.14,975.391 c 30.73,79.039 71.71,67.749 133.16,101.629 10.25,0 0,33.87 -10.24,56.46 20.49,11.29 40.97,-11.3 61.45,-11.3 -10.24,11.3 -10.24,11.3 -20.48,22.59 51.22,33.88 92.18,11.29 122.92,-33.88 40.96,67.76 -20.49,158.1 81.94,124.22 -4.69,12.92 -8.79,26.44 -11.91,40.14 -7.89,2.87 -16.65,2.45 -24.55,-2.68 -2.98,-1.94 -5.97,-3.88 -8.96,-5.82 -2.4,-1.56 -4.39,-3.62 -6.15,-5.87 -7.94,-3.35 -14.24,-12.55 -17.9,-21.8 -0.78,-1.95 -1.14,-4.1 -1.19,-6.33 -5.49,-6.32 -9.74,-14.04 -11.81,-24.8 -1.96,-10.22 -0.29,-20.74 1.67,-30.84 0.24,-1.2 0.41,-2.38 0.6,-3.57 -12.89,11.39 -23.89,27.95 -38.89,36.07 -21.45,11.63 -46.14,12.88 -69.13,6.14 -7.93,-2.34 -15.94,-6.11 -23.36,-10.31 -1.67,15.9 -4.83,31.86 -12.12,44.55 -7.25,12.6 -22.88,13.02 -30.47,0.56 -1.96,-3.22 -3.53,-6.67 -4.92,-10.19 -14.55,8.33 -31.73,11.29 -47.83,7.87 -4.35,-0.93 -14.73,-2.42 -18.24,-5.99 -0.76,12.52 2.12,36.51 2.12,40.69 -0.01,32.33 -39.5,55.94 -61.13,29.23 -5.06,-6.25 -42.84,-51.76 -26.81,-15.25 12.84,29.24 -19.71,64.73 -42.99,37.83 -5.03,-5.83 -9.58,-12.36 -13.52,-19.29 l -1.65,1.28 c -6.4,4.27 -13.03,5.85 -20.27,7.18 -3.09,0.57 -4.67,0.51 -5.43,0.27 -0.17,0.82 -0.82,2.28 -2.64,4.85 -6.07,8.53 -18.63,3.44 -21.16,-5.75 -1.84,-6.71 -3.49,-12.96 -3.47,-19.1 -1.91,-0.49 -4.72,-1.21 -5.28,-2.34 -9.24,-3.54 -17.19,-13.5 -16.82,-24.77 0.76,-23.1 15.21,-38.46 33.65,-46.81 12.53,-5.67 28.73,-8.99 42.72,-6.08 2.46,-2.96 5.41,-5.74 8.6,-8.39 -2.36,-1.66 -4.65,-3.49 -6.8,-5.63 -5.32,0.82 -11.08,-0.01 -14.97,-2.97 l -4.93,1.05 c -13.51,11.63 -32.02,-3.67 -32.61,-19.85 -0.19,-5.48 -22.53,-5.01 -27.22,-5.79 -6,-0.99 -6.93,-9.59 -3.55,-13.86 16.1,-20.35 36.7,-22.79 53.58,-11.43 7.07,-3.5 14.48,-4.3 22.39,-2.25 l 1.96,-1.63 c 10.46,-8.25 26.85,-2.73 33.04,8.91 8.19,15.4 22.56,10.79 36.96,10.88 6.67,0.05 13.47,3.02 18.15,8.36 10.42,-22.53 29.36,-36.75 63.56,-31.09 4.81,0.8 15.52,2.84 20.39,6.98 2.85,-10.26 5.81,-22.81 7.84,-26.4 3.41,-6.05 7.51,-11.79 12.12,-17.02 -1.69,-1.49 -3.42,-3.01 -5.19,-4.55 -13.64,-1.95 -23.43,-11.86 -32.35,-23.82 -5.51,-2.59 -10.08,-3.27 -12.79,-0.63 -12.22,11.96 -31.82,15.1 -44.16,0.81 -20.53,-23.78 -36.93,-22.57 -60.66,-5.66 -8.99,6.4 -22.1,0.72 -24.85,-10.63 -7.65,-31.63 10.64,-59.09 39.33,-66.88 15.15,-4.108 30.3,-2.38 44.55,2.99 -1.37,-5.03 -2.35,-10.2 -3.04,-15.129 -0.85,-6.082 0.21,-13.641 -0.14,-19.539 5.97,-0.063 9.88,1.289 9.88,4.379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4088",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3546.04,1494.83 c 8.57,0 17.93,-1.76 27.64,-3.8 8.2,1.1 16.15,2.67 23.48,5.18 3.73,-3.71 7.45,-7.41 11.18,-11.12 14.14,-1.02 27.94,0.78 40.14,9.74 -5.57,-24.55 -5.01,-52.39 4.81,-74.54 1.41,-0.49 2.84,-0.93 4.41,-1.04 12.14,-0.88 24.64,0.76 37.01,1.08 1.46,-3.16 2.98,-6.34 4.32,-9.46 3.92,-9.12 7.66,-18.61 11.41,-28.18 49.45,7.65 40.46,69.8 40.46,112.14 0,11.3 20.49,33.88 30.73,33.88 51.21,-11.29 0,-90.34 30.73,-90.34 40.97,-11.3 40.97,45.17 61.46,56.46 6.5,3.59 12.69,6.81 18.77,9.86 2.24,8.76 3.37,17.89 3.17,26.96 -0.2,9.46 -4.4,19.1 -6.3,28.32 14.96,-9.43 35.52,0.56 45.73,17.41 13.05,4.94 24.81,11.94 35.68,21.09 l 0.58,-0.08 c 2.67,-5.71 7.27,-10.45 14.08,-12.68 0.29,-0.1 2.19,-0.68 3.35,-0.95 l 0.89,-0.67 c 0.7,-1.35 6.5,-8.56 3.22,-3.7 4.89,-7.24 9.12,-15.08 15.3,-21.11 9.81,-9.56 25.13,-12.39 37.04,-5.74 12.07,6.73 20.22,23.17 9.64,36.03 -2.82,3.43 -8.44,6.16 -11.63,6.9 -1.11,1.44 -2.31,2.84 -3.54,4.21 -0.4,0.7 -2.88,4.18 -3.58,5.28 -1.77,2.78 -3.63,5.47 -5.55,8.09 2.62,2.06 5.17,4.27 7.62,6.69 5.6,5.49 10.14,11.39 13.96,17.58 4.23,-0.21 8.55,0.01 13.24,0.97 2.17,0.45 3.49,0.85 3.7,1.02 4.05,0.48 8.15,0.66 12.16,1.57 3.1,0.7 6.15,1.53 9.14,2.47 8.5,-3.56 17.84,-5.42 26.45,-6.65 6.09,-0.87 11.95,-0.77 18.06,-0.67 8.4,0.14 14.45,2.3 22.42,4 14.76,3.16 12.78,25.46 0.45,30.37 -9.72,3.86 -18.8,11.65 -28.12,18.88 -1.46,8.44 -5.74,16.25 -13.14,20.86 l -2.08,1.19 c 3.95,2.97 7.8,6.05 11.45,9.13 7.05,-4.48 16.03,-6.1 26.35,-3.2 12.79,3.6 21.61,13.94 27.16,26.69 2.39,5.49 12.07,44.1 4.56,46.11 14.87,-3.99 27.84,16.26 15.97,29.13 -12.86,13.95 -31,13.87 -45.12,1.44 -7.15,-6.29 -11.48,-15.23 -13.97,-24.8 -0.72,-2.74 -1.89,-6.84 -2.57,-10.78 -3.46,0.98 -7.17,0.91 -10.89,-0.7 -3.86,-1.68 -9.22,-3.8 -15.26,-6.3 -5.92,25.21 -17.44,48.44 -33.78,67.53 l 12.37,15.89 c 7.81,5.01 7.8,21.15 -2.39,23.18 -7.62,1.51 -14.58,2.15 -21.16,1.94 0.16,1.73 0,3.5 -0.56,5.24 -1.08,3.25 -1.91,6.12 -2.71,9.33 -0.54,2.19 -3.9,12.61 -2.83,9.59 1.42,-3.97 -1.48,4.21 -1.71,4.68 -0.51,1.1 -1.07,2.12 -1.65,3.17 l -0.44,0.7 c 0.51,3.36 0.97,6.72 1.53,10.13 1.31,8.17 -0.25,12.47 2.91,19.24 1.8,3.86 -1,7.39 -4.64,6.89 -9.29,-1.27 -13.49,-0.49 -21.18,-6.05 -8.69,-6.27 -15.5,-14.92 -20.25,-24.98 -4.34,-9.24 -4.14,-21.07 2.93,-28.77 2.68,-2.91 5.34,-5.4 8.61,-7.35 1.13,-3.18 2.96,-7.6 3.58,-9.03 0.74,-1.71 1.86,-3.2 3.13,-4.56 -4.32,-3.21 -8.61,-6.99 -12.92,-11.7 -13.71,-15.01 -9.74,-37.32 4.98,-49.02 14.87,-11.8 23.8,-25.03 27.15,-40.51 -13.34,11.22 -32.51,9.69 -44.95,-0.92 -1.24,6.38 -2.15,12.78 -2.66,18.25 -1.48,16.15 -21.04,32 -33.23,15.89 -16.5,-21.81 -21.14,-43.96 -13.96,-72.06 4.37,-17.09 14.11,-37.76 27.87,-50.4 -1.02,-0.37 -2.1,-0.43 -3.34,0.24 -14.98,8.17 -35.27,8.94 -47.62,-5.89 -1.57,-1.89 -3.12,-3.64 -4.68,-5.28 -3.4,10.99 -7.8,21.4 -11.68,32.64 -5.32,15.42 -28.37,15.51 -28.11,-3.68 0.22,-16.74 -0.31,-33.77 -1.03,-50.8 -2.48,-0.98 -4.76,-2.18 -6.84,-3.66 -20.65,-2.9 -39.6,-11.73 -53.04,-33.08 -10.77,-17.1 -12.74,-36.45 -10.97,-56.78 1.62,-18.52 3.01,-31.77 -17.53,-25 -11.2,3.7 -23.89,1.36 -33.49,-5.97 -1.34,1.13 -2.71,1.93 -4.06,2.83 12.39,21.14 13.43,48.74 -1.14,71.66 2.28,1.86 4.7,4.75 7.31,8.91 17.71,14.34 26.36,34.36 26.98,53.84 11.05,5.34 20.42,16.01 23.96,27.86 1.26,4.19 2.5,8.38 3.75,12.57 16.83,16.55 31.59,38.43 36.63,62.58 1.43,0.52 2.87,1.04 4.32,1.85 35.75,19.83 62.82,54.3 51.14,95.59 0.46,0.94 0.98,1.8 1.47,2.7 2.26,0.16 4.49,0.34 6.81,0.41 28.31,0.79 34.14,36.79 14.22,54.33 -2.7,2.38 -6.31,15.57 -8.64,19.78 -4.63,8.4 -15.49,13.03 -23.57,7.28 -5.97,-4.25 -9.84,-9.52 -12.34,-15.29 -1.73,4.37 -3.99,8.05 -7.69,10.92 -1.91,2.95 -6.69,5.72 -8.75,6.42 l -1.33,0.31 0.34,-0.79 -0.17,0.4 0.07,-0.04 -0.28,0.44 -0.06,0.01 c -1.91,3.51 -4.95,6.31 -8.88,7.85 l -0.2,0.08 c -6.32,2.48 -14.57,-1.27 -17.83,-7.63 -4.35,-8.47 -1.75,-17.29 3.56,-24.08 -0.12,-1.7 -0.15,-3.43 0.04,-5.21 0.87,-8.17 3.93,-14.7 9.21,-20.56 3.45,-3.82 7.89,-5.72 12.4,-6.14 -2.85,-5.3 -6.39,-10.59 -8.76,-15.13 -5.79,-11.18 -4.43,-25.06 3.52,-34.49 5.13,-6.09 -5.33,-12.78 -15.59,-17.94 -4.22,10.66 -9.84,20.42 -17.03,26.75 1.12,6.2 -4.24,11.22 -10.09,8.42 -1.6,-0.41 -3.2,-0.82 -4.8,-1.23 -4.17,-0.02 -9.57,-2.4 -11.41,-6.94 -4.22,-10.5 -2.91,-19.03 -4.58,-29.99 -2.02,-13.24 -8.55,-26.09 -14.55,-37.87 -5.94,-11.66 -13.94,-16.73 -23.01,-24.85 -3.35,-3 -6.07,-6.42 -8.36,-10.12 -5.93,-1 -11.62,-3.27 -16.85,-6.93 -0.99,8.32 -1.99,16.64 -3.02,24.95 6.89,0.36 13.58,3.42 19.07,8.79 12.29,12.01 14.89,30.38 11.55,47.45 -2.59,13.28 -10.85,22.95 -20.2,31.05 -6.43,5.59 -14.37,4.79 -20.78,0.62 -0.41,2.88 -0.95,5.8 -1.79,8.8 -1.71,6.11 -4.33,11.09 -7.47,15.22 14.49,5.62 21.33,21.74 17.51,37.27 -0.13,1.14 -0.16,2.3 -0.39,3.43 -0.48,2.02 -1.18,3.79 -1.98,5.45 -0.04,2.07 -0.36,4.13 -0.77,6.16 l 1.88,1.25 c 12.46,10.47 20.41,27.41 16.1,44.85 -1.31,5.29 -2.91,10.66 -3.76,15.96 l 2.18,1.06 c 10.01,6.21 13.47,19.87 9.28,30.87 0.65,5.11 -1.95,11.12 -6.67,11.96 -1.53,0.29 -2.99,0.29 -4.48,0.45 -7.1,3.36 -15.61,2.67 -21.89,-2.19 -14.46,-5.26 -24.66,-18.44 -26.07,-40.61 -0.89,-14.04 6.47,-21.26 7.97,-33.56 -1.63,13.27 -5.77,0.68 -6.95,-5.92 -0.23,-1.22 -0.21,-2.38 -0.31,-3.56 -3.66,-1.25 -7.13,-3.34 -10.11,-6.43 -4.16,-4.32 -8,-8.13 -11.3,-13.46 -2.45,-3.97 -3.94,-8.16 -4.91,-12.45 -9.42,12.5 -19.26,24.78 -25.63,38.93 24.42,14.44 20.23,64.56 -14.21,65.19 -31,0.56 -38.75,-40.03 -22.38,-59.25 -8.27,-14.19 -10.35,-30.39 -3.09,-51.55 5.75,-16.75 15.9,-28.33 25.33,-42.39 8.64,-12.87 13.62,-18.93 15.21,-28.03 -0.41,-3.87 -0.28,-7.81 0.38,-11.71 -0.11,-1.39 -0.16,-2.68 -0.34,-4.24 -1.14,-9.85 -3.27,-19.19 -5.11,-28.37 l -0.17,-0.2 c -9.01,-10.7 -10.27,-27.6 -2.14,-38.67 0.79,-4.55 2.14,-9.18 4.08,-13.9 -1.57,-20.91 -2.96,-41.83 -4.06,-62.76 -6.02,6.79 -12.29,12.28 -20.9,15.75 -11.64,4.68 -24.39,-6.85 -24.41,-19.81 -0.02,-12.09 4.09,-21.95 9.15,-32.45 3.69,-7.64 7.73,-15.94 13.7,-21.5 -6.87,-18.66 -12.5,-34.73 -33.95,-32.46 -11.85,1.24 -29.35,15.25 -40.22,20.13 l -2.27,0.97 c -1.8,7.65 -5.92,13.67 -11.36,17.69 21.78,25.75 43.68,61.76 49.93,90 4.66,21.08 -3.37,39.86 -16.53,54.85 -6.42,7.3 -14.36,13.46 -22.05,19.08 -1.82,1.33 -4.99,2.83 -6.26,4.88 l -1.06,1.27 c 0.9,0.68 2.31,2.2 4.49,5.76 9.31,15.21 -8.75,36.71 -22.99,26.2 -16.56,-12.24 -32.97,-25.34 -29.25,-50.22 2.28,-15.22 16.52,-35.2 29.42,-42 l 2.13,-2.15 c -6.49,-8.86 -11.44,-19.77 -17.81,-28.84 -3.11,-4.43 -7.13,-9.73 -11.32,-15.16 -4.62,3.96 -10.24,6.65 -16.43,7.45 -6.72,22.02 -28.84,30.31 -48.39,24.42 -4.75,10.42 -11.09,20.04 -20.77,28.52 -12.12,10.6 -24.41,17.26 -39.64,20.12 -1.38,0.26 -8.19,1.83 -13.31,2.55 -9.77,19.87 -40.51,20.6 -51.08,0.17 -20.23,-39.07 7.95,-67.34 41.82,-72.45 29.1,-4.41 25.36,-21.85 33.3,-50.31 0.69,-2.43 1.66,-4.79 2.77,-7.08 -1.38,-15.03 0.31,-29.67 4.49,-43.65 -3.95,-1.08 -7.85,-2.3 -11.66,-3.79 -10.73,11.58 -29.44,13.84 -41.55,-0.23 -3.77,9.12 -13.66,11.28 -21.79,7.53 -28.49,-13.12 -24.26,-56.87 -0.81,-73.66 8.26,-5.92 17.02,-8.1 25.5,-7.56 l 1.15,-1.61 c 10.36,-12.8 27.82,-13.79 40.98,-6.59 28.1,15.39 53.63,1.35 77.47,-15.36 11.6,-8.12 22.86,-8.51 32.22,-4.24 11.74,-4.97 23.74,-8.69 35.61,-10.86 10.4,-1.92 20.38,-2.6 30.08,-2.69 -1.72,1.85 -3.87,3.55 -6.6,5.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4090",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3573.68,1491.03 c -9.71,2.04 -19.07,3.8 -27.64,3.8 2.73,-1.5 4.88,-3.2 6.6,-5.05 7.26,-0.07 14.27,0.33 21.04,1.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4092",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3999.25,1183.22 c -14.73,5.78 -29.66,9.71 -45.16,9.67 14.82,-5.33 30.66,-8.42 45.16,-9.67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4094",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4203.81,1573.32 -0.33,1.85 c -2.01,11.26 -13.73,20.64 -23.98,20.13 -10.38,-0.52 -21.83,-8.06 -23.97,-20.13 l -0.34,-1.85 c -1.71,-9.59 -0.43,-20.04 6.49,-27.04 4.93,-4.99 10.99,-8.13 17.82,-8.13 6.47,0 13.25,3.09 17.82,8.13 6.72,7.41 8.25,17.1 6.49,27.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4096",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4229,1655.36 c -27.03,0 -27.08,-46.32 0,-46.32 27.03,0 27.07,46.32 0,46.32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4098",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4050.91,1513.13 c -2.65,6.92 -9.27,12.49 -16.37,12.14 -6.25,-0.31 -12.25,-3.71 -15.47,-9.79 -4.39,-8.28 -2.25,-16.96 2.8,-23.93 l 0.78,-1.09 c 5.25,-7.24 18.55,-7.2 23.77,0 l 0.79,1.09 c 4.6,6.36 6.7,13.72 3.7,21.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4100",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4002.71,1460.84 c -7.71,0 -14.27,-7.23 -14.27,-15.74 0,-8.54 6.53,-15.75 14.27,-15.75 7.73,0 14.29,7.24 14.29,15.75 0,8.54 -6.53,15.74 -14.29,15.74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4102",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4055.75,1416.85 c -21.62,0 -21.66,-37.05 0,-37.05 21.63,0 21.66,37.05 0,37.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4104",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4105.25,1455.4 c -16.58,0 -16.61,-28.4 0,-28.4 16.58,0 16.6,28.4 0,28.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4106",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4140.6,1537.38 c -21.26,0 -21.29,-36.44 0,-36.44 21.27,0 21.31,36.44 0,36.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4108",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4172.43,1404.23 c -20.55,0 -20.58,-35.2 0,-35.2 20.55,0 20.58,35.2 0,35.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4110",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4221.93,1395 c -9.53,0 -18.65,-9.22 -18.21,-20.06 0.45,-10.88 8,-20.07 18.21,-20.07 9.52,0 18.64,9.23 18.21,20.07 -0.44,10.87 -8,20.06 -18.21,20.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4112",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4298.35,1351.55 c -0.72,7.03 -6.31,12.33 -12.8,9.31 -5.79,-2.68 -7.78,-11.55 -2.98,-16.52 2.65,-2.74 4.92,-5.67 8.51,-6.84 3.23,-1.05 6.15,1.28 7.23,4.53 1.04,3.13 0.37,6.29 0.04,9.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4114",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4355.52,1333.39 0.03,-0.03 -0.51,1 -0.14,0.26 -0.66,1.33 c -3.63,8.43 -14.51,9.5 -20.58,4.34 -6.05,-5.16 -8.01,-17.07 -1.43,-23.05 2.6,-2.34 5.42,-5.14 8.89,-5.69 6.53,-1.06 12.97,1.16 15.63,8.44 1.73,4.74 1.06,9.5 -1.23,13.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4116",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4296.18,1508.97 c -24.51,0 -24.55,-41.99 0,-41.99 24.5,0 24.55,41.99 0,41.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4118",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4154.75,1229.99 c -31,0 -31.05,-53.12 0,-53.12 31,0 31.05,53.12 0,53.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4120",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4076.96,1169.55 c -24.15,0 -24.19,-41.38 0,-41.38 24.15,0 24.19,41.38 0,41.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4122",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4073.43,1116.71 c -21.62,0 -21.66,-37.06 0,-37.06 21.63,0 21.67,37.06 0,37.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4124",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4003.08,1169.9 -0.62,1.55 c -4.68,11.61 -23.1,11.61 -27.77,0 l -0.63,-1.55 c -2.51,-6.24 -3.29,-12.49 0,-18.7 2.99,-5.64 8.58,-9.17 14.51,-9.17 5.93,0 11.53,3.53 14.51,9.17 3.3,6.21 2.51,12.46 0,18.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4126",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4119.39,1123.66 c -11.53,0 -11.55,-19.77 0,-19.77 11.54,0 11.56,19.77 0,19.77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4128",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4161.82,1052.45 c -5.77,0 -5.78,-9.88 0,-9.88 5.77,0 5.78,9.88 0,9.88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4130",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4239.61,1067.73 c -5.41,0 -5.42,-9.26 0,-9.26 5.4,0 5.41,9.26 0,9.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4132",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4282.74,1056.36 c -10.76,-5 -13.37,-20.26 -5.32,-29.53 1.92,-2.21 3.8,-4.46 5.81,-6.56 6.2,-6.51 19.22,-4.64 20.84,6.05 0.66,4.45 1.08,8.93 1.56,13.39 1.41,13.24 -13.19,21.16 -22.89,16.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4134",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4204.25,1288.65 c -26.67,0 -26.71,-45.71 0,-45.71 26.68,0 26.72,45.71 0,45.71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4136",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3829.47,1532.06 c -24.15,0 -24.19,-41.38 0,-41.38 24.14,0 24.19,41.38 0,41.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4138",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3880.76,1496.71 -0.66,1.75 c -2.62,6.95 -7.76,13.19 -15.28,12.82 -7.6,-0.37 -12.46,-5.35 -15.27,-12.82 l -0.66,-1.75 c -4.22,-11.2 6.21,-23.05 15.93,-23.05 9.78,0 20.15,11.89 15.94,23.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4140",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3865.69,1624.35 c -1.29,1.05 -2.54,1.71 -3.98,2.49 -9.9,5.32 -22.34,-1.02 -22.34,-14.13 0,-13.11 12.44,-19.45 22.34,-14.13 1.44,0.78 2.69,1.43 3.98,2.49 7.8,6.37 7.8,16.91 0,23.28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4142",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3935.82,1607.08 c -2.61,1.45 -4.21,3.22 -7.26,4.15 -1.06,0.3 -2.15,0.25 -3.23,0.35 -13.18,8.21 -27.87,-8.45 -20.53,-22.87 2.9,-5.72 7.17,-10.25 12.66,-12.8 7.84,-3.65 15.55,-0.17 21.31,5.96 6.41,6.84 5.42,20.59 -2.95,25.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4144",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3977.97,1676.59 c -9.96,0 -19.51,-9.66 -19.05,-21 0.46,-11.38 8.37,-21 19.05,-21 9.96,0 19.5,9.65 19.04,21 -0.46,11.38 -8.37,21 -19.04,21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4146",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4020.91,1709.8 c -1.67,12.1 -12.94,21.23 -21.02,28.43 -8.52,7.6 -21.48,9.87 -29.71,0 -8.37,-10.05 -7.4,-22.66 0,-32.76 2.76,-3.75 5.37,-8.23 8.55,-11.56 4.65,-4.86 11,-10.56 17.24,-11.6 7.39,-1.24 14.16,-0.39 19.72,5.74 5.57,6.14 6.34,13.6 5.22,21.75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4148",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4052.22,1703.56 c -13.55,0 -24.31,-17.85 -16.21,-31.13 l 0.85,-1.4 c 7.69,-12.6 23.02,-12.6 30.71,0 l 0.85,1.4 c 8.1,13.28 -2.66,31.13 -16.2,31.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4150",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4057.16,1791.37 -1.08,0.57 c -7.02,3.74 -15.18,2.08 -19.44,-5.62 -2.48,-4.48 -3.23,-8.69 -3.82,-13.8 -1.34,-11.56 14.47,-18.11 21.04,-9.61 l 1.17,1.38 1.05,0.58 c 4.49,2.34 6.95,8.37 7.05,13.53 l 0.02,1.44 c 0.09,4.38 -2.3,9.57 -5.99,11.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4152",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4134.3,1731.05 c -3.18,12.73 -19.04,18.92 -28.02,9.38 -4.53,-2.43 -7.91,-6.72 -8.54,-12.51 -0.76,-7.09 2.14,-12.1 7.09,-16.3 2.29,-1.95 5.25,-3.67 8.11,-4.12 6.36,-0.99 12.09,-0.37 16.89,4.93 4.38,4.82 6.12,12.04 4.47,18.62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4154",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4137.07,1804.79 c -19.46,0 -19.49,-33.35 0,-33.35 19.46,0 19.5,33.35 0,33.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4156",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4083.57,1917.41 c -2.88,11.52 -10.49,18.08 -20.15,22.21 -0.9,0.38 -1.81,0.78 -2.72,1.16 -18.74,8 -41.08,-16.63 -33.82,-37.29 0.35,-1 0.71,-1.99 1.06,-3 3.74,-10.64 9.69,-19.03 20.14,-22.2 9.93,-3.02 20.8,0.15 28.07,8.17 7.28,8.02 10.15,20 7.42,30.95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4158",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3850.6,1842.6 c -6.94,8.6 -21.15,8.37 -28.12,0 -6.94,-8.34 -8.3,-22.87 0,-31 6.86,-6.74 13.37,-14.54 23.34,-14.17 9.76,0.36 17.3,8.62 17.64,19.43 0.33,11.04 -6.73,18.14 -12.86,25.74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4160",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3896.65,1943.8 c -27.04,0 -27.08,-46.31 0,-46.31 27.03,0 27.07,46.31 0,46.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4162",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3943.54,1868.91 c -1.81,13.14 -17.42,21.54 -28.25,17.69 -12.99,-4.64 -17.98,-17.07 -16.04,-31.16 -0.34,3.95 -0.57,4.56 -0.71,1.85 -1.31,-13.21 11.51,-25.89 22.97,-25.32 13.57,0.67 21.55,11.16 22.96,25.32 0.39,3.92 -0.4,7.74 -0.93,11.62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4164",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3790.57,1782.76 c -25.59,0 -25.63,-43.85 0,-43.85 25.6,0 25.64,43.85 0,43.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4166",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3786.33,1709.33 c -9.56,5.58 -21.1,2.55 -26.83,-7.75 -2.8,-5.05 -5.68,-11.46 -5.44,-17.54 0.24,-5.9 2.05,-11.14 4.4,-16.37 5.42,-12.11 23.13,-11.76 28.65,0 l 1.23,2.38 c 0.52,0.75 1.2,1.73 2.16,3.11 0.82,2.08 1.31,3.35 1.64,4.21 l 1.22,2.39 c 5.37,9.65 2.2,24.2 -7.03,29.57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4168",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3769.36,1642.62 c -10.67,0 -18.78,-11.63 -15.93,-23.05 0.45,-1.82 0.89,-3.64 1.34,-5.44 3.95,-15.86 25.23,-15.88 29.17,0 0.45,1.8 0.9,3.62 1.35,5.44 2.84,11.42 -5.23,23.05 -15.93,23.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4170",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3730.14,1590.43 -8.5,1.39 c -8.43,1.39 -16.91,-3.85 -16.91,-14.19 0,-10.25 8.48,-15.58 16.91,-14.2 l 8.5,1.4 c 11.49,1.88 11.5,23.71 0,25.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4172",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3659.75,1542.9 c -14.05,0 -14.08,-24.09 0,-24.09 14.06,0 14.09,24.09 0,24.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4174",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3696.3,1655.4 c -1.56,3.9 -5.64,7.89 -9.86,7.31 -1.55,-0.22 -3.07,-0.53 -4.61,-0.79 -4.24,0.35 -8.06,-1.24 -11.89,-3.9 -7.51,-5.21 -9.7,-16.14 -4.16,-24.04 5.02,-7.19 16.3,-9.23 22.15,-1.66 2.4,3.1 4.29,5.81 5.45,9.05 l 0.69,1.05 c 2.79,3.76 4.1,8.28 2.23,12.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4176",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3748.14,1728.37 c -21.26,0 -21.3,-36.43 0,-36.43 21.27,0 21.31,36.43 0,36.43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4178",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3698.65,1770.64 c -8.36,0 -16.36,-8.1 -15.97,-17.61 0.38,-9.53 7.02,-17.6 15.97,-17.6 8.35,0 16.35,8.1 15.96,17.6 -0.38,9.54 -7.01,17.61 -15.96,17.61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4180",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3769.5,1851.25 c -4.84,3.44 -10.96,3.74 -16.41,2.37 -7.79,-1.96 -12.06,-8.83 -14.86,-16.39 -3.24,-8.72 1.46,-19.4 7.63,-24.67 9.99,-8.5 24.83,-5.54 31.28,6.59 5.97,11.25 2.04,25.22 -7.64,32.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4182",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3717.82,1844.5 c -1.06,8.7 -8.06,12.56 -15.38,11.29 -8.92,-1.54 -16.98,-4.08 -20.59,-14.05 -1.56,-4.32 1.01,-10.46 4.63,-12.55 6.88,-3.96 12.2,-0.93 19.24,-0.08 7.33,0.88 13.17,6.62 12.1,15.39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4184",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3668.65,1891.41 c -0.92,0.32 -1.21,0.39 -1.31,0.39 l -1.14,0.54 c -1.55,0.99 -3.22,1.49 -5.02,1.49 l -0.51,0.08 c -7.54,1.31 -14.43,-0.27 -19.35,-7.3 -4.64,-6.62 -4.98,-15.27 -1.45,-22.62 3,-6.24 7.46,-10.43 13.24,-13.21 11.01,-5.31 23.5,-2.72 28.61,10.63 4.78,12.5 -1.51,25.97 -13.07,30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4186",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3660.67,1893.91 h 0.06 c -2.87,0.42 -2.81,0.41 -0.06,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4188",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3688.19,1919.92 c -3.36,7.6 -9.32,11.74 -17.05,14.1 -5.58,1.7 -11.71,-0.1 -15.8,-4.61 -4.44,-4.89 -5.12,-10.91 -4.18,-17.42 1.37,-9.48 8.47,-15.69 16.48,-18.1 9.65,-2.9 18.57,3.63 21.71,13.6 l 0.08,-0.09 c 2.36,3.81 1.42,9.1 -1.24,12.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4190",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3734.57,1962.33 -0.75,0.53 c -3.94,2.78 -9.84,2.78 -13.77,0 l -0.75,-0.53 c -12.39,-8.74 -7.75,-31.08 7.63,-31.08 15.38,0 20.06,22.31 7.64,31.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4192",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3734,2000.15 c -1.79,0 -1.8,-3.08 0,-3.08 1.81,0 1.81,3.08 0,3.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4194",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3620.86,1983.58 v -1.13 1.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4196",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3648.52,1521.37 c -5.19,8.89 -13.81,12.37 -23.11,10.37 -6.19,-1.33 -12.28,-6.11 -16.46,-11.14 -8.82,-10.61 -8.41,-26.89 2.21,-35.95 9.85,-8.39 25.96,-6.14 32.1,6.76 l 0.3,0.73 1.77,1.88 c 6.14,6.87 8.11,18.95 3.19,27.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4198",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3730.75,1481.3 c -10.11,8.61 -29.15,7.29 -34.98,-7.36 -2.92,-7.34 -4.44,-12.09 -4.81,-20.17 -1.11,-24.26 30.56,-33 41.19,-12.67 l 1.01,1.03 c 10.96,10.27 7.97,30.33 -2.41,39.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4200",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3756.46,1452.71 c -3.44,4.51 -6.9,9.02 -10.35,13.53 -7.49,9.8 -23.67,9.15 -31.29,0 -7.54,-9.05 -9.45,-25.71 0,-34.49 4.09,-3.81 8.19,-7.6 12.28,-11.41 8.3,-7.71 21.34,-9.64 29.36,0 8.14,9.78 7.49,22.56 0,32.37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4202",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3771.14,1464.12 c -0.88,2.03 -1.77,4.05 -2.66,6.08 -0.96,2.22 -4.34,2.22 -5.32,0 -0.89,-2.03 -1.77,-4.05 -2.65,-6.08 -1.99,-4.54 0.36,-10.22 5.32,-10.22 4.95,0 7.29,5.68 5.31,10.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4204",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3557.22,1605.3 c -11.28,0 -22.08,-10.93 -21.57,-23.77 0.53,-12.88 9.48,-23.78 21.57,-23.78 11.28,0 22.09,10.94 21.57,23.78 -0.53,12.88 -9.48,23.77 -21.57,23.77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4206",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3507.07,1549.63 c -8.61,8.72 -24.12,11.03 -33.01,1.07 -9,-2.59 -16.36,-13.89 -15.95,-24 0.45,-10.96 6.76,-21.46 16.78,-24.29 12.34,-3.48 22.84,0.74 32.18,9.66 9.56,9.14 9.12,28.33 0,37.56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4208",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3430.98,1597.85 -1.68,-0.36 c -9.19,-1.91 -16.83,-13.65 -16.42,-23.75 0.42,-10.25 6.56,-21.72 16.42,-23.77 l 1.68,-0.36 c 14.3,-2.98 28.72,7 28.72,24.13 0,17 -14.4,27.09 -28.72,24.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4210",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3362.75,1586.51 c -3.02,0 -6.34,0.09 -9.27,-0.81 -3.43,-1.05 -5.85,-3.61 -8.57,-5.93 -5,-4.28 -4.97,-15.62 0,-19.87 2.72,-2.33 5.14,-4.9 8.57,-5.94 2.93,-0.89 6.25,-0.8 9.27,-0.8 8.18,0 15.13,7.66 15.13,16.67 0,9.04 -6.92,16.68 -15.13,16.68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4212",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3372.23,1587.7 c -10.99,7.08 -23.4,-0.01 -27.56,-12.36 -0.76,-2.22 -1.53,-4.41 -2.33,-6.6 l -0.24,-0.63 c -0.57,-1.42 -1.13,-2.82 -1.72,-4.23 -2.84,-6.78 -5.37,-12.58 -3.85,-20.24 1.2,-6.05 7.29,-11.09 12.88,-10.81 11.64,0.56 19.73,13.2 26.61,22.37 7.62,10.14 7.28,25.35 -3.79,32.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4214",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3468.83,1707.15 c -11.05,0 -22.37,-13.26 -17.83,-25.8 l 0.64,-1.76 c 2.84,-7.85 8.8,-14.84 17.19,-14.42 8.48,0.42 14.14,6 17.18,14.42 l 0.64,1.76 c 4.55,12.57 -6.82,25.8 -17.82,25.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4216",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3514.79,1665.28 c -15.86,0 -15.89,-27.18 0,-27.18 15.86,0 15.88,27.18 0,27.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4218",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3560.77,1710.44 -2.84,-0.66 c -7.98,-1.86 -10.1,-13.66 -4.7,-19.61 5.4,-5.96 16.1,-3.62 17.78,5.18 l 0.61,3.13 c 1.44,7.46 -4.08,13.54 -10.85,11.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4220",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3574.82,1797.88 c -5.44,2.52 -10.98,2.32 -16.18,-0.92 -3.12,-1.96 -4.96,-5.01 -5.89,-8.44 -0.28,-0.74 -0.59,-1.64 -0.99,-2.86 -0.23,-1.23 -0.19,-1.44 0.05,-0.82 -4.08,-11.03 0.13,-24.09 11.25,-27.47 11.39,-3.46 22.32,6.28 22.69,19.05 0.26,9.02 -3.01,17.76 -10.93,21.46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4222",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3401.53,1707.5 -0.8,1.43 c -6.15,10.91 -20.29,10.91 -26.44,0 l -0.81,-1.43 c -6.56,-11.64 1.97,-26.95 14.03,-26.95 12.06,0 20.58,15.31 14.02,26.95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4224",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3341.54,1772.64 c -4.69,0 -4.7,-8.03 0,-8.03 4.69,0 4.7,8.03 0,8.03"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4226",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3415.79,1755.46 c -15.14,0 -24.7,-18.6 -17.17,-32.97 1.95,-3.75 3.75,-7.29 6.46,-10.49 5.44,-6.44 15.99,-6.44 21.42,0 2.68,3.15 4.52,6.77 6.47,10.49 7.52,14.37 -2.04,32.97 -17.18,32.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4228",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3212.24,1582.65 c -3.11,8.13 -10.86,14.65 -19.19,14.24 -7.33,-0.36 -14.37,-4.36 -18.14,-11.48 -5.01,-9.43 -2.86,-20.17 3.28,-28.05 l 0.81,-1.06 c 6.63,-8.5 21.48,-8.47 28.08,0 l 0.82,1.06 c 5.6,7.2 7.78,16.31 4.34,25.29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4230",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3196.4,1481.91 c -1.07,0.46 -2.17,0.75 -3.32,0.87 -8.48,1.55 -17.02,-4 -17.02,-14.29 0,-10.22 8.53,-15.85 17.02,-14.3 1.15,0.13 2.25,0.41 3.32,0.87 11.99,4.13 12,22.72 0,26.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4232",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3254.66,1499.17 c -4.88,6.97 -13.74,5.72 -18.01,-1.22 -1.67,-2.71 -2.57,-5.55 -2.73,-8.83 -0.17,-3.67 1.98,-7.67 4.88,-9.39 2.62,-1.55 5.51,-2.17 8.38,-1.07 1.66,0.63 2.91,1.61 3.91,2.74 5.64,3.65 7.99,11.46 3.57,17.77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4234",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3263.37,1411.37 -0.42,1.83 c -4.21,18.36 -29.52,18.38 -33.74,0 l -0.41,-1.83 c -2.85,-12.42 5.51,-25.01 17.28,-25.01 11.72,0 20.13,12.59 17.29,25.01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4236",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3237.36,1337.77 c -9.03,-9.96 0.27,-25.47 11.99,-22.71 l 2.43,0.57 c 2.59,0.61 5.11,3.39 5.67,6.25 l 0.52,2.67 c 2.49,12.9 -11.58,23.18 -20.61,13.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4238",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3313.26,1447.22 c -25.23,0 -25.27,-43.22 0,-43.22 25.22,0 25.27,43.22 0,43.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4240",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3338.01,1363.35 c -4.69,0 -4.7,-8.02 0,-8.02 4.68,0 4.69,8.02 0,8.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4242",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3364.87,1347.41 c -4.26,7.01 -7.96,14.4 -11.14,22.07 -3.99,9.57 -17.22,12.66 -24.91,7.19 -8.83,-6.27 -10.96,-17.31 -6.54,-27.46 6.83,-15.6 20.45,-46.37 40.05,-34.18 5.34,3.33 8.15,10.16 8.15,16.71 0,6.51 -2.54,10.61 -5.61,15.67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4244",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3405.18,1418.37 v -1.12 1.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4246",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3470.76,1387.88 c -1.09,2.65 -2.2,5.3 -3.29,7.94 -1.33,3.21 -5.93,0.4 -4.36,-2.8 l 3.78,-7.63 c 1.41,-2.85 5.05,-0.36 3.87,2.49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4248",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3179.39,1414.57 c -2.94,7.68 -10.28,13.86 -18.17,13.47 -15.25,-0.75 -23.9,-18.29 -17.37,-32.17 2.54,-9.38 13.53,-14.12 21.44,-11.88 3.65,1.03 7.48,3.48 9.99,6.63 5.36,6.74 7.35,15.51 4.11,23.95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4250",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3097.58,1492.34 c -18.74,0 -18.77,-32.11 0,-32.11 18.75,0 18.78,32.11 0,32.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4252",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3065.15,1433.33 -1.37,0.75 c -11.39,6.13 -25.72,-1.18 -25.72,-16.26 0,-15.09 14.33,-22.41 25.72,-16.27 l 1.37,0.74 c 10.65,5.73 10.65,25.31 0,31.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4254",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3075.77,1374.94 c 0.31,-5.8 0.65,-10.74 4.67,-15 3.64,-3.87 9.41,-3.89 13.06,0 4.02,4.26 4.37,9.2 4.67,15 0.86,15.88 -23.25,15.91 -22.4,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4256",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3005.1,1509.04 c -2.15,-1.18 -4.12,-3.11 -5.92,-4.83 -12.15,-11.52 -5.31,-34.8 9.31,-38.91 -1.13,0.53 -2.26,1.07 -3.39,1.61 14.61,-8.72 33.29,2.12 33.29,21.06 0,19.41 -18.58,29.19 -33.29,21.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4258",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2936.15,1311.91 c -2.48,6.49 -8.69,11.72 -15.35,11.39 -14.75,-0.73 -21.89,-19.54 -11.89,-31.63 l 0.84,-1.02 c 5.5,-6.64 16.6,-6.64 22.08,0 l 0.84,1.02 c 4.62,5.59 6.18,13.2 3.48,20.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4260",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2914.32,1248.69 c -4.18,1.9 -6.99,-0.7 -8.45,-4.97 -2.78,-8.09 11.55,-7.76 8.64,0 l -0.1,0.28 c 2.04,0.96 1.94,3.76 -0.09,4.69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4262",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2964.58,1305.18 c -0.22,1.47 -2.49,1.47 -2.71,0 l -2.15,-14.93 c -0.94,-6.48 7.95,-6.51 7.02,0 -0.73,4.98 -1.45,9.96 -2.16,14.93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4264",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2996.93,1324.75 c -11.75,16.76 -30.39,1.88 -39.3,-9.9 -6.85,-9.03 -7.24,-21.79 1.8,-29.49 8.84,-7.52 20.32,-4.25 26.34,5.54 l 1.86,2.84 1.25,1.51 1.38,1.37 1.16,0.77 c 8.51,6.2 12.19,17.82 5.51,27.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4266",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3009.19,1242.33 c -9.02,0 -9.03,-15.44 0,-15.44 9.01,0 9.02,15.44 0,15.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4268",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2927.87,1179.77 c -13.34,0 -13.36,-22.85 0,-22.85 13.33,0 13.36,22.85 0,22.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4270",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2943.26,1181.44 c -8.63,12.32 -24.83,10.46 -32.32,-2.19 -2.21,-3.72 -4.19,-7.07 -5.61,-10.82 -1.05,-2.28 -1.82,-4.72 -1.78,-7.29 v -0.04 -0.02 0.01 c 0.22,-11.96 10.69,-19.25 20.78,-16.68 2.97,0.75 5.85,2.04 8.74,3.09 13.03,4.73 18.86,21.58 10.19,33.94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4272",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3062.06,1220.97 c -1.18,9.97 -7.21,19.82 -17.51,19.31 -10.51,-0.52 -16.24,-8.54 -17.52,-19.31 -0.22,-1.95 -0.46,-3.9 -0.69,-5.85 -1.23,-10.46 9.25,-20.52 18.21,-20.07 8.8,0.43 19.52,8.92 18.2,20.07 -0.23,1.95 -0.46,3.9 -0.69,5.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4274",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3084.89,1302.07 c -1.6,0.66 -3.2,1.33 -4.8,2 -8.67,3.62 -17.73,-5.57 -17.73,-14.89 0,-9.34 9.07,-18.49 17.73,-14.89 1.6,0.68 3.2,1.34 4.8,2.01 11.46,4.78 11.48,20.98 0,25.77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4276",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3122.33,1223.76 c -10.1,0 -10.1,-17.28 0,-17.28 10.09,0 10.11,17.28 0,17.28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4278",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3097.58,1173.6 c -6.13,0 -6.14,-10.5 0,-10.5 6.13,0 6.14,10.5 0,10.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4280",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3136.15,1096.33 c -0.65,2.84 -1.36,5.49 -2.44,8.18 -5,12.45 -22.97,-2.57 -13.18,-11.21 1.47,-1.3 2.67,-2.92 3.92,-4.48 4.83,-5.95 13.34,0.38 11.7,7.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4282",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3065.76,1069.09 c -11.53,0 -11.55,-19.77 0,-19.77 11.53,0 11.55,19.77 0,19.77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4284",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3006.02,1068.56 c -4.95,10.75 -19.1,11.79 -26.39,3.74 -7.31,-8.05 -6.35,-23.64 3.4,-29.09 7.19,-4.03 15.99,-6.72 22.53,0.5 6.56,7.22 4.11,16.91 0.46,24.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4286",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3050.14,1036.02 c -2.29,-1.32 -4.58,-2.64 -6.86,-3.96 -9.51,-5.5 -10.6,-20.62 -3.35,-28.62 7.26,-7.991 20.97,-6.788 25.96,3.69 1.2,2.52 2.39,5.04 3.59,7.56 6.64,13.96 -6.67,28.66 -19.34,21.33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4288",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3227.28,1195.8 c -0.19,1.59 -0.39,3.19 -0.58,4.78 -0.57,5 -3.2,10.32 -7.32,12.48 -11.9,6.21 -22.38,1.43 -29.61,-10.11 -7.51,-11.98 0.23,-29.06 12.05,-32.65 12.01,-3.65 26.39,6.86 25.53,21.43 -0.08,1.37 0.01,2.7 -0.07,4.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4290",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3268.1,1187.84 c -0.96,8.28 -4.01,15.2 -11.36,18.62 -6.56,3.05 -15.19,1.81 -20.2,-4.22 -4.4,-5.29 -6.52,-12.75 -4.75,-19.82 2.39,-9.56 9.6,-13.79 17.83,-14.96 1.17,-0.17 2.35,-0.34 3.53,-0.5 7.57,-1.08 16.37,8.69 15.4,16.98 -0.14,1.3 -0.3,2.6 -0.45,3.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4292",
    style: {
      fill: "#f573a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3327.4,1186.06 c -10.25,0 -20.08,-9.94 -19.61,-21.61 0.48,-11.71 8.61,-21.61 19.61,-21.61 10.25,0 20.08,9.94 19.61,21.61 -0.48,11.71 -8.62,21.61 -19.61,21.61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4294",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3518.21,1326.82 c -0.5,4.12 -1.5,7.97 -2.49,11.97 -2.54,10.33 -12.17,19.08 -22.15,18.59 -10.1,-0.5 -19.4,-7.5 -22.14,-18.59 -0.98,-3.99 -1.99,-7.86 -2.49,-11.97 -0.97,-7.99 0.35,-14.39 3.58,-21.7 7.78,-17.55 34.33,-17.55 42.12,0 3.22,7.29 4.56,13.65 3.57,21.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4296",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3581.52,1326.91 c -0.56,0.94 -1.13,1.87 -1.7,2.81 -4.19,6.94 -12.73,6.94 -16.92,0 -0.57,-0.94 -1.13,-1.87 -1.69,-2.81 -5.03,-8.34 1.63,-19.51 10.16,-19.51 8.52,0 15.18,11.17 10.15,19.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4298",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3636.42,1372.82 c -3.73,6.69 -8.57,11.37 -15.78,12.69 -6.2,1.14 -12.16,0.77 -18.24,-1.1 -7.81,-2.41 -12.7,-10.91 -11.64,-19.65 0.99,-8.08 7.9,-16.41 15.96,-15.53 1.34,0.15 2.63,0.18 3.96,0.15 l 1.6,-0.42 c 3.61,-1.31 7.09,-1.48 10.83,-1.72 11.67,-0.74 19.23,15 13.31,25.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4300",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3681.17,1299.34 c -0.64,8.45 -9.43,16.82 -17.03,10.77 l -1.16,-1.08 -0.48,-0.15 -0.39,-0.14 c -3.83,-0.54 -7.26,-1.5 -10.7,-3.82 -6.01,-4.09 -9.86,-12.85 -7.59,-20.58 2.09,-7.11 8.58,-14.19 15.93,-13.38 8.07,0.9 14.63,3.9 18.44,12.36 2.25,4.98 3.42,10.44 2.98,16.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4302",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3744.72,1393.31 c -6.95,7.77 -17.53,9.82 -26.13,2.5 -8.87,-7.56 -10.72,-23.39 -1.99,-32.26 5.88,-5.97 11.62,-8.38 19.53,-9.3 9.29,-1.08 17.38,8.74 18.51,18.02 1.1,9.06 -3.04,16.88 -9.92,21.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4304",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3793.16,1363.97 c -2.11,8.19 -7.38,13.83 -13.77,18.2 -8.43,5.79 -19.78,2.72 -25.64,-5.64 -5.48,-7.81 -6.23,-22.01 1.55,-28.79 1.93,-1.68 3.47,-3.75 5.34,-5.51 2.63,-2.46 5.34,-4.37 8.65,-5.56 l 1.9,-0.27 0.7,-0.24 c 5.11,-1.6 12,-0.14 15.55,4.53 5.17,6.78 8.08,14.17 5.72,23.28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4306",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3826.82,1323.94 c -1.13,0.2 -2.25,0.39 -3.38,0.6 -6.32,1.11 -6.36,-9.46 0,-8.34 1.13,0.19 2.25,0.4 3.38,0.59 3.22,0.57 3.22,6.58 0,7.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4308",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3833.01,1436.26 c -12.46,0 -24.39,-12.07 -23.81,-26.25 0.57,-14.21 10.46,-26.24 23.81,-26.24 12.45,0 24.37,12.07 23.8,26.24 -0.58,14.22 -10.46,26.25 -23.8,26.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4310",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3894.21,1284.31 c -5.59,2.49 -10.68,3.35 -16.69,1.44 -17.84,-5.7 -17.86,-34.21 0,-39.91 5.87,-1.87 11.16,-1.02 16.69,1.44 6.94,3.1 13.15,9.45 12.78,18.52 -0.37,9.17 -5.32,15.18 -12.78,18.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4312",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3956.11,1320.57 c -1.28,10.11 -13.53,13.77 -20.56,9.23 -7.71,-4.97 -9.28,-17.25 -2.85,-24.25 1.42,-1.54 2.83,-3.07 4.25,-4.6 3.46,-3.68 8.65,-4.87 13.08,-2.72 3.9,1.89 7.96,6.89 7.35,12.05 -0.4,3.44 -0.84,6.86 -1.27,10.29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4314",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3988.4,1267.66 c -3.1,5.83 -8.66,10.55 -14.56,12.34 -8.94,2.72 -16.92,-0.57 -23.71,-6.91 -1.8,-1.67 -3.44,-3.44 -5.02,-5.36 -6.54,-7.94 -9.12,-20.66 -3.54,-30.2 5.16,-8.82 15.91,-15.25 25.53,-11.45 2.22,0.88 4.43,1.57 6.74,2.12 15.53,3.67 22.14,25.16 14.56,39.46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4316",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3762.94,1218.31 c -5.75,-6.9 -8.5,-16.63 -6.2,-25.84 2.78,-11.11 12.67,-19.66 23.23,-19.5 1.88,0.03 3.77,0.06 5.65,0.09 10.02,0.17 18.21,9.14 18.35,20.24 0.03,2.08 0.06,4.15 0.08,6.23 0.29,22.45 -26.89,35.85 -41.11,18.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4318",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3815.32,1116.09 c -13.69,-0.68 -21.92,-19.25 -11.48,-30.57 l 1.78,-1.93 c 5.32,-5.77 14.08,-5.78 19.41,0 l 1.78,1.93 c 9.75,10.57 2.75,31.27 -11.49,30.57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4320",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3780.43,1039.71 -0.76,1.46 c -7.55,14.39 -27.21,14.39 -34.76,0 l -0.76,-1.46 c -7.96,-15.19 2.16,-34.85 18.14,-34.85 15.98,0 26.1,19.66 18.14,34.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4322",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3907.73,1127.88 c 0.3,11.43 -6.85,21.86 -18.16,21.86 -11.51,0 -21.63,-13.09 -17.82,-25.79 2.59,-8.63 7.54,-16.34 15.93,-18.69 9.42,-2.63 21.72,5.33 20.66,17.35 -0.15,1.77 -0.36,3.52 -0.61,5.27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4324",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3896.65,1146.04 c -19.46,0 -19.5,-33.35 0,-33.35 19.46,0 19.49,33.35 0,33.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4326",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3717.51,1161.01 c -4.76,8.97 -15.48,14.2 -24.67,11.07 -1.48,-0.5 -2.98,-1.01 -4.46,-1.52 -8.51,-2.89 -15.53,-13.66 -12.23,-23.74 0.48,-1.45 0.96,-2.91 1.43,-4.36 3,-9.17 9.17,-15.92 18.16,-17.26 8.28,-1.22 17.7,3 21.77,11.5 3.61,7.53 3.98,16.82 0,24.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4328",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3675.16,1292.91 c -1.68,-0.36 -3.35,-0.72 -5.03,-1.08 -8.56,-1.85 -15.67,-12.68 -15.29,-22.14 0.39,-9.58 6.12,-20.14 15.29,-22.14 1.68,-0.36 3.35,-0.72 5.03,-1.08 13.78,-2.99 27.65,6.82 27.65,23.22 0,16.31 -13.87,26.21 -27.65,23.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4330",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3596.11,1153.32 v -1.13 1.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4332",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3584.43,1124.65 c -12.2,10.38 -27.29,3.59 -33.09,-10.65 l -0.37,-0.49 c 0.93,2.84 0.27,1.16 -0.23,-0.29 -1.12,-1.25 -2.2,-2.55 -3.05,-4.07 -0.92,-1.73 -1.58,-3.56 -1.96,-5.49 -1.32,-6.02 -0.19,-13.33 4.23,-17.62 9.73,-9.42 21.71,-6.24 32.28,-0.59 13.95,7.45 13.33,29.71 2.19,39.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4334",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3480.64,1187.87 c -1.74,1.69 -3.74,2.87 -6.05,3.47 -1.24,0.31 -2.6,0.46 -3.94,0.56 l -0.68,0.1 -0.55,0.03 c -5.04,0.48 -9.99,-1.37 -13.24,-6.38 -4.17,-5.06 -5.32,-12.71 -4.23,-19.26 0.54,-3.22 1.85,-6.23 3.24,-9.11 6.66,-13.79 24.6,-13.9 32.79,-2.22 8.25,11.77 3.51,26.43 -7.34,32.81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4336",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3478.92,1120.94 c -6.46,13.97 -24.7,13.74 -32.78,2.22 -8.01,-11.42 -3.77,-26.09 6.73,-32.54 3.83,-4.28 8.81,-6.62 14.64,-5.75 6.21,0.92 13.29,6.33 14.41,13.69 1.27,8.39 0.52,14.8 -3,22.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4338",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3486.79,1053.58 c -9.15,5.91 -22.51,-1.52 -21.92,-13.87 0.1,-2.06 0.2,-4.12 0.29,-6.18 0.43,-8.95 9.61,-16.57 17.25,-10.92 1.47,1.09 2.92,2.16 4.38,3.24 8.91,6.6 9.88,21.35 0,27.73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4340",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3465.29,1028.59 v -1.13 1.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4342",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3394.58,1171.09 c -9.02,0 -15.86,-6.42 -18.6,-14.84 -2.77,-5.13 -3.75,-11.75 -2.23,-16.93 2.56,-8.72 9.82,-15.78 18.48,-15.53 10.22,0.31 19.81,7.67 21.79,19.15 2.42,14.03 -5.65,28.15 -19.44,28.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4344",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3362.75,1094.85 v -1.13 1.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4346",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3270.83,1090.95 v -1.13 1.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4348",
    style: {
      fill: "#f24d72",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3270.83,1108.3 c -3.54,0.37 -7.07,0.74 -10.61,1.12 -5.91,0.61 -11.74,-5.15 -13.23,-11.11 -1.63,-6.55 1.11,-13.59 6.31,-17.08 3.1,-2.1 6.22,-4.2 9.33,-6.3 8.99,-6.07 21.13,-0.25 23.86,10.7 2.96,11.85 -5.3,21.57 -15.66,22.67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4350",
    style: {
      fill: "#f89b87",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3702.74,1701.1 0.04,-0.01 -0.04,0.01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4352",
    style: {
      fill: "#f57458",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4037.63,1203.88 c -71.7,0 -143.4,-81.94 -194.62,-10.24 -22.32,29.75 -6.78,54.08 15.15,73.03 l -2.4,1.36 c 4.07,3.03 8.18,7.03 11.05,9.29 2.05,1.6 3.41,3.5 4.5,5.5 -22.92,-3.31 -44.2,5.91 -55.05,32.02 -26.06,-12.77 -44.4,-46.51 -30.22,-74.24 7.12,-13.93 20.17,-22.64 33.45,-29.93 1.04,-0.57 2.04,-1.19 3.05,-1.8 -22.6,-9.68 -33.35,-29.56 -47.41,-48.46 -6.07,-0.58 -11.71,-1.37 -17.28,-2.7 -6.08,4.79 -12.14,7.45 -20.24,6.5 -7.91,-0.93 -14.84,-5.05 -19.03,-11.99 -3.51,-5.83 -4.78,-12.6 -4.43,-19.54 -9.63,-7.7 -19.15,-15.68 -28.53,-23.91 -0.89,1.01 -1.62,2.05 -2.56,3.03 -2.03,2.08 -6.3,5.04 -11.53,8.41 -1.31,12.01 -9.81,23.94 -20.23,29.44 5.09,2.53 9.94,5.56 14.36,8.96 24.73,-3.85 43.4,16.5 50.63,43.3 2.05,7.62 -4.89,15.59 -12.88,13.31 -4.03,-1.15 -23.74,-11.15 -25.46,-9.66 -1.88,1.62 -3.97,2.94 -6.13,4.08 4.74,10.8 4.48,22.09 -1.9,32.93 13.32,5.45 25.43,14 34.42,24.88 6.56,7.93 11.22,17.35 14.04,27.32 -6.08,-2.77 -12.27,-5.69 -18.77,-8.95 -20.49,-10.24 -20.49,-61.45 -61.46,-51.22 -30.73,0 20.49,71.7 -30.73,81.95 -10.24,0 -30.72,-20.48 -30.72,-30.73 0,-38.39 8.99,-94.78 -40.47,-101.71 2.47,-5.75 4.94,-11.51 7.51,-17.24 -0.61,-1.36 -1.32,-2.59 -1.83,-4.05 -2.22,-6.43 -4.46,-13.06 -6.65,-19.77 -6.79,2.35 -13.64,4.44 -20.53,6.31 -5.6,10.63 -18.28,17.9 -31.25,15.09 -5.71,-1.24 -12.39,-3.89 -19.32,-6.73 -5.45,0.27 -10.94,0.34 -16.48,0.17 -8.52,12.55 -18.23,16.82 -32.76,19.84 -13.66,2.84 -26.88,3.2 -38.53,-0.93 l 0.87,0.66 c -6.68,-2.13 -13.6,-4.17 -20.56,-5.79 -1.5,0.12 -5.09,0.12 -9.04,0.36 -0.08,0.85 -0.2,2.07 -0.4,4.1 -1.63,16.9 -2.79,32.72 -10.43,48.16 -1.04,2.11 -2.16,4.04 -3.35,5.89 -10.35,-5.76 -21.02,-9.92 -33.34,-5.81 20.48,-20.49 20.48,-51.22 0,-61.47 -24.47,-8.15 -29.48,35.49 -40.83,43.36 l -2.21,0.62 -0.73,0.54 c -2.19,0.23 -4.61,-0.71 -7.45,-3.54 -25.76,-25.75 -31.26,-59.61 -26.71,-93.91 7.82,6.34 13.77,14.3 17.64,23.27 14.94,-8.74 32.06,-17.17 49.9,-23.83 9.56,-6.52 18.96,-12.95 28.37,-17.41 26.59,-12.58 53.34,-15.05 82.02,-13.33 8.75,-7.23 19.33,-10.74 31.98,-10.57 8.19,0.11 16.02,1.81 23.45,4.61 -0.46,-2.83 -0.77,-5.68 -0.78,-8.54 -0.03,-5.86 0.9,-11.54 2.62,-16.84 -6.98,-1.18 -13.69,-2.81 -19.65,-5.53 -16.29,-7.43 -26.94,-21.55 -37.89,-35.15 -2.3,-2.86 -11.3,-14.06 -16.25,-22.33 -2.58,2.66 -5.12,5.34 -7.8,7.891 l -1.45,1.348 c 0.33,14.781 -4.54,30.341 -12.32,41.731 -5.26,7.7 -10.62,12.92 -18.92,15.6 -6.49,2.1 -14.51,2.31 -18.52,-4.54 -2.38,-4.08 -3.92,-8.54 -5.04,-13.14 -20.85,9.87 -43.56,13.95 -67.25,6.16 -3.99,-1.32 -7.55,-2.83 -10.77,-4.57 1,1.44 2.1,2.9 3.43,4.43 6.29,7.29 9.58,18.27 3.95,27.14 -1.23,1.94 -2.45,3.87 -3.68,5.8 -4.37,6.9 -11.04,12.01 -18.48,14.48 3.12,-12.43 7.22,-24.69 11.91,-36.41 -102.43,30.72 -40.98,-51.22 -81.94,-112.681 -30.74,40.98 -71.7,61.461 -122.92,30.742 10.24,-10.25 10.24,-10.25 20.49,-20.492 -20.49,0 -40.97,20.492 -61.46,10.242 10.24,-20.492 20.49,-51.211 10.24,-51.211 -61.45,-30.731 -102.43,-20.488 -133.16,-92.192 0,-2.796 -3.9,-4.019 -9.88,-3.968 -0.2,-3.008 -0.83,-5.559 -2.53,-7.078 0.62,0.55 -15.21,-1.493 -19.99,-4.18 -7.86,-4.422 -14.69,-14.871 -12.27,-24.16 l 0.74,-2.864 c 1.93,-7.367 8.55,-15.789 16.56,-17.097 21.25,-3.492 41.23,-2.992 56.69,13.918 12.53,13.722 15.73,34.211 21.7,51.152 l 0.27,1.039 c 3.03,3.262 7.34,6.371 10.75,9.082 6.42,5.117 13.6,9.488 19.57,15.117 5.63,5.289 11.47,11.34 16.81,17.891 3.39,1.93 6.78,3.969 10.15,6.121 2.81,1.789 6.23,4.25 10.04,7.039 2.88,-21.351 21.96,-31.219 43.24,-32.508 10.76,-0.66 15.98,15.778 5.99,20.778 -11.48,5.75 -16.2,11.472 -11.67,23.84 1.46,3.968 3.48,7.691 5.65,11.332 -0.17,-0.5 0.79,0.609 1.97,2.046 3.69,0.704 7.16,0.754 10.21,-0.207 16.81,-5.312 20.53,-23.859 46.6,-21.949 10.99,0.817 19.72,4.86 25.94,11.469 4.06,-4.449 9.22,-8.02 15.24,-10.09 30.29,-10.391 72.31,1.598 89.75,29.109 2,0.801 3.93,1.731 5.87,2.641 2.21,-1.82 4.63,-3.473 7.47,-4.723 1.04,-0.457 2.16,-0.738 3.26,-1.078 12.09,-20.121 37.22,-40.398 19.24,-56.48 -16.75,-14.981 -47.98,-12.36 -66.93,-27.078 -9.81,-7.602 -4.46,-24.992 6.84,-27.731 34.8,-8.461 88.87,-2.98 113.78,25.809 l 0.4,0.5 c 7.26,-2.121 16.07,-0.27 21.61,6.98 10.78,14.078 22.08,26.551 35.84,37.739 13.88,11.281 7.22,30.722 -4.46,39.73 -1.17,0.91 -2.29,1.953 -3.44,2.91 l 1,-0.23 c 25.22,-4.438 50.29,-5.16 74.74,3.183 17.43,5.95 31.01,16.95 45.17,27.137 8.22,-17.379 24.29,-33.848 35.06,-46.117 12.6,-14.363 23.26,-26.942 42.81,-31.652 22.61,-5.45 45.79,-0.321 68.27,-6.52 15.97,-4.41 29.94,12.898 21.89,27.531 -6.78,12.34 -16,19.86 -26.52,25.02 3.36,2.371 7.4,5.359 11.29,8.551 2.61,-2.59 5.68,-4.993 9.7,-6.93 10.93,-5.262 21.28,-7.813 31.39,-8.551 12.57,-5.031 26.67,-3.98 39.64,4.66 1.99,1.309 3.72,2.758 5.34,4.25 5.92,2.59 11.89,5.52 17.99,8.969 2.5,1.422 4.88,2.84 7.2,4.242 2.58,0.809 5.21,1.637 7.91,2.5 23.9,7.578 46.83,6.278 69.66,1.778 13.66,-6.141 27.23,-13.122 41.61,-15.848 l 1.91,-0.293 c 2.62,-19.617 19.13,-37.238 42.4,-29.43 15.98,5.36 19.58,7.262 23.44,3.852 -24.65,86.281 -124.66,47.64 -167.28,124.719 -14.02,-3.79 -41.53,-21.411 -61.6,-31.821 -4.74,7.93 -9.21,15.16 -18.18,20.453 0.53,1.378 1.09,2.758 1.59,4.158 4.24,0.88 8.67,2.39 13.3,4.75 19.72,10.04 35.72,24.24 52.2,37.47 9.41,-4.91 23.11,1.42 22.77,13.24 -0.03,1.05 -0.31,2 -0.52,2.97 5.03,3.23 10.35,6.09 15.86,8.66 l 1.1,-1.43 c 11.69,-12.47 24.32,-7.38 37.12,-13.44 7.16,-3.4 15.03,-3.44 21.59,-0.84 11.67,-6.15 23.78,-10.95 34.6,-9.9 5.01,15.34 9.53,28.99 14.02,41.17 -4.26,1.2 -8.89,1.14 -12.7,-0.6 -8.52,-3.9 -25.65,15.04 -32.49,20 -4.62,3.34 -9.34,4.26 -13.77,3.66 4.17,9.51 7.8,20.14 14.83,25.85 -2.58,-3.47 20.24,0.71 25.74,1.27 14.57,1.49 29.52,3.78 43.63,7.72 2.6,0.73 5.07,1.63 7.58,2.47 20.45,23.15 50.78,39.35 105.4,57.55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4354",
    style: {
      fill: "#f89b87",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3474.27,1285.82 c -12.19,-8.12 -26,-9.76 -40.14,-8.83 10.82,-9.76 21.64,-19.51 32.47,-29.27 -5.28,-9.96 0.25,-25.65 12.49,-29.51 -9.83,20.1 -10.39,45.34 -4.82,67.61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4356",
    style: {
      fill: "#f89b87",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3910.67,1066.3 c 4.27,9.73 -2.73,17.26 -11.26,19.66 -4.49,-12.18 -9.01,-25.83 -14.02,-41.17 9.98,0.97 18.87,6.89 25.28,21.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4358",
    style: {
      fill: "#f89b87",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4235.38,1137.21 -0.24,-0.73 c -0.64,0.71 -1.47,1.64 -2.64,2.91 -2.1,2.26 -4.95,4.24 -7.54,5.83 -4.87,3.01 -10.76,4.87 -16.25,6.85 3.73,5.56 7.21,11.94 11.07,19.3 2.32,4.41 -2.35,10.43 -7.15,7.4 -9.9,-6.25 -37.2,-0.94 -47.96,0.36 -10.74,1.29 -20.86,5.53 -30.54,10.65 1.96,6.99 3.13,14.27 3.88,21.45 1.51,14.48 -5.09,42.43 11.85,45.82 18.91,3.77 19.09,33.21 0.63,37.8 -19.76,4.91 -39.4,3.46 -53.43,-12.91 -15.61,-18.19 -11.25,-38.92 -16.57,-60.28 -3.14,-12.59 0.18,-11 -13.76,-12.48 -13.07,-1.37 -30.71,5.34 -43.79,7.45 -10.21,1.65 -20.48,3.02 -30.46,3.36 -1.54,3.67 -3.63,7.21 -6.31,10.54 -3.18,3.97 -5.33,9.27 -6.61,15.36 16.91,14.94 28.17,31.26 33.04,49.84 8.97,0.46 18.07,3.73 26.83,10.73 7.04,5.63 12.33,12.76 18.5,19.23 2.02,2.13 5.74,4.7 8.33,7.36 3.34,-0.56 6.66,-1.19 10.05,-1.62 37.06,-4.79 41.13,49.08 11,61.98 0.06,6.52 -0.05,13.05 -0.2,19.79 -0.16,6.58 0.5,13.18 0.1,19.72 -0.11,1.63 -1.34,6.13 -1.53,9.07 0.37,0.66 1.32,3.68 2.48,5.26 8.9,12.12 -7.44,26.11 -19.22,19.86 -1.05,-0.55 -5.81,-3.79 -7.66,-5.11 -1.15,-0.54 -7.05,-3.85 -7.8,-4.31 -8.97,-5.39 -14.45,-12.02 -18.69,-21.32 -5.13,-11.29 -8.75,-22.98 -12.34,-34.72 -10.56,-5.88 -18.32,-16.37 -22.13,-30.55 -18.35,-0.67 -36.93,-10.07 -53.24,-27.25 -32.43,-34.14 -43.13,-85.7 -26.65,-128.72 -6.35,-2.34 -13.9,-3.26 -21.93,-3.48 -2,19.57 -13.08,38.11 -31.53,50.04 -2.83,1.84 -5.83,3.39 -8.81,4.98 -21.93,-18.95 -37.47,-43.28 -15.15,-73.03 51.22,-71.7 122.92,10.24 194.62,10.24 -54.62,-18.2 -84.95,-34.4 -105.4,-57.55 1.85,0.62 3.78,1.16 5.6,1.82 6.12,-5.35 13.99,-9.01 22.57,-9.9 15.07,-1.56 27.23,4.71 41.9,6.04 14.96,1.35 29.61,-2.65 44.48,-3.01 h 0.46 c 1.52,-0.96 3.1,-1.87 4.84,-2.62 15.17,-6.54 30.59,-6.96 46.73,-9.26 4.92,-0.7 9.34,0.07 13.28,1.84 11.91,-2.89 24.22,-3.74 36.72,-3.52 l 1.08,-0.57 c 1.32,-5.09 4.6,-9.72 10.38,-12.77 l 2.65,-1.41 c 10.2,-5.38 19.78,-3.59 28.55,3.22 -3.34,-2.59 -1.39,-0.78 2.34,-2.82 4.53,-2.49 10.85,-4.79 15.83,-5.8 6.11,-1.23 12.91,-0.76 18.52,2.05 1.41,0.71 2.62,1.79 3.89,2.74 1.08,0.07 6.01,1.68 6.07,1.7 12.13,4.34 11.16,22.53 -2.74,23.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4360",
    style: {
      fill: "#f89b87",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3871.31,1282.82 c 5.26,9.67 0.17,22.78 -8.35,28.92 -15.11,10.9 -32.1,10.26 -46.7,3.1 10.85,-26.11 32.13,-35.33 55.05,-32.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4362",
    style: {
      fill: "#f89b87",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3248.92,1203.88 c 2.84,2.83 5.26,3.77 7.45,3.54 -10.8,8.54 -25.13,12.31 -37.69,7.6 0.08,1.05 0.15,2.1 0.16,3.15 l 0.01,0.1 c 0.2,1.4 0.45,3.05 0.76,5.12 0.07,1.32 0,2.64 0.05,3.97 0.01,0.3 0.09,1.34 0.17,2.24 l 0.12,0.73 c 0.34,1.86 0.7,3.7 0.99,5.55 5.89,13.34 -3.26,32.6 -19.52,31.31 -1.63,-0.12 -3.26,-0.37 -4.89,-0.55 -7.46,0.38 -14.36,-0.77 -21.39,-4.98 -6.34,-3.77 -11.66,-8.79 -16.23,-14.51 -3.06,-3.83 -5.31,-8.06 -7.04,-12.53 -5.54,1.27 -11.15,2.39 -16.9,3.2 -7.2,1 -34.16,-2.25 -38.88,1.21 -8.34,-1.05 -5.37,0.37 8.9,4.23 1.67,7.15 1.75,14.3 0.23,21.44 -2.02,12.21 -5.69,19.62 -14.36,28.11 -9.01,8.82 -18.55,8.86 -28.5,14.84 -1.47,0.3 -2.76,0.56 -3.89,0.77 -3.76,4.07 -5.67,8.85 -5.46,14.43 0.23,4.8 -2.57,9.69 -6.61,12.78 -2.3,10.32 -4.35,20.69 -6.24,31.02 -2.6,14.24 -20.03,16.05 -29.55,8.33 -2.29,3.67 -4.59,7.34 -6.88,11.01 5.71,23.82 -27.19,32.78 -36.03,10.57 -13.84,-34.79 4.45,-53.84 29.93,-56.04 -6.83,-30.68 -4.15,-61.57 6.94,-92.67 2.47,-6.93 5.48,-13.45 8.71,-19.85 -5.47,1.42 -10.74,2.96 -15.81,4.76 -5.08,16.25 -20.25,23.86 -35.44,22.61 -5.54,5.88 -10.88,13.03 -16.06,22.01 -1.78,3.07 -4.54,5.35 -7.67,7 -0.52,1.29 -1.01,2.57 -1.61,3.87 -7.67,16.43 -30.24,13.58 -39.17,0.64 -1.33,-1.92 -2.33,-4.1 -3.41,-6.22 -3.16,1.24 -6.43,2.32 -9.85,3.06 -11.62,2.51 -23.51,1.02 -34.9,-2.06 -1.38,1.81 -2.72,3.47 -3.76,4.68 -7.91,9.31 -21.21,7.08 -29.69,0.49 -15.16,-11.75 -18.89,-37.89 -9.05,-54.33 10.92,-18.23 32.09,-20.26 51.02,-16.77 2.98,0.55 5.94,1.21 8.84,2.06 0.9,0.26 2.5,0.28 3.67,0.3 l 1.69,-0.9 c 4.13,-3.21 7.54,-7.64 11.07,-11.45 3.56,-3.82 7.11,-7.41 10.74,-10.74 -3.81,-2.28 -7.34,-5.13 -10.37,-8.61 l -1.68,0.37 c -10.21,2.5 -22.07,-8.98 -15.18,-19.08 4.43,-6.51 9.17,-10.41 15.57,-14.92 5.76,-4.04 15.79,-2.94 20.53,2.3 2.68,2.96 4.75,5.63 7.63,7.78 1.44,0.13 2.77,0.08 4.55,-0.92 11.58,-6.51 22.66,-0.26 27.38,8.89 7.44,-14.86 18.99,-26.41 38.66,-30.37 11.32,-2.28 22.86,-0.68 34.25,-2.32 19.9,-2.86 29.7,-14.44 41.96,-28.61 -3.59,-6.8 -6.68,-13.78 -8.46,-21.16 -3.61,-14.99 1.43,-29.67 14.8,-37.83 14.62,-8.91 31.93,-4.21 39.81,10.7 2.08,3.92 2.95,9.35 0.22,13.29 0.93,-1.35 0.2,-0.01 -0.66,1.49 0.76,1.36 1.53,2.75 1.83,3.23 6.38,10.21 13.46,19.32 19.04,29.78 24.61,-12.1 50.65,-20.71 77.2,-12.4 8.22,2.57 15.26,6.5 21.24,11.35 -4.55,34.3 0.95,68.16 26.71,93.91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4364",
    style: {
      fill: "#f89b87",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3300.14,1162.9 c 20.48,10.25 20.48,40.98 0,61.47 12.32,-4.11 22.99,0.05 33.34,5.81 -2.96,4.65 -6.42,8.63 -10.9,12.52 3.51,-3.05 -9.02,6.32 -5.62,4.4 -1,0.57 -6.02,2.18 -8.7,2.94 -3.11,1.26 -8.23,3.21 -10.01,3.58 -7.26,1.51 -14.16,0.73 -21.19,-1.44 -15.71,-4.85 -14.22,-30.04 3.53,-29.77 0.7,0.01 2.32,-0.21 3.84,-0.34 l -0.03,-0.44 c -0.61,-9.7 -1.16,-14.63 -1.42,-23.35 -7.82,3.42 -15.71,6.05 -23.67,7.98 11.35,-7.87 16.36,-51.51 40.83,-43.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4366",
    style: {
      fill: "#f89b87",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3768.86,1011.34 c -0.95,-0.11 -2.17,-0.52 -3.3,-0.82 42.62,-77.079 142.63,-38.438 167.28,-124.719 2.58,-2.289 5.26,-6.93 11.84,-14.59 12.15,-14.191 32.74,-29.629 50.55,-35.332 17.49,-5.59 36.96,-4.41 53.06,4.551 7.72,4.312 11.78,8.84 14.83,13.761 14.11,-9.519 27.34,-27.382 48.97,-24.5 34.3,4.559 46.53,36.321 59.53,63.661 7.58,15.949 -10.55,32.418 -24.76,19.769 -13.18,-11.75 -26.11,-23.109 -38.27,-17.242 -8.64,4.16 -15.25,18.312 -24.74,23.68 -27.87,15.722 -45.07,6.972 -68.22,-7.477 -2.99,-1.863 -4.42,-3.293 -5,-4.352 -1.21,3.149 -11.97,16.54 -12.73,17.61 -4.53,6.289 -8.03,11.808 -12.83,16.871 6.13,6.25 10.43,14.441 11.3,22.848 16.69,-3.11 31.29,10 33.73,26.07 13.28,-2.649 26.68,-7.238 38.86,-11.18 18.51,-6 25.74,21.471 8.37,28.481 -13.21,5.34 -26.2,12.1 -39.31,18.02 8.5,6.7 9.98,8.95 21.41,8.76 19.22,-0.31 28.13,22.84 15.86,36.55 -40.4,45.17 -98.9,-6.18 -132.37,-33 -7.71,-6.18 -11.11,-13.51 -11.64,-20.86 -3.48,-3.02 -6.78,-6.19 -9.76,-9.52 l -0.08,-0.1 c -5.44,-0.95 -10.72,-2.54 -15.67,-5.06 -14.38,1.27 -26.17,-9.861 -30.75,-23.021 -16.5,5.442 -34.77,17.332 -45.98,21.541 -1.33,0.5 -2.66,0.96 -4,1.43 -14.49,1.13 -30.33,3.93 -45.16,8.77 -3.64,-0.01 -7.31,-0.16 -11.02,-0.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4368",
    style: {
      fill: "#f89b87",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2869.93,814.648 c 30.73,71.704 71.71,61.461 133.16,92.192 10.25,0 0,30.719 -10.24,51.211 20.49,10.25 40.97,-10.242 61.46,-10.242 -10.25,10.242 -10.25,10.242 -20.49,20.492 51.22,30.719 92.18,10.238 122.92,-30.742 40.96,61.461 -20.49,143.401 81.94,112.681 -4.69,11.72 -8.79,23.98 -11.91,36.41 -7.88,2.6 -16.63,2.22 -24.54,-2.44 -2.99,-1.75 -5.98,-3.51 -8.97,-5.27 -2.4,-1.42 -4.38,-3.28 -6.15,-5.32 -7.94,-3.04 -14.24,-11.39 -17.9,-19.79 -0.77,-1.76 -1.14,-3.71 -1.18,-5.73 -5.49,-5.73 -9.75,-12.73 -11.82,-22.49 -1.96,-9.28 -0.29,-18.82 1.68,-27.981 0.23,-1.078 0.41,-2.168 0.59,-3.238 -12.89,10.319 -23.89,25.349 -38.89,32.719 -21.45,10.55 -46.13,11.68 -69.13,5.56 -7.93,-2.11 -15.94,-5.53 -23.36,-9.35 -1.67,14.43 -4.83,28.9 -12.12,40.42 -7.25,11.42 -22.88,11.8 -30.47,0.5 -1.96,-2.92 -3.52,-6.04 -4.92,-9.25 -14.55,7.56 -31.73,10.25 -47.83,7.14 -4.35,-0.84 -14.73,-2.19 -18.24,-5.43 -0.76,11.36 2.12,33.13 2.12,36.92 -0.01,29.32 -39.5,50.74 -61.13,26.51 -5.06,-5.66 -42.84,-46.95 -26.81,-13.84 12.86,26.53 -19.71,58.71 -42.98,34.32 -5.04,-5.29 -9.58,-11.22 -13.53,-17.5 l -1.65,1.17 c -6.4,3.87 -13.03,5.29 -20.26,6.51 -3.1,0.5 -4.68,0.45 -5.44,0.24 -0.17,0.75 -0.82,2.07 -2.64,4.39 -6.06,7.75 -18.63,3.13 -21.16,-5.21 -1.84,-6.08 -3.49,-11.76 -3.47,-17.32 -1.91,-0.44 -4.72,-1.1 -5.28,-2.12 -9.23,-3.22 -17.19,-12.25 -16.82,-22.46 0.76,-20.97 15.21,-34.9 33.65,-42.48 12.53,-5.13 28.73,-8.14 42.72,-5.5 2.46,-2.7 5.41,-5.21 8.6,-7.62 -2.36,-1.5 -4.65,-3.16 -6.8,-5.1 -5.32,0.74 -11.08,-0.02 -14.97,-2.69 l -4.93,0.94 c -13.51,10.55 -32.02,-3.32 -32.6,-17.99 -0.2,-4.97 -22.54,-4.55 -27.23,-5.26 -6,-0.91 -6.93,-8.7 -3.55,-12.579 16.1,-18.449 36.7,-20.672 53.58,-10.359 7.07,-3.172 14.48,-3.902 22.39,-2.043 l 1.96,-1.481 c 10.46,-7.476 26.85,-2.476 33.05,8.082 8.18,13.969 22.55,9.79 36.95,9.872 6.68,0.039 13.47,2.73 18.15,7.578 10.42,-20.438 29.36,-33.34 63.56,-28.188 4.81,0.719 15.52,2.567 20.39,6.317 2.85,-9.309 5.81,-20.68 7.84,-23.95 3.41,-5.468 7.51,-10.687 12.12,-15.437 -1.69,-1.34 -3.41,-2.723 -5.19,-4.121 -13.63,-1.762 -23.43,-10.762 -32.35,-21.61 -5.51,-2.339 -10.08,-2.972 -12.79,-0.562 -12.21,10.851 -31.81,13.703 -44.16,0.73 -20.53,-21.558 -36.93,-20.48 -60.66,-5.14 -8.98,5.812 -22.1,0.66 -24.85,-9.629 -7.65,-28.699 10.64,-53.61 39.33,-60.668 15.15,-3.731 30.3,-2.16 44.55,2.707 -1.37,-4.559 -2.35,-9.238 -3.04,-13.731 -0.85,-5.507 0.21,-12.367 -0.14,-17.718 5.98,-0.051 9.88,1.172 9.88,3.968"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4370",
    style: {
      fill: "#f89b87",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3371.83,1285.82 c 8.57,0 17.93,-1.6 27.64,-3.45 8.2,1.01 16.15,2.42 23.48,4.7 3.73,-3.36 7.46,-6.71 11.18,-10.08 14.14,-0.93 27.95,0.71 40.14,8.83 -5.57,-22.27 -5.01,-47.51 4.82,-67.61 1.4,-0.45 2.83,-0.84 4.4,-0.95 12.14,-0.79 24.64,0.69 37.01,0.98 1.46,-2.86 2.98,-5.75 4.33,-8.58 3.92,-8.27 7.65,-16.88 11.4,-25.55 49.46,6.93 40.47,63.32 40.47,101.71 0,10.25 20.48,30.73 30.72,30.73 51.22,-10.25 0,-81.95 30.73,-81.95 40.97,-10.23 40.97,40.98 61.46,51.22 6.5,3.26 12.69,6.18 18.77,8.95 2.24,7.94 3.37,16.23 3.17,24.45 -0.2,8.58 -4.39,17.32 -6.3,25.69 14.96,-8.56 35.52,0.51 45.73,15.79 13.05,4.48 24.81,10.83 35.68,19.13 l 0.58,-0.07 c 2.67,-5.19 7.27,-9.47 14.08,-11.51 0.29,-0.09 2.19,-0.61 3.35,-0.86 l 0.89,-0.61 c 0.7,-1.22 6.5,-7.75 3.22,-3.36 4.89,-6.56 9.12,-13.67 15.3,-19.13 9.81,-8.68 25.13,-11.25 37.04,-5.22 12.07,6.11 20.22,21.02 9.64,32.69 -2.82,3.12 -8.44,5.58 -11.63,6.25 -1.1,1.32 -2.31,2.58 -3.54,3.82 -0.4,0.65 -2.88,3.8 -3.58,4.8 -1.77,2.52 -3.63,4.96 -5.55,7.33 2.62,1.86 5.17,3.88 7.63,6.06 5.59,4.98 10.13,10.35 13.96,15.95 4.22,-0.18 8.54,0.02 13.23,0.89 2.18,0.41 3.49,0.77 3.7,0.92 4.05,0.44 8.15,0.59 12.16,1.42 3.1,0.65 6.15,1.4 9.14,2.25 8.5,-3.23 17.84,-4.92 26.45,-6.04 6.09,-0.79 11.95,-0.7 18.06,-0.6 8.4,0.13 14.45,2.08 22.42,3.62 14.76,2.87 12.78,23.1 0.45,27.55 -9.72,3.51 -18.8,10.57 -28.11,17.12 -1.46,7.67 -5.75,14.75 -13.15,18.93 l -2.08,1.08 c 3.96,2.69 7.8,5.49 11.45,8.27 7.05,-4.06 16.03,-5.53 26.35,-2.89 12.79,3.26 21.61,12.65 27.16,24.2 2.39,4.99 12.07,40.01 4.56,41.84 14.88,-3.62 27.84,14.74 15.97,26.42 -12.86,12.65 -31,12.58 -45.12,1.3 -7.15,-5.7 -11.48,-13.82 -13.97,-22.49 -0.72,-2.49 -1.89,-6.22 -2.57,-9.78 -3.46,0.88 -7.17,0.83 -10.89,-0.64 -3.86,-1.52 -9.22,-3.45 -15.26,-5.71 -5.92,22.87 -17.44,43.94 -33.78,61.25 l 12.38,14.41 c 7.81,4.54 7.79,19.19 -2.4,21.03 -7.62,1.37 -14.58,1.95 -21.15,1.76 0.16,1.58 0,3.18 -0.57,4.75 -1.08,2.95 -1.91,5.56 -2.71,8.47 -0.54,1.98 -3.9,11.43 -2.83,8.7 1.43,-3.6 -1.48,3.82 -1.71,4.25 -0.5,0.99 -1.07,1.91 -1.65,2.87 l -0.44,0.62 c 0.51,3.05 0.97,6.11 1.53,9.2 1.32,7.41 -0.25,11.31 2.91,17.45 1.8,3.5 -1,6.7 -4.64,6.25 -9.29,-1.16 -13.49,-0.45 -21.18,-5.49 -8.69,-5.68 -15.5,-13.53 -20.25,-22.65 -4.34,-8.39 -4.14,-19.11 2.93,-26.1 2.68,-2.64 5.34,-4.9 8.62,-6.67 1.12,-2.89 2.95,-6.89 3.57,-8.2 0.74,-1.55 1.86,-2.89 3.13,-4.12 -4.32,-2.92 -8.61,-6.34 -12.92,-10.62 -13.71,-13.62 -9.74,-33.84 4.98,-44.47 14.87,-10.7 23.8,-22.69 27.15,-36.74 -13.34,10.18 -32.51,8.79 -44.95,-0.84 -1.24,5.8 -2.15,11.61 -2.65,16.57 -1.49,14.65 -21.05,29.02 -33.24,14.4 -16.5,-19.78 -21.14,-39.86 -13.96,-65.36 4.37,-15.51 14.11,-34.24 27.87,-45.72 -1.02,-0.33 -2.1,-0.39 -3.34,0.22 -14.97,7.42 -35.27,8.11 -47.62,-5.34 -1.57,-1.72 -3.12,-3.3 -4.68,-4.79 -3.39,9.98 -7.8,19.42 -11.67,29.6 -5.33,13.99 -28.38,14.08 -28.12,-3.33 0.22,-15.19 -0.31,-30.63 -1.03,-46.08 -2.48,-0.9 -4.76,-1.98 -6.84,-3.32 -20.65,-2.63 -39.6,-10.63 -53.04,-30 -10.76,-15.52 -12.74,-33.07 -10.97,-51.5 1.63,-16.8 3.01,-28.83 -17.52,-22.68 -11.21,3.35 -23.9,1.24 -33.5,-5.42 -1.34,1.03 -2.71,1.76 -4.06,2.57 12.39,19.17 13.44,44.21 -1.14,65 2.28,1.69 4.71,4.31 7.31,8.08 17.71,13.01 26.36,31.17 26.98,48.83 11.05,4.85 20.42,14.53 23.96,25.28 1.26,3.8 2.5,7.59 3.75,11.39 16.83,15.02 31.59,34.88 36.63,56.78 1.43,0.47 2.87,0.94 4.32,1.68 35.76,17.98 62.83,49.24 51.15,86.7 l 1.46,2.45 c 2.26,0.15 4.49,0.3 6.81,0.36 28.31,0.73 34.14,33.38 14.23,49.29 -2.71,2.16 -6.32,14.13 -8.64,17.94 -4.64,7.63 -15.49,11.82 -23.58,6.6 -5.97,-3.85 -9.83,-8.63 -12.33,-13.86 -1.74,3.96 -4,7.3 -7.7,9.91 -1.9,2.67 -6.69,5.18 -8.75,5.82 l -1.33,0.28 0.34,-0.71 -0.17,0.35 0.07,-0.03 -0.28,0.4 -0.06,0.01 c -1.91,3.18 -4.95,5.71 -8.88,7.12 l -0.19,0.07 c -6.33,2.25 -14.58,-1.15 -17.84,-6.92 -4.35,-7.68 -1.75,-15.69 3.56,-21.84 -0.12,-1.55 -0.15,-3.11 0.04,-4.73 0.87,-7.41 3.93,-13.33 9.21,-18.64 3.46,-3.47 7.89,-5.2 12.4,-5.58 -2.85,-4.8 -6.39,-9.6 -8.75,-13.73 -5.8,-10.14 -4.44,-22.72 3.51,-31.28 5.13,-5.53 -5.33,-11.59 -15.59,-16.27 -4.21,9.68 -9.84,18.52 -17.03,24.26 1.12,5.62 -4.23,10.17 -10.08,7.65 -1.61,-0.38 -3.21,-0.75 -4.81,-1.13 -4.17,-0.01 -9.57,-2.17 -11.4,-6.29 -4.23,-9.52 -2.92,-17.26 -4.59,-27.2 -2.02,-12.02 -8.55,-23.68 -14.55,-34.36 -5.94,-10.58 -13.94,-15.17 -23.01,-22.54 -3.35,-2.72 -6.07,-5.82 -8.36,-9.18 -5.93,-0.9 -11.6,-2.96 -16.84,-6.28 -1,7.54 -1.99,15.09 -3.03,22.63 6.89,0.32 13.58,3.11 19.07,7.97 12.29,10.9 14.89,27.56 11.55,43.05 -2.59,12.04 -10.85,20.82 -20.2,28.16 -6.43,5.07 -14.37,4.34 -20.78,0.56 -0.41,2.61 -0.95,5.26 -1.78,7.98 -1.72,5.54 -4.34,10.06 -7.48,13.81 14.49,5.09 21.33,19.72 17.51,33.8 -0.13,1.04 -0.16,2.09 -0.39,3.12 -0.47,1.83 -1.18,3.43 -1.98,4.95 -0.04,1.87 -0.36,3.74 -0.77,5.58 l 1.88,1.14 c 12.47,9.49 20.41,24.85 16.1,40.67 -1.31,4.81 -2.91,9.68 -3.76,14.47 l 2.19,0.97 c 10.01,5.64 13.46,18.03 9.28,28 0.64,4.64 -1.96,10.09 -6.68,10.86 -1.53,0.24 -2.98,0.25 -4.48,0.4 -7.1,3.04 -15.59,2.42 -21.89,-1.98 -14.46,-4.78 -24.66,-16.73 -26.07,-36.85 -0.89,-12.73 6.47,-19.29 7.97,-30.43 -1.63,12.03 -5.77,0.62 -6.95,-5.38 -0.22,-1.1 -0.21,-2.15 -0.31,-3.22 -3.66,-1.14 -7.12,-3.03 -10.11,-5.84 -4.16,-3.92 -7.99,-7.37 -11.3,-12.2 -2.45,-3.6 -3.94,-7.4 -4.91,-11.3 -9.42,11.34 -19.26,22.48 -25.63,35.31 24.43,13.1 20.23,58.57 -14.21,59.13 -31,0.52 -38.75,-36.3 -22.38,-53.74 -8.27,-12.87 -10.35,-27.56 -3.08,-46.76 5.76,-15.19 15.89,-25.7 25.33,-38.44 8.63,-11.67 13.61,-17.18 15.2,-25.44 -0.41,-3.5 -0.28,-7.08 0.38,-10.62 -0.1,-1.26 -0.15,-2.43 -0.34,-3.83 -1.14,-8.95 -3.27,-17.42 -5.11,-25.75 l -0.17,-0.18 c -9.01,-9.7 -10.27,-25.03 -2.13,-35.07 0.78,-4.12 2.13,-8.32 4.07,-12.61 -1.57,-18.96 -2.96,-37.94 -4.05,-56.92 -6.03,6.15 -12.3,11.13 -20.91,14.28 -11.64,4.25 -24.39,-6.21 -24.4,-17.96 -0.02,-10.98 4.08,-19.92 9.15,-29.45 3.69,-6.92 7.72,-14.46 13.69,-19.5 -6.87,-16.92 -12.5,-31.49 -33.95,-29.45 -11.84,1.13 -29.35,13.84 -40.22,18.27 l -2.27,0.88 c -1.8,6.93 -5.92,12.4 -11.36,16.05 21.79,23.34 43.69,56.02 49.94,81.63 4.65,19.13 -3.38,36.16 -16.54,49.75 -6.42,6.63 -14.36,12.22 -22.05,17.31 -1.81,1.2 -4.99,2.57 -6.26,4.43 l -1.06,1.15 c 0.91,0.61 2.31,1.99 4.49,5.23 9.32,13.79 -8.75,33.3 -22.99,23.76 -16.56,-11.11 -32.97,-22.98 -29.25,-45.55 2.28,-13.81 16.52,-31.93 29.42,-38.1 l 2.14,-1.95 c -6.5,-8.04 -11.44,-17.93 -17.82,-26.15 -3.11,-4.04 -7.13,-8.84 -11.31,-13.76 -4.63,3.59 -10.25,6.02 -16.44,6.76 -6.72,19.98 -28.84,27.49 -48.39,22.14 -4.75,9.46 -11.09,18.19 -20.77,25.87 -12.11,9.62 -24.4,15.67 -39.64,18.26 -1.38,0.23 -8.19,1.66 -13.31,2.31 -9.77,18.02 -40.51,18.69 -51.08,0.16 -20.23,-35.45 7.96,-61.09 41.82,-65.73 29.1,-3.99 25.36,-19.81 33.3,-45.63 0.69,-2.2 1.66,-4.34 2.77,-6.43 -1.37,-13.62 0.31,-26.91 4.49,-39.58 -3.95,-0.98 -7.85,-2.1 -11.66,-3.44 -10.72,10.5 -29.43,12.55 -41.54,-0.21 -3.78,8.27 -13.67,10.23 -21.8,6.84 -28.49,-11.91 -24.26,-51.6 -0.81,-66.82 8.26,-5.38 17.02,-7.35 25.5,-6.87 l 1.15,-1.45 c 10.37,-11.61 27.82,-12.51 40.99,-5.98 28.09,13.95 53.62,1.22 77.46,-13.92 11.6,-7.39 22.86,-7.74 32.22,-3.85 11.74,-4.51 23.74,-7.89 35.61,-9.86 10.4,-1.73 20.38,-2.36 30.09,-2.44 -1.73,1.67 -3.88,3.22 -6.61,4.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4372",
    style: {
      fill: "#f89b87",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3399.47,1282.37 c -9.71,1.85 -19.07,3.45 -27.64,3.45 2.73,-1.36 4.88,-2.91 6.61,-4.58 7.25,-0.06 14.27,0.3 21.03,1.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4374",
    style: {
      fill: "#f89b87",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3825.04,1003.17 c -14.73,5.24 -29.66,8.82 -45.16,8.77 14.83,-4.84 30.67,-7.64 45.16,-8.77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4376",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4029.6,1357.02 -0.33,1.68 c -2.01,10.21 -13.72,18.71 -23.98,18.25 -10.38,-0.46 -21.82,-7.3 -23.97,-18.25 l -0.34,-1.68 c -1.7,-8.7 -0.42,-18.19 6.49,-24.53 4.93,-4.53 11,-7.38 17.82,-7.38 6.47,0 13.25,2.81 17.82,7.38 6.72,6.72 8.26,15.51 6.49,24.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4378",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4054.79,1431.43 c -27.03,0 -27.08,-42.01 0,-42.01 27.03,0 27.07,42.01 0,42.01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4380",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3876.7,1302.42 c -2.65,6.28 -9.26,11.32 -16.37,11.01 -6.25,-0.28 -12.25,-3.37 -15.47,-8.87 -4.39,-7.51 -2.24,-15.4 2.8,-21.71 l 0.79,-0.99 c 5.24,-6.57 18.54,-6.53 23.77,0 l 0.78,0.99 c 4.61,5.77 6.71,12.45 3.7,19.57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4382",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3828.5,1254.99 c -7.71,0 -14.27,-6.56 -14.27,-14.28 0,-7.75 6.53,-14.28 14.27,-14.28 7.73,0 14.29,6.56 14.29,14.28 0,7.75 -6.53,14.28 -14.29,14.28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4384",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3881.54,1215.09 c -21.62,0 -21.66,-33.61 0,-33.61 21.63,0 21.66,33.61 0,33.61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4386",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3931.04,1250.06 c -16.58,0 -16.61,-25.77 0,-25.77 16.59,0 16.6,25.77 0,25.77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4388",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3966.39,1324.42 c -21.25,0 -21.29,-33.06 0,-33.06 21.27,0 21.31,33.06 0,33.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4390",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3998.22,1203.64 c -20.55,0 -20.58,-31.93 0,-31.93 20.55,0 20.58,31.93 0,31.93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4392",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4047.72,1195.28 c -9.52,0 -18.65,-8.38 -18.21,-18.21 0.45,-9.87 8.01,-18.21 18.21,-18.21 9.52,0 18.65,8.38 18.21,18.21 -0.44,9.87 -8,18.21 -18.21,18.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4394",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4124.14,1155.85 c -0.72,6.38 -6.31,11.19 -12.8,8.45 -5.78,-2.43 -7.78,-10.48 -2.98,-14.98 2.65,-2.5 4.92,-5.15 8.51,-6.21 3.24,-0.96 6.16,1.17 7.24,4.11 1.03,2.84 0.36,5.7 0.03,8.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4396",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4181.31,1139.38 0.03,-0.02 -0.51,0.9 -0.14,0.24 -0.66,1.21 c -3.63,7.65 -14.5,8.62 -20.58,3.93 -6.05,-4.67 -8.01,-15.49 -1.41,-20.9 2.58,-2.13 5.41,-4.67 8.88,-5.17 6.53,-0.95 12.96,1.05 15.62,7.67 1.73,4.29 1.06,8.6 -1.23,12.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4398",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4121.97,1298.65 c -24.51,0 -24.55,-38.09 0,-38.09 24.51,0 24.55,38.09 0,38.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4400",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3980.55,1045.59 c -31,0 -31.06,-48.168 0,-48.168 30.99,0 31.04,48.168 0,48.168"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4402",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3902.75,990.77 c -24.14,0 -24.19,-37.528 0,-37.528 24.15,0 24.19,37.528 0,37.528"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4404",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3899.22,942.84 c -21.62,0 -21.66,-33.61 0,-33.61 21.63,0 21.67,33.61 0,33.61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4406",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3828.88,991.09 -0.63,1.402 c -4.68,10.528 -23.1,10.528 -27.77,0 l -0.63,-1.402 c -2.51,-5.668 -3.29,-11.34 0,-16.961 2.99,-5.109 8.59,-8.32 14.51,-8.32 5.93,0 11.53,3.211 14.52,8.32 3.29,5.621 2.51,11.293 0,16.961"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4408",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3945.18,949.152 c -11.53,0 -11.55,-17.933 0,-17.933 11.54,0 11.56,17.933 0,17.933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4410",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3987.62,884.559 c -5.78,0 -5.79,-8.969 0,-8.969 5.76,0 5.77,8.969 0,8.969"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4412",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4065.4,898.41 c -5.41,0 -5.42,-8.398 0,-8.398 5.41,0 5.41,8.398 0,8.398"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4414",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4108.53,888.102 c -10.76,-4.543 -13.37,-18.383 -5.32,-26.793 1.93,-2 3.8,-4.039 5.81,-5.95 6.21,-5.89 19.22,-4.199 20.84,5.493 0.68,4.039 1.09,8.097 1.56,12.148 1.41,12.012 -13.19,19.191 -22.89,15.102"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4416",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4030.04,1098.79 c -26.67,0 -26.71,-41.44 0,-41.44 26.68,0 26.72,41.44 0,41.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4418",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3655.26,1319.58 c -24.15,0 -24.19,-37.52 0,-37.52 24.15,0 24.19,37.52 0,37.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4420",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3706.55,1287.53 -0.66,1.59 c -2.62,6.3 -7.76,11.97 -15.28,11.63 -7.6,-0.35 -12.46,-4.86 -15.27,-11.63 l -0.65,-1.59 c -4.23,-10.16 6.2,-20.91 15.92,-20.91 9.78,0 20.15,10.79 15.94,20.91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4422",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3691.48,1403.31 c -1.29,0.95 -2.54,1.55 -3.98,2.25 -9.89,4.84 -22.34,-0.93 -22.34,-12.81 0,-11.9 12.45,-17.65 22.34,-12.82 1.44,0.7 2.69,1.3 3.98,2.25 7.81,5.78 7.81,15.35 0,21.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4424",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3761.61,1387.64 c -2.61,1.31 -4.21,2.92 -7.26,3.76 -1.06,0.27 -2.14,0.24 -3.23,0.32 -13.18,7.44 -27.87,-7.66 -20.53,-20.75 2.9,-5.17 7.17,-9.29 12.66,-11.6 7.84,-3.31 15.55,-0.17 21.31,5.4 6.42,6.2 5.42,18.67 -2.95,22.87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4426",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3803.76,1450.69 c -9.96,0 -19.5,-8.76 -19.04,-19.05 0.45,-10.32 8.36,-19.05 19.04,-19.05 9.96,0 19.5,8.76 19.04,19.05 -0.46,10.32 -8.37,19.05 -19.04,19.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4428",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3846.7,1480.82 c -1.67,10.96 -12.94,19.25 -21.02,25.78 -8.52,6.9 -21.48,8.96 -29.7,0 -8.36,-9.11 -7.41,-20.55 0,-29.71 2.75,-3.4 5.37,-7.47 8.54,-10.49 4.65,-4.4 11,-9.57 17.24,-10.53 7.39,-1.12 14.16,-0.35 19.72,5.22 5.57,5.56 6.35,12.33 5.22,19.73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4430",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3878.01,1475.15 c -13.54,0 -24.31,-16.19 -16.2,-28.23 l 0.84,-1.27 c 7.69,-11.43 23.02,-11.43 30.71,0 l 0.85,1.27 c 8.1,12.04 -2.66,28.23 -16.2,28.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4432",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3882.95,1554.81 -1.07,0.51 c -7.03,3.4 -15.19,1.88 -19.45,-5.1 -2.48,-4.05 -3.22,-7.88 -3.82,-12.51 -1.34,-10.49 14.47,-16.44 21.04,-8.71 l 1.17,1.24 1.06,0.53 c 4.49,2.12 6.94,7.58 7.04,12.27 l 0.03,1.3 c 0.09,3.98 -2.31,8.68 -6,10.47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4434",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3960.09,1500.09 c -3.18,11.55 -19.04,17.15 -28.02,8.51 -4.53,-2.21 -7.91,-6.1 -8.54,-11.35 -0.76,-6.43 2.14,-10.98 7.09,-14.78 2.29,-1.77 5.25,-3.33 8.11,-3.73 6.36,-0.91 12.09,-0.35 16.89,4.46 4.38,4.37 6.12,10.92 4.47,16.89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4436",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3962.86,1566.98 c -19.46,0 -19.49,-30.26 0,-30.26 19.46,0 19.5,30.26 0,30.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4438",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3909.36,1669.13 c -2.88,10.45 -10.48,16.4 -20.15,20.14 -0.9,0.35 -1.81,0.71 -2.72,1.06 -18.74,7.25 -41.07,-15.08 -33.82,-33.82 0.36,-0.91 0.71,-1.82 1.06,-2.72 3.74,-9.66 9.69,-17.27 20.15,-20.15 9.92,-2.74 20.79,0.14 28.06,7.42 7.28,7.27 10.16,18.14 7.42,28.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4440",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3676.39,1601.27 c -6.94,7.8 -21.15,7.6 -28.12,0 -6.93,-7.55 -8.3,-20.74 0,-28.12 6.87,-6.1 13.37,-13.18 23.34,-12.85 9.77,0.32 17.3,7.82 17.64,17.62 0.33,10.02 -6.73,16.46 -12.86,23.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4442",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3722.44,1693.07 c -27.03,0 -27.08,-42.01 0,-42.01 27.03,0 27.07,42.01 0,42.01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4444",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3769.33,1625.13 c -1.81,11.93 -17.41,19.55 -28.25,16.05 -12.99,-4.2 -17.98,-15.48 -16.04,-28.26 -0.33,3.58 -0.57,4.14 -0.71,1.67 -1.31,-11.98 11.51,-23.47 22.97,-22.96 13.57,0.6 21.56,10.12 22.96,22.96 0.39,3.56 -0.39,7.03 -0.93,10.54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4446",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3616.37,1546.99 c -25.59,0 -25.64,-39.77 0,-39.77 25.59,0 25.63,39.77 0,39.77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4448",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3612.12,1480.39 c -9.56,5.05 -21.1,2.31 -26.83,-7.04 -2.8,-4.58 -5.68,-10.39 -5.44,-15.9 0.25,-5.36 2.05,-10.1 4.4,-14.85 5.42,-10.98 23.13,-10.66 28.65,0 l 1.23,2.16 c 0.52,0.67 1.2,1.57 2.16,2.81 0.82,1.9 1.31,3.04 1.64,3.83 l 1.22,2.17 c 5.37,8.75 2.2,21.94 -7.03,26.82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4450",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3595.15,1419.88 c -10.67,0 -18.77,-10.55 -15.93,-20.92 0.45,-1.64 0.9,-3.29 1.34,-4.93 3.95,-14.39 25.23,-14.41 29.17,0 0.45,1.64 0.9,3.29 1.35,4.93 2.84,10.37 -5.22,20.92 -15.93,20.92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4452",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3555.93,1372.53 -8.49,1.27 c -8.44,1.25 -16.91,-3.49 -16.91,-12.88 0,-9.29 8.47,-14.13 16.91,-12.87 l 8.49,1.26 c 11.49,1.71 11.5,21.51 0,23.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4454",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3485.55,1329.42 c -14.06,0 -14.09,-21.85 0,-21.85 14.06,0 14.08,21.85 0,21.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4456",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3522.09,1431.47 c -1.55,3.53 -5.64,7.16 -9.86,6.63 -1.54,-0.2 -3.07,-0.48 -4.6,-0.71 -4.25,0.31 -8.07,-1.13 -11.9,-3.54 -7.51,-4.72 -9.69,-14.65 -4.16,-21.81 5.03,-6.52 16.3,-8.36 22.15,-1.51 2.4,2.81 4.29,5.27 5.45,8.21 l 0.69,0.95 c 2.8,3.41 4.1,7.52 2.23,11.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4458",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3573.93,1497.66 c -21.26,0 -21.29,-33.05 0,-33.05 21.27,0 21.31,33.05 0,33.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4460",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3524.44,1535.99 c -8.35,0 -16.36,-7.33 -15.96,-15.96 0.39,-8.65 7.01,-15.96 15.96,-15.96 8.35,0 16.35,7.34 15.96,15.96 -0.38,8.65 -7.01,15.96 -15.96,15.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4462",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3595.29,1609.13 c -4.84,3.11 -10.96,3.38 -16.4,2.14 -7.8,-1.77 -12.07,-8 -14.87,-14.87 -3.24,-7.91 1.46,-17.61 7.63,-22.37 9.99,-7.72 24.83,-5.03 31.28,5.97 5.97,10.22 2.04,22.88 -7.64,29.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4464",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3543.61,1602.99 c -1.06,7.89 -8.05,11.39 -15.38,10.25 -8.92,-1.4 -16.98,-3.7 -20.59,-12.75 -1.56,-3.92 1.01,-9.48 4.63,-11.38 6.88,-3.6 12.2,-0.85 19.24,-0.08 7.33,0.8 13.18,6 12.1,13.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4466",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3494.44,1645.55 c -0.92,0.28 -1.21,0.35 -1.3,0.35 l -1.15,0.49 c -1.55,0.9 -3.22,1.35 -5.02,1.36 l -0.51,0.07 c -7.54,1.18 -14.43,-0.26 -19.35,-6.62 -4.64,-6.01 -4.98,-13.85 -1.45,-20.52 3.01,-5.67 7.46,-9.46 13.24,-11.99 11.01,-4.81 23.5,-2.46 28.61,9.64 4.78,11.34 -1.51,23.56 -13.07,27.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4468",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3486.46,1647.82 0.07,-0.01 c -2.88,0.39 -2.82,0.38 -0.07,0.01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4470",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3513.99,1671.4 c -3.37,6.91 -9.33,10.66 -17.06,12.79 -5.58,1.55 -11.71,-0.08 -15.8,-4.18 -4.44,-4.44 -5.12,-9.89 -4.18,-15.8 1.37,-8.59 8.47,-14.22 16.49,-16.41 9.65,-2.63 18.56,3.29 21.7,12.33 l 0.08,-0.09 c 2.37,3.46 1.42,8.27 -1.23,11.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4472",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3560.36,1709.88 -0.75,0.48 c -3.94,2.52 -9.83,2.52 -13.77,0 l -0.75,-0.48 c -12.39,-7.93 -7.75,-28.19 7.63,-28.19 15.38,0 20.06,20.23 7.64,28.19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4474",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3559.79,1744.18 c -1.79,0 -1.8,-2.8 0,-2.8 1.81,0 1.81,2.8 0,2.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4476",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3446.66,1729.15 v -1.02 1.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4478",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3474.32,1309.9 c -5.2,8.05 -13.82,11.21 -23.12,9.4 -6.19,-1.2 -12.28,-5.55 -16.46,-10.11 -8.82,-9.62 -8.41,-24.39 2.21,-32.59 9.86,-7.62 25.96,-5.58 32.1,6.12 l 0.3,0.66 1.77,1.7 c 6.14,6.24 8.12,17.2 3.2,24.82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4480",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3556.54,1273.55 c -10.11,7.81 -29.15,6.61 -34.98,-6.68 -2.92,-6.65 -4.44,-10.97 -4.81,-18.29 -1.11,-22.01 30.56,-29.94 41.19,-11.5 l 1.01,0.94 c 10.96,9.31 7.97,27.51 -2.41,35.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4482",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3582.25,1247.61 c -3.44,4.09 -6.89,8.19 -10.35,12.29 -7.48,8.87 -23.67,8.29 -31.29,0 -7.54,-8.22 -9.45,-23.33 0,-31.3 4.1,-3.45 8.19,-6.9 12.29,-10.34 8.29,-7 21.33,-8.74 29.35,0 8.15,8.86 7.49,20.47 0,29.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4484",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3596.94,1257.96 c -0.89,1.84 -1.78,3.69 -2.66,5.52 -0.97,2.01 -4.35,2.01 -5.33,0 -0.88,-1.83 -1.76,-3.68 -2.65,-5.52 -1.99,-4.11 0.37,-9.26 5.32,-9.26 4.95,0 7.29,5.15 5.32,9.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4486",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3383.01,1386.03 c -11.28,0 -22.08,-9.92 -21.57,-21.57 0.53,-11.68 9.48,-21.56 21.57,-21.56 11.29,0 22.09,9.92 21.57,21.56 -0.53,11.69 -9.47,21.57 -21.57,21.57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4488",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3332.87,1335.53 c -8.62,7.91 -24.13,10 -33.02,0.97 -9,-2.35 -16.36,-12.6 -15.95,-21.77 0.45,-9.95 6.76,-19.47 16.78,-22.03 12.34,-3.15 22.84,0.67 32.19,8.77 9.55,8.28 9.11,25.68 0,34.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4490",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3256.77,1379.26 -1.68,-0.31 c -9.19,-1.74 -16.83,-12.39 -16.42,-21.56 0.42,-9.29 6.56,-19.7 16.42,-21.56 l 1.68,-0.32 c 14.31,-2.7 28.72,6.35 28.72,21.88 0,15.43 -14.4,24.59 -28.72,21.87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4492",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3188.55,1368.98 c -3.02,0 -6.34,0.08 -9.27,-0.73 -3.44,-0.95 -5.85,-3.27 -8.58,-5.38 -5,-3.88 -4.97,-14.17 0,-18.02 2.73,-2.12 5.14,-4.45 8.58,-5.39 2.93,-0.8 6.25,-0.73 9.27,-0.73 8.17,0 15.12,6.95 15.12,15.12 0,8.21 -6.92,15.13 -15.12,15.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4494",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3198.02,1370.05 c -10.99,6.44 -23.4,0 -27.56,-11.21 -0.75,-2 -1.53,-3.99 -2.33,-5.97 l -0.24,-0.58 c -0.57,-1.28 -1.13,-2.56 -1.72,-3.83 -2.84,-6.15 -5.37,-11.41 -3.85,-18.37 1.2,-5.48 7.29,-10.06 12.88,-9.8 11.64,0.51 19.73,11.97 26.61,20.29 7.62,9.2 7.28,23 -3.79,29.47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4496",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3294.62,1478.41 c -11.05,0 -22.37,-12.03 -17.82,-23.4 l 0.63,-1.6 c 2.84,-7.12 8.81,-13.45 17.19,-13.08 8.48,0.38 14.14,5.45 17.19,13.08 l 0.63,1.6 c 4.55,11.4 -6.82,23.4 -17.82,23.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4498",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3340.58,1440.42 c -15.85,0 -15.88,-24.64 0,-24.64 15.86,0 15.89,24.64 0,24.64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4500",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3386.56,1481.39 -2.84,-0.59 c -7.98,-1.69 -10.1,-12.4 -4.7,-17.8 5.4,-5.4 16.11,-3.28 17.79,4.7 l 0.6,2.84 c 1.44,6.78 -4.08,12.29 -10.85,10.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4502",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3400.61,1560.7 c -5.44,2.29 -10.98,2.12 -16.18,-0.83 -3.12,-1.77 -4.96,-4.54 -5.88,-7.65 -0.28,-0.68 -0.6,-1.49 -1,-2.6 -0.23,-1.11 -0.19,-1.3 0.07,-0.74 -4.1,-10 0.11,-21.85 11.24,-24.92 11.38,-3.14 22.31,5.69 22.68,17.28 0.27,8.19 -3.01,16.12 -10.93,19.46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4504",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3227.32,1478.74 -0.8,1.28 c -6.15,9.9 -20.29,9.9 -26.44,0 l -0.8,-1.28 c -6.57,-10.56 1.96,-24.45 14.02,-24.45 12.06,0 20.59,13.89 14.02,24.45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4506",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3167.33,1537.82 c -4.69,0 -4.69,-7.29 0,-7.29 4.69,0 4.7,7.29 0,7.29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4508",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3241.58,1522.24 c -15.14,0 -24.7,-16.87 -17.17,-29.92 1.96,-3.39 3.76,-6.61 6.47,-9.51 5.43,-5.84 15.98,-5.84 21.41,0 2.68,2.86 4.52,6.14 6.47,9.51 7.52,13.05 -2.03,29.92 -17.18,29.92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4510",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3038.04,1365.48 c -3.12,7.37 -10.87,13.28 -19.2,12.91 -7.33,-0.32 -14.36,-3.94 -18.14,-10.4 -5.01,-8.56 -2.85,-18.31 3.28,-25.46 l 0.82,-0.94 c 6.62,-7.72 21.47,-7.7 28.07,0 l 0.82,0.94 c 5.61,6.54 7.78,14.8 4.35,22.95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4512",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3022.2,1274.1 c -1.08,0.42 -2.18,0.68 -3.32,0.79 -8.49,1.41 -17.03,-3.63 -17.03,-12.96 0,-9.27 8.53,-14.38 17.03,-12.97 1.14,0.12 2.24,0.38 3.32,0.79 11.98,3.74 11.99,20.61 0,24.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4514",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3080.45,1289.76 c -4.88,6.32 -13.74,5.18 -18.01,-1.1 -1.67,-2.46 -2.57,-5.04 -2.72,-8.02 -0.18,-3.32 1.97,-6.95 4.88,-8.52 2.62,-1.4 5.51,-1.96 8.37,-0.96 1.66,0.57 2.91,1.45 3.91,2.49 5.64,3.3 7.99,10.38 3.57,16.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4516",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3089.16,1210.12 -0.42,1.65 c -4.21,16.66 -29.52,16.67 -33.73,0 l -0.42,-1.65 c -2.85,-11.27 5.51,-22.69 17.28,-22.69 11.72,0 20.13,11.42 17.29,22.69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4518",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3063.15,1143.35 c -9.03,-9.03 0.27,-23.09 11.99,-20.59 l 2.43,0.52 c 2.59,0.55 5.11,3.06 5.67,5.67 l 0.52,2.41 c 2.49,11.7 -11.57,21.03 -20.61,11.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4520",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3139.05,1242.64 c -25.23,0 -25.27,-39.21 0,-39.21 25.23,0 25.27,39.21 0,39.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4522",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3163.8,1166.57 c -4.69,0 -4.69,-7.29 0,-7.29 4.68,0 4.69,7.29 0,7.29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4524",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3190.66,1152.1 c -4.26,6.36 -7.96,13.06 -11.14,20.01 -3.98,8.69 -17.21,11.5 -24.91,6.54 -8.83,-5.7 -10.96,-15.72 -6.54,-24.91 6.83,-14.16 20.45,-42.07 40.05,-31 5.35,3.02 8.15,9.21 8.15,15.16 0,5.89 -2.53,9.6 -5.61,14.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4526",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3230.98,1216.48 v -1.03 1.03"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4528",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3296.55,1188.8 c -1.09,2.42 -2.2,4.82 -3.29,7.22 -1.33,2.9 -5.93,0.35 -4.36,-2.55 l 3.78,-6.92 c 1.41,-2.58 5.05,-0.31 3.87,2.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4530",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3005.18,1213.01 c -2.94,6.98 -10.28,12.58 -18.17,12.23 -15.25,-0.68 -23.9,-16.59 -17.37,-29.18 2.55,-8.51 13.53,-12.81 21.44,-10.78 3.65,0.94 7.49,3.15 9.99,6.01 5.37,6.12 7.35,14.07 4.11,21.72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4532",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2923.37,1283.56 c -18.74,0 -18.77,-29.12 0,-29.12 18.75,0 18.78,29.12 0,29.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4534",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2890.95,1230.04 -1.38,0.68 c -11.39,5.55 -25.71,-1.08 -25.71,-14.76 0,-13.68 14.32,-20.31 25.71,-14.75 l 1.38,0.67 c 10.64,5.2 10.64,22.96 0,28.16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4536",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2901.56,1177.07 c 0.31,-5.27 0.66,-9.74 4.67,-13.61 3.64,-3.5 9.41,-3.52 13.08,0 4.01,3.87 4.35,8.34 4.66,13.61 0.85,14.42 -23.26,14.44 -22.41,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4538",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2830.89,1298.71 c -2.15,-1.07 -4.11,-2.82 -5.92,-4.38 -12.15,-10.45 -5.31,-31.56 9.32,-35.29 -1.14,0.49 -2.27,0.97 -3.4,1.46 14.61,-7.92 33.29,1.92 33.29,19.1 0,17.6 -18.58,26.48 -33.29,19.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4540",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2761.94,1119.9 c -2.48,5.9 -8.69,10.63 -15.35,10.33 -14.74,-0.66 -21.87,-17.72 -11.88,-28.68 l 0.84,-0.93 c 5.49,-6.04 16.59,-6.03 22.08,0 l 0.85,0.93 c 4.6,5.06 6.16,11.97 3.46,18.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4542",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2740.12,1062.55 c -4.18,1.73 -7,-0.63 -8.46,-4.5 -2.77,-7.34 11.55,-7.04 8.64,0 l -0.1,0.25 c 2.04,0.86 1.94,3.41 -0.08,4.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4544",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2790.37,1113.8 c -0.22,1.34 -2.49,1.34 -2.71,0 l -2.15,-13.55 c -0.94,-5.87 7.96,-5.91 7.02,0 -0.72,4.52 -1.45,9.03 -2.16,13.55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4546",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2822.72,1131.55 c -11.74,15.19 -30.39,1.71 -39.3,-8.99 -6.85,-8.19 -7.24,-19.75 1.8,-26.74 8.84,-6.83 20.33,-3.86 26.34,5.02 l 1.86,2.58 1.25,1.36 1.38,1.25 1.17,0.69 c 8.5,5.63 12.18,16.18 5.5,24.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4548",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2834.98,1056.79 c -9.01,0 -9.02,-14 0,-14 9.01,0 9.02,14 0,14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4550",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2753.66,1000.04 c -13.34,0 -13.36,-20.731 0,-20.731 13.33,0 13.36,20.731 0,20.731"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4552",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2769.05,1001.56 c -8.63,11.18 -24.83,9.49 -32.32,-1.99 -2.2,-3.371 -4.19,-6.41 -5.61,-9.808 -1.05,-2.071 -1.81,-4.293 -1.78,-6.621 v -0.039 -0.012 l 0.01,0.012 c 0.21,-10.86 10.68,-17.461 20.78,-15.141 2.96,0.687 5.85,1.859 8.75,2.82 13.01,4.278 18.84,19.571 10.17,30.779"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4554",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2887.85,1037.41 c -1.18,9.05 -7.21,17.98 -17.51,17.52 -10.51,-0.48 -16.24,-7.75 -17.52,-17.52 -0.22,-1.77 -0.46,-3.54 -0.69,-5.31 -1.23,-9.48 9.26,-18.6 18.21,-18.2 8.8,0.39 19.52,8.1 18.2,18.2 -0.23,1.77 -0.46,3.54 -0.69,5.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4556",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2910.68,1110.97 c -1.6,0.61 -3.2,1.21 -4.8,1.82 -8.66,3.28 -17.73,-5.05 -17.73,-13.51 0,-8.47 9.08,-16.78 17.73,-13.49 1.6,0.6 3.2,1.21 4.8,1.81 11.46,4.34 11.48,19.03 0,23.37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4558",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2948.12,1039.95 c -10.09,0 -10.1,-15.69 0,-15.69 10.09,0 10.11,15.69 0,15.69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4560",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2923.37,994.441 c -6.13,0 -6.14,-9.519 0,-9.519 6.13,0 6.14,9.519 0,9.519"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4562",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2961.94,924.359 c -0.64,2.582 -1.36,4.973 -2.44,7.411 -5,11.3 -22.97,-2.329 -13.18,-10.161 1.47,-1.187 2.67,-2.66 3.92,-4.058 4.83,-5.41 13.34,0.351 11.7,6.808"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4564",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2891.55,899.641 c -11.53,0 -11.55,-17.93 0,-17.93 11.53,0 11.55,17.93 0,17.93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4566",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2831.81,899.16 c -4.95,9.762 -19.09,10.699 -26.39,3.399 -7.31,-7.297 -6.35,-21.438 3.4,-26.387 7.19,-3.66 15.99,-6.102 22.54,0.457 6.55,6.543 4.11,15.34 0.45,22.531"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4568",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2875.93,869.648 c -2.29,-1.199 -4.57,-2.398 -6.86,-3.589 -9.51,-4.989 -10.59,-18.707 -3.35,-25.957 7.26,-7.25 20.97,-6.161 25.96,3.339 1.2,2.301 2.4,4.579 3.59,6.868 6.64,12.652 -6.67,25.992 -19.34,19.339"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4570",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3053.07,1014.57 c -0.19,1.45 -0.39,2.91 -0.58,4.35 -0.56,4.54 -3.18,9.37 -7.32,11.32 -11.9,5.63 -22.38,1.29 -29.61,-9.17 -7.5,-10.87 0.23,-26.371 12.06,-29.621 12,-3.308 26.38,6.223 25.52,19.441 -0.08,1.24 0.01,2.44 -0.07,3.68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4572",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3093.89,1007.36 c -0.96,7.51 -4.01,13.79 -11.36,16.89 -6.55,2.77 -15.19,1.63 -20.2,-3.83 -4.4,-4.8 -6.51,-11.56 -4.74,-17.97 2.38,-8.68 9.59,-12.52 17.82,-13.579 1.18,-0.152 2.35,-0.301 3.53,-0.461 7.57,-0.961 16.37,7.891 15.4,15.41 -0.14,1.18 -0.3,2.36 -0.45,3.54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4574",
    style: {
      fill: "#fbc2b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3153.19,1005.75 c -10.25,0 -20.08,-9.02 -19.61,-19.602 0.48,-10.628 8.63,-19.609 19.61,-19.609 10.26,0 20.08,9.012 19.61,19.609 -0.48,10.614 -8.61,19.602 -19.61,19.602"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4576",
    style: {
      fill: "#f89b87",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3344,1133.43 c -0.5,3.73 -1.5,7.23 -2.49,10.85 -2.54,9.37 -12.17,17.31 -22.14,16.87 -10.1,-0.46 -19.41,-6.81 -22.14,-16.87 -0.99,-3.61 -2,-7.13 -2.5,-10.85 -0.97,-7.25 0.35,-13.05 3.58,-19.69 7.78,-15.92 34.33,-15.92 42.12,0 3.22,6.62 4.56,12.39 3.57,19.69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4578",
    style: {
      fill: "#f89b87",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3407.31,1133.51 -1.7,2.54 c -4.19,6.31 -12.73,6.31 -16.92,0 l -1.69,-2.54 c -5.03,-7.57 1.63,-17.7 10.16,-17.7 8.52,0 15.18,10.13 10.15,17.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4580",
    style: {
      fill: "#f89b87",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3462.22,1175.15 c -3.74,6.07 -8.58,10.31 -15.79,11.51 -6.2,1.04 -12.16,0.7 -18.24,-1 -7.81,-2.18 -12.7,-9.89 -11.63,-17.82 0.98,-7.33 7.89,-14.89 15.95,-14.09 1.34,0.14 2.63,0.16 3.96,0.14 l 1.6,-0.38 c 3.62,-1.19 7.09,-1.35 10.83,-1.56 11.67,-0.68 19.23,13.6 13.32,23.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4582",
    style: {
      fill: "#f89b87",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3506.97,1108.49 c -0.65,7.67 -9.43,15.26 -17.03,9.78 l -1.17,-0.98 -0.48,-0.14 -0.39,-0.13 c -3.83,-0.48 -7.26,-1.36 -10.69,-3.47 -6.02,-3.69 -9.87,-11.64 -7.6,-18.66 2.09,-6.45 8.59,-12.87 15.94,-12.13 8.06,0.81 14.62,3.53 18.43,11.2 2.25,4.52 3.42,9.48 2.99,14.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4584",
    style: {
      fill: "#f89b87",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3570.51,1193.74 c -6.95,7.05 -17.53,8.9 -26.13,2.26 -8.87,-6.85 -10.72,-21.21 -1.98,-29.26 5.87,-5.41 11.61,-7.59 19.52,-8.43 9.29,-0.98 17.39,7.93 18.52,16.34 1.1,8.22 -3.05,15.31 -9.93,19.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4586",
    style: {
      fill: "#f89b87",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3618.96,1167.12 c -2.12,7.44 -7.39,12.54 -13.77,16.52 -8.43,5.24 -19.79,2.46 -25.65,-5.13 -5.48,-7.08 -6.23,-19.96 1.55,-26.11 1.93,-1.53 3.47,-3.4 5.34,-4.99 2.63,-2.24 5.35,-3.97 8.66,-5.04 l 1.89,-0.26 0.71,-0.22 c 5.1,-1.46 12,-0.12 15.54,4.11 5.17,6.15 8.08,12.85 5.73,21.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4588",
    style: {
      fill: "#f89b87",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3652.62,1130.82 c -1.14,0.17 -2.26,0.35 -3.39,0.53 -6.32,1.01 -6.36,-8.57 0,-7.56 1.13,0.18 2.25,0.36 3.39,0.54 3.21,0.51 3.21,5.97 0,6.49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4590",
    style: {
      fill: "#f89b87",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3658.8,1232.7 c -12.45,0 -24.39,-10.96 -23.81,-23.81 0.57,-12.9 10.46,-23.81 23.81,-23.81 12.45,0 24.37,10.95 23.81,23.81 -0.59,12.9 -10.47,23.81 -23.81,23.81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4592",
    style: {
      fill: "#f89b87",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3720,1094.87 c -5.59,2.25 -10.68,3.03 -16.69,1.3 -17.84,-5.17 -17.86,-31.03 0,-36.19 5.87,-1.7 11.16,-0.94 16.69,1.29 6.94,2.82 13.15,8.58 12.78,16.8 -0.37,8.32 -5.32,13.78 -12.78,16.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4594",
    style: {
      fill: "#f89b87",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3781.9,1127.76 c -1.28,9.17 -13.53,12.49 -20.56,8.37 -7.71,-4.51 -9.28,-15.64 -2.85,-21.99 1.42,-1.4 2.83,-2.8 4.25,-4.18 3.46,-3.33 8.65,-4.42 13.08,-2.47 3.91,1.71 7.96,6.25 7.35,10.93 -0.4,3.12 -0.83,6.22 -1.27,9.34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4596",
    style: {
      fill: "#f89b87",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3814.19,1079.76 c -3.1,5.29 -8.65,9.57 -14.56,11.2 -8.94,2.46 -16.92,-0.53 -23.71,-6.27 -1.8,-1.51 -3.44,-3.12 -5.02,-4.86 -6.54,-7.2 -9.11,-18.74 -3.54,-27.39 5.16,-8.01 15.91,-13.83 25.53,-10.39 2.23,0.79 4.43,1.42 6.74,1.92 15.53,3.33 22.15,22.83 14.56,35.79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4598",
    style: {
      fill: "#f89b87",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3588.73,1034.99 c -5.74,-6.25 -8.5,-15.07 -6.19,-23.43 2.77,-10.08 12.67,-17.83 23.22,-17.681 1.88,0.023 3.77,0.051 5.65,0.082 10.03,0.148 18.21,8.289 18.35,18.349 0.03,1.88 0.06,3.77 0.08,5.65 0.3,20.37 -26.89,32.52 -41.11,17.03"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4600",
    style: {
      fill: "#f89b87",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3641.11,942.281 c -13.69,-0.621 -21.92,-17.461 -11.48,-27.73 l 1.78,-1.75 c 5.32,-5.242 14.08,-5.25 19.41,0 l 1.79,1.75 c 9.74,9.59 2.75,28.359 -11.5,27.73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4602",
    style: {
      fill: "#f89b87",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3606.22,872.992 -0.76,1.328 c -7.55,13.051 -27.21,13.051 -34.75,0 l -0.77,-1.328 c -7.96,-13.781 2.16,-31.601 18.14,-31.601 15.98,0 26.1,17.82 18.14,31.601"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4604",
    style: {
      fill: "#f89b87",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3733.52,952.969 c 0.3,10.371 -6.84,19.84 -18.15,19.84 -11.52,0 -21.64,-11.887 -17.83,-23.399 2.6,-7.828 7.54,-14.82 15.94,-16.949 9.41,-2.402 21.71,4.828 20.65,15.738 -0.14,1.602 -0.36,3.192 -0.61,4.77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4606",
    style: {
      fill: "#f89b87",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3722.44,969.449 c -19.46,0 -19.5,-30.258 0,-30.258 19.46,0 19.49,30.258 0,30.258"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4608",
    style: {
      fill: "#f89b87",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3543.3,983.02 c -4.76,8.14 -15.48,12.878 -24.67,10.039 -1.48,-0.457 -2.97,-0.911 -4.46,-1.368 -8.51,-2.621 -15.53,-12.402 -12.23,-21.539 0.48,-1.32 0.96,-2.64 1.44,-3.953 3,-8.32 9.16,-14.449 18.15,-15.66 8.28,-1.109 17.7,2.723 21.77,10.43 3.61,6.832 3.98,15.261 0,22.051"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4610",
    style: {
      fill: "#f89b87",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3500.96,1102.67 c -1.68,-0.33 -3.36,-0.65 -5.03,-0.99 -8.56,-1.68 -15.68,-11.49 -15.3,-20.07 0.39,-8.7 6.12,-18.28 15.3,-20.08 1.67,-0.33 3.35,-0.66 5.03,-0.99 13.77,-2.7 27.64,6.18 27.64,21.07 0,14.78 -13.86,23.77 -27.64,21.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4612",
    style: {
      fill: "#f89b87",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3421.9,976.051 v -1.031 1.031"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4614",
    style: {
      fill: "#f89b87",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3410.22,950.039 c -12.19,9.43 -27.29,3.262 -33.09,-9.648 l -0.37,-0.442 c 0.93,2.563 0.27,1.043 -0.23,-0.277 -1.12,-1.133 -2.2,-2.313 -3.05,-3.692 -0.92,-1.57 -1.58,-3.23 -1.96,-4.98 -1.32,-5.449 -0.19,-12.09 4.23,-15.98 9.73,-8.551 21.72,-5.661 32.29,-0.528 13.94,6.75 13.33,26.938 2.18,35.547"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4616",
    style: {
      fill: "#f89b87",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3306.43,1007.39 c -1.72,1.53 -3.74,2.6 -6.05,3.15 -1.24,0.28 -2.59,0.41 -3.94,0.5 l -0.68,0.09 -0.55,0.03 c -5.04,0.45 -9.98,-1.24 -13.24,-5.79 -4.17,-4.58 -5.32,-11.53 -4.23,-17.468 0.54,-2.91 1.85,-5.64 3.24,-8.261 6.66,-12.512 24.6,-12.602 32.79,-2.012 8.25,10.68 3.51,23.971 -7.34,29.761"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4618",
    style: {
      fill: "#f89b87",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3304.72,946.68 c -6.47,12.672 -24.71,12.472 -32.79,2.019 -8.01,-10.367 -3.77,-23.679 6.73,-29.527 3.83,-3.871 8.81,-6 14.64,-5.211 6.21,0.828 13.29,5.738 14.41,12.41 1.27,7.617 0.52,13.438 -2.99,20.309"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4620",
    style: {
      fill: "#f89b87",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3312.58,885.582 c -9.15,5.348 -22.5,-1.391 -21.92,-12.582 0.1,-1.871 0.2,-3.738 0.3,-5.609 0.43,-8.121 9.6,-15.02 17.24,-9.899 1.47,0.977 2.92,1.957 4.38,2.93 8.91,5.988 9.88,19.367 0,25.16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4622",
    style: {
      fill: "#f89b87",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3291.08,862.902 v -1.023 1.023"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4624",
    style: {
      fill: "#f89b87",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3220.37,992.16 c -9.01,0 -15.86,-5.808 -18.6,-13.441 -2.77,-4.66 -3.75,-10.668 -2.23,-15.379 2.56,-7.91 9.82,-14.301 18.5,-14.07 10.2,0.269 19.79,6.949 21.77,17.371 2.43,12.718 -5.65,25.519 -19.44,25.519"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4626",
    style: {
      fill: "#f89b87",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3188.55,923.012 v -1.02 1.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4628",
    style: {
      fill: "#f89b87",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3096.62,919.48 v -1.031 1.031"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4630",
    style: {
      fill: "#f89b87",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3096.62,935.211 c -3.54,0.34 -7.07,0.668 -10.61,1.019 -5.9,0.559 -11.74,-4.671 -13.23,-10.082 -1.63,-5.929 1.11,-12.328 6.31,-15.5 3.11,-1.906 6.22,-3.808 9.34,-5.707 8.98,-5.5 21.12,-0.222 23.85,9.7 2.96,10.761 -5.3,19.578 -15.66,20.57"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoralCover);
export default __webpack_public_path__ + "static/media/coralCover.f62dddcb620a931cb65ac003057403e1.svg";
export { ForwardRef as ReactComponent };